import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { notification } from 'antd';
import SvgIcon from '@material-ui/core/SvgIcon';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Switch from '@material-ui/core/Switch';

import L from 'leaflet';
import 'leaflet-draw';
import { area as turfArea } from '@turf/turf';

import Config from '../../constants/appConfig';
import MaterialIcon from '../../components/MaterialIcon';
import tools from '../../components/util/tools';
import geo from '../../components/util/geo';

import { useParams } from "react-router";
import saveAs from 'file-saver';
import jszip from 'jszip';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';

import Backd from '../../components/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from '@material-ui/core/DialogContentText';
import Checkbox from '@material-ui/core/Checkbox';
import SliderComponent from '@material-ui/core/Slider';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import BarHeat from '../../components/heat_graph/barGraph';
import PlaneHeat from '../../components/heat_graph/planeGraph';
import DeltaTHeat from '../../components/heat_graph/deltaTGraph';

import Units from '../../components/util/units';
//import PlaneAngle from '../../components/custom_compass/planeAngle';

import Tab from '../../components/Tab/local';
import Marks from './../../components/image/img';
import Img_mark from './../../assets/images/aircraft.png';
import Img_up from './../../assets/images/gaugeUp.png';
import Img_down from './../../assets/images/gaugeDown.png';
import Img_fine from './../../assets/images/gaugeOk.png';
import pinWaypoint from './../../assets/images/marker/waypoint/pin.png';
import aircraftReplay3DModel from './../../assets/replay_3d/models/catalog.json';

import uMarker from './../job_stats/update_marker';
import Slider from '../../components/Slider/barSlider';
import './anime.css';

import SPW from "string-pixel-width";

import Accordion from '../../components/Accordion';
import MapItem from './MapItem';
import Replay3D from './replay_3d/Replay3D';

import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Select from '@material-ui/core/Select';

Chart.register(zoomPlugin);

class Edit extends React.Component {
  base = {
    updateValuesAnimation: false,
    id_job: null,
    task: null,//localStorage.getItem('check-task') === 'null' || this.props.guid ? null : localStorage.getItem('check-task'),
    lingua: this.props.res.LINGUA,
    progress: false,
    loading: false,
    progressValue: 0,
    title: '...',
    title_sk: '...',
    data: null,
    state: 0,//0=null;1=task;2=processing;3=open
    tiro: 0,
    play: false,
    end: false,
    polygons: [],
    time: 0,
    area: 0,
    correto: 0,
    fora: 0,
    sobre: 0,
    restante: 0,
    timeS: 0,
    areaS: 0,
    corretoS: 0,
    foraS: 0,
    sobreS: 0,
    restanteS: 0,
    sTime: 1,
    tab: '0',
    tabMenu: '2',
    tabSubMenuV: '0',
    tabSubMenuD: '0',
    openTask: false,
    showChart: false,
    chartIndex: 0,
    fastProgress: false,
    valueBar: 0,
    showProgressBar: true,
    showReplay3D: false,
    autoReplay3DOpening: false,
    climateTimeline: [],
    climatePeriod: null,
    externalClimateLoading: false,

    showForm: false,

    dateIni: '',
    dateFim: '',

    area_talhoes: 0,
    distancia_percorrida: 0,

    polygons_total: 0,
    polygons_aplicados: 0,

    showStack: false,
    listTypes: [
      { type: 'caminho', label: this.props.res.CAMINHO, active: true },
      { type: 'aplicacao', label: this.props.res.APLICACAO, active: true },
      //{ type: 'faltando', label: this.props.res.NAO_APLICADO, active: true },
      { type: 'area', label: this.props.res.AREA, active: true },
      { type: 'name', label: this.props.res.TITULO, active: true }
    ],

    listPerfis: [],
    selectedPerfil: 0,
    nomePerfil: '',
    larguraExd: 100,

    atual_altura: 0,
    count_altura: 0,
    media_altura: 0,
    media_alturaS: 0,
    corretoAltS: 0,
    corretoAlt: 0,
    aceitavelAltSupS: 0,
    aceitavelAltSup: 0,
    aceitavelAltInfS: 0,
    aceitavelAltInf: 0,
    incorretaAltInfS: 0,
    incorretaAltInf: 0,
    incorretaAltSupS: 0,
    incorretaAltSup: 0,

    alturaMargemDown: { value: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 1 : 1, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), text: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 6 : 3, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), valid: true },
    alturaMargemUp: { value: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 1 : 1, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), text: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 8 : 5, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), valid: true },
    alturaLimiteDown: { value: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 1 : 1, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), text: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 5 : 2, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), valid: true },
    alturaLimiteUp: { value: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 1 : 1, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), text: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 9 : 6, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), valid: true },
    alturaSet: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 7 : 4, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)),

    count_fluxo: 0,
    media_fluxo: 0,
    media_fluxoS: 0,
    corretoFlxS: 0,
    corretoFlx: 0,
    aceitavelFlxSupS: 0,
    aceitavelFlxSup: 0,
    aceitavelFlxInfS: 0,
    aceitavelFlxInf: 0,
    incorretaFlxInfS: 0,
    incorretaFlxInf: 0,
    incorretaFlxSupS: 0,
    incorretaFlxSup: 0,

    fluxoMargemDown: { value: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? .5 : 2, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), text: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? 1.5 : 8, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), valid: true },
    fluxoMargemUp: { value: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? .5 : 2, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), text: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? 2.5 : 12, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), valid: true },
    fluxoLimiteDown: { value: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? .5 : 3, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), text: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? 1 : 5, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), valid: true },
    fluxoLimiteUp: { value: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? .5 : 3, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), text: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? 3 : 15, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), valid: true },
    fluxoSet: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? 2 : 10, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)),

    count_velocidade: 0,
    media_velocidade: 0,
    media_velocidadeS: 0,
    corretoVlcS: 0,
    corretoVlc: 0,
    aceitavelVlcSupS: 0,
    aceitavelVlcSup: 0,
    aceitavelVlcInfS: 0,
    aceitavelVlcInf: 0,
    incorretaVlcInfS: 0,
    incorretaVlcInf: 0,
    incorretaVlcSupS: 0,
    incorretaVlcSup: 0,

    velocidadeMargemDown: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 10 : 10, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 100 : 170, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeMargemUp: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 10 : 10, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 120 : 190, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeLimiteDown: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 20 : 20, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 80 : 150, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeLimiteUp: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 20 : 20, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 140 : 210, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeSet: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 110 : 180, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)),

    count_velocidade_vento: 0,
    media_velocidade_vento: 0,
    media_velocidade_ventoS: 0,
    corretoVlcVS: 0,
    corretoVlcV: 0,
    aceitavelVlcVSupS: 0,
    aceitavelVlcVInf: 0,
    incorretaVlcVInfS: 0,
    aceitavelVlcVSup: 0,
    aceitavelVlcVInfS: 0,
    incorretaVlcVInf: 0,
    incorretaVlcVSupS: 0,
    incorretaVlcVSup: 0,

    velocidadeVMargemDown: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 4 : 8, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 2 : 2, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeVMargemUp: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 4 : 8, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 10 : 18, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeVLimiteDown: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 2 : 2, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 0 : 0, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeVLimiteUp: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 10 : 12, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 30 : 30, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeVSet: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 6 : 10, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)),

    count_angulo_vento: 0,
    media_angulo_vento: 0,
    media_angulo_ventoS: 0,
    corretoAngVS: 0,
    corretoAngV: 0,
    aceitavelAngVSupS: 0,
    aceitavelAngVSup: 0,
    aceitavelAngVInfS: 0,
    aceitavelAngVInf: 0,
    incorretaAngVInfS: 0,
    incorretaAngVInf: 0,
    incorretaAngVSupS: 0,
    incorretaAngVSup: 0,

    atual_angulo_vento: -1,
    media_angulo_up: -1,
    media_angulo_down: -1,

    angulo_plane: 0,
    angulo_wind: 0,

    espelharAnguloV: true,
    anguloVMargemDown: { value: 50, text: 50, valid: true },
    anguloVMargemUp: { value: 50, text: 50, valid: true },
    anguloVLimiteDown: { value: 20, text: 70, valid: true },
    anguloVLimiteUp: { value: 20, text: 70, valid: true },
    anguloVSet: 0,

    count_temperatura: 0,
    media_temperatura: 0,
    media_temperaturaS: 0,
    corretoTempVS: 0,
    corretoTemp: 0,
    aceitavelTempSupS: 0,
    aceitavelTempSup: 0,
    aceitavelTempInfS: 0,
    aceitavelTempInf: 0,
    incorretaTempInfS: 0,
    incorretaTempInf: 0,
    incorretaTempSupS: 0,
    incorretaTempSup: 0,

    temperaturaMargemDown: this.props.res.LINGUA === 'en-US' ? { value: 31.5, text: 41, valid: true } : { value: 17.5, text: 5, valid: true },
    temperaturaMargemUp: this.props.res.LINGUA === 'en-US' ? { value: 31.5, text: 104, valid: true } : { value: 17.5, text: 40, valid: true },
    temperaturaLimiteDown: this.props.res.LINGUA === 'en-US' ? { value: 9, text: 32, valid: true } : { value: 5, text: 0, valid: true },
    temperaturaLimiteUp: this.props.res.LINGUA === 'en-US' ? { value: 18, text: 122, valid: true } : { value: 10, text: 50, valid: true },
    temperaturaSet: this.props.res.LINGUA === 'en-US' ? 72.5 : 22.5,

    count_Umidade: 0,
    media_Umidade: 0,
    media_UmidadeS: 0,
    corretoUmiVS: 0,
    corretoUmi: 0,
    aceitavelUmiSupS: 0,
    aceitavelUmiSup: 0,
    aceitavelUmiInfS: 0,
    aceitavelUmiInf: 0,
    incorretaUmiInfS: 0,
    incorretaUmiInf: 0,
    incorretaUmiSupS: 0,
    incorretaUmiSup: 0,

    umidadeMargemDown: { value: 37.5, text: 15, valid: true },
    umidadeMargemUp: { value: 37.5, text: 90, valid: true },
    umidadeLimiteDown: { value: 5, text: 10, valid: true },
    umidadeLimiteUp: { value: 10, text: 100, valid: true },
    umidadeSet: 52.5,

    count_DeltaT: 0,
    media_DeltaT: 0,
    media_DeltaTS: 0,
    corretoDeltaTVS: 0,
    corretoDeltaT: 0,
    aceitavelDeltaTSupS: 0,
    aceitavelDeltaTSup: 0,
    aceitavelDeltaTInfS: 0,
    aceitavelDeltaTInf: 0,
    incorretaDeltaTInfS: 0,
    incorretaDeltaTInf: 0,
    incorretaDeltaTSupS: 0,
    incorretaDeltaTSup: 0,

    larguraSet: 20,
    larguraDefault: 0,
    alturaDefault: 0,
    fluxoDefault: 0,
    velocidadeDefault: 0,

    cultura: '',
    nome: '',
    cliente: '',
    clients: [],
    piloto: '',
    pilots: [],
    aeronave: '',
    planes: [],
    selectedPlaneId: null,
    selectedPlaneAircraftBrand: '',
    selectedPlaneIdAircraftBrand: null,
    gCultura: '',
    gNome: '',
    gCliente: '',
    gPiloto: '',
    gAeronave: '',
    gAcerto: 0,
    gFalha: 0,
    gPerda: 0,
    gUniformidade: 0,

    gfluxo: 0,
    gAltura: 0,
    gVelocidade: 0,
    gVelocidadeV: 0,
    gDirecaoV: 0,
    gDeltaT: 0,
    gTemperatura: 0,
    gHumidade: 0,

    tabMenuItens: [
      { label: this.props.res.INFORMACAO, value: '0', active: false },
      { label: this.props.res.ANIMACAO, value: '1', active: false },
      { label: this.props.res.CONFIGURACAO, value: '2', active: true },
    ],
    tabItens: [
      { label: this.props.res.APLICACAO, value: '0', active: true },
      { label: this.props.res.ALTURA, type: 'altura', value: '1', active: false },
      { label: this.props.res.FLUXO, type: 'fluxo', value: '2', active: false },
      { label: this.props.res.VELOCIDADE_TAB, type: 'velocidade', value: '3', active: false },
      { label: this.props.res.VENTO, type: 'vento', value: '4', active: false },
      { label: this.props.res.DELTA_T, type: 'delta', value: '5', active: false },
    ],
    tabItensVento: [
      { label: this.props.res.VELOCIDADE, type: 'velocidadeVento', value: '0', active: true },
      { label: this.props.res.DIRECAO, type: 'direcaoVento', value: '1', active: true },
    ],
    tabItensDeltaT: [
      { label: this.props.res.DELTA_T, type: 'deltaT', value: '0', active: true },
      { label: this.props.res.TEMPERATURA_, type: 'temperatura', value: '1', active: true },
      { label: this.props.res.UMIDADE_, type: 'humidade', value: '2', active: true },
    ],

    fonstes: [],
    fonteClima: 0,
    tipoFonte: 'EXTERNO',

    legend: {
      area: {
        data1: 0,
        data2: 0,
        data3: 0,
      },
      aplicacao: {
        data1: 0,
        data2: 0,
        data3: 0,
      },
      altura: {
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
      },
      fluxo: {
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
      },
      velocidade: {
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
      },
      velocidadeVento: {
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
      },
      direcaoVento: {
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
        data6: 0,
        data7: 0,
        data8: 0,
        data9: 0,
        data10: 0,
      },
      temperatura: {
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
      },
      humidade: {
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
      },
      deltaT: {
        data1: 0,
        data2: 0,
        data3: 0,
        data4: 0,
        data5: 0,
      }
    },
    limitWeather: 0,
    limitConsumption: 0,
    showLimit: true,
    checkConfig: [false, false, false, false, false],
    itensTask: [],
    clear: false,
    new: { msg: this.props.res.NOVO_ANALISE_CONFIRM, func: this.clear },

    ruler_a: false,
    showDeltat: false,
    modalOpen: false,
    checkResumo: false,
    checkDetailFluxo: false,
    checkMapa: false,
    checkResumoCobertura: true,
    checkResumoAltura: true,
    checkResumoFluxo: true,
    checkResumoVelocidade: true,
    checkResumoDeltat: true,
    checkResumoTemperatura: true,
    checkResumoUmidade: true,
    checkResumoVelocidadeVento: true,
    checkResumoAnguloVento: true,
    profileLoaded: false,
    //teste: false,
    //teste2: true

    fluxoSetsAplicacaoStatic: [],
    fluxoPorSetStatic: {},

    coordMode: 'dms',
  };

  state = JSON.parse(JSON.stringify(this.base));

  drawCreateToolbar = null;
  ruler_p = { first: { lat: null, lng: null }, second: { lat: null, lng: null } };

  //itens animacao
  featureGroupI = null;//icone
  featureGroupL = null;//linha rota do voo
  featureGroupPoly = null;//polygon da area
  fGAPP = {
    '0': null,//poly da aplicacao
    '1': null,//poly da altura da plicacao
    '2': null,//poly do fluxo da aplicacao
    '3': null,//poly do velocidade da aplicacao
    '4': null,//poly do velocidade do vento da aplicacao
    '5': null,//poly do direcao do vento da aplicacao
    '6': null,//poly do deltaT da aplicacao
    '7': null,//poly do temperatura da aplicacao
    '8': null,//poly do humidade da aplicacao
  }
  //itens static
  featureGroupLS = null;//linha rota do voo
  featureGroupPolyS = null;//polygon da area
  fGAPPS = {
    '0': null,//poly da aplicacao
    '1': null,//poly da altura da plicacao
    '2': null,//poly do fluxo da aplicacao
    '3': null,//poly do velocidade da aplicacao
    '4': null,//poly do velocidade do vento da aplicacao
    '5': null,//poly do direcao do vento da aplicacao
    '6': null,//poly do deltaT da aplicacao
    '7': null,//poly do temperatura da aplicacao
    '8': null,//poly do humidade da aplicacao
  }

  selectedItem = null;

  featureGroupTemp = null;//polygon da area

  featureAtual = {
    caminho: null,
    aplicacao: null,
    area: null,
    //icone: null
  }

  polyNames = {};
  polygonsDefault = [];

  marker = {
    base: null,
    marker: null,
    angle: 45
  };
  marker_heat = null;

  waypointMarker = null;
  waypointIcon = null;
  mapIsDragging = false;

  run = true;
  current_run = 0;
  new_run = 0;
  iPlay = 1;
  line = null;

  isMovingBar = false;
  seekSwap = null;
  seekPreviewLine = null;
  seekPreviewMarker = null;

  altura = [];
  fluxo = [];
  velocidade = [];
  velocidadeVento = [];
  direcaoVento = [];
  deltaT = [];
  temperatura = [];
  humidade = [];

  alturaS = [];
  fluxoS = [];
  velocidadeS = [];
  velocidadeVentoS = [];
  direcaoVentoS = [];
  deltaTS = [];
  temperaturaS = [];
  humidadeS = [];

  pieChart = {
    aplicacao: null,
    area: null,
    altura: null,
    fluxo: null,
    velocidade: null,
    velocidadeVento: null,
    direcaoVento: null,
    deltaT: null,
    temperatura: null,
    humidade: null,
  };

  pieChartData = { info: null, anime: null };
  barChart = null;
  selectedPath = null;

  lineClick = false;

  typeMapItem = 'analise';//[analise, retoque]

  styles = {
    area: {
      color: '#47839e',
      weight: 4,
      opacity: 0.5,
      fillOpacity: 0.1,
    },
    linha: {
      color: '#d0d0d0',
      weight: 1,
      opacity: .9,
      smoothFactor: 1,
      className: 'caminho',
    },
    sobre: {
      color: '#0d1763',
      fillOpacity: .5,
      opacity: 0,
      className: 'aplicacao',
    },
    fora: {
      color: '#ffd500',
      fillOpacity: .9,
      opacity: 0,
      className: 'aplicacao',
    },
    correto: {
      color: '#32a852',
      fillOpacity: .9,
      opacity: 0,
      className: 'aplicacao',
    },
    area_static: {
      color: '#eb8c34',
      opacity: 0,
      fillOpacity: 1,
      className: 'faltando',
    },
    sobre_static: {
      color: '#0d1763',
      light_color: '#467580',
      fillOpacity: .5,
      opacity: 0,
      className: 'aplicacao',
    },
    fora_static: {
      color: '#ffd500',
      fillOpacity: 1,
      opacity: 0,
      className: 'aplicacao',
    },
    correto_static: {
      color: '#32a852',
      light_color: '#26b54d',
      fillOpacity: .9,
      opacity: 0,
      className: 'aplicacao',
    },
    app_add_static: {
      color: '#82d199',
      light_color: '#92ebad',
      fillOpacity: .9,
      opacity: 0,
      className: 'aplicacao',
    },
    stripColor: {
      correto: '#5db445',
      app_add: '#92ebad',
      aceitavelInf: '#f1da0f',
      aceitavelSup: '#6dbfbf',
      incorretaInf: '#e74c3c',
      incorretaSup: '#a536f5'
    }
  };

  acc = {};

  pendingReplay3DQualityResult = null;
  replay3DPlaneFromUrlPromise = null;
  replay3DClimateTimeline = [];
  replay3DClimatePeriod = null;
  replay3DClimateKey = null;
  replay3DClimateRequest = null;
  replay3DClimateRequestKey = null;

  normalizeReplay3DClimateDate = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const numeric = Number(value);
    if (Number.isFinite(numeric) && numeric > 0) {
      return numeric < 100000000000 ? numeric * 1000 : numeric;
    }
    const parsed = new Date(value).getTime();
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  };


  isReplay3DAdmin = () => {
    const profile = this.props && this.props.profile;
    const normalizedProfile = Array.isArray(profile)
      ? profile.map((item) => {
        if (item && typeof item === 'object') {
          return Number(item.id !== undefined ? item.id : (item.value !== undefined ? item.value : item.profile));
        }
        return Number(item);
      }).filter(Number.isFinite)
      : [];
    const isAdmin = normalizedProfile.includes(2);

    return isAdmin;
  };

  getReplay3DExternalClimateCoordinate = (result) => {
    const path = result && Array.isArray(result.path) ? result.path : [];
    const pontos = result && Array.isArray(result.pontos) ? result.pontos : [];
    const resultPolygons = result && Array.isArray(result.polygons) ? result.polygons : [];
    const statePolygons = Array.isArray(this.state.polygons) ? this.state.polygons : [];

    const isValidCoordinate = (lat, lng) => (
      Number.isFinite(lat) &&
      Number.isFinite(lng) &&
      Math.abs(lat) <= 90 &&
      Math.abs(lng) <= 180 &&
      !(lat === 0 && lng === 0)
    );

    const normalizeCoordinate = (value) => {
      if (value === null || value === undefined) return null;

      if (typeof value === 'string') {
        try {
          return normalizeCoordinate(JSON.parse(value));
        } catch (e) {
          return null;
        }
      }

      if (Array.isArray(value)) {
        if (value.length >= 2) {
          const first = Number(value[0]);
          const second = Number(value[1]);
          if (isValidCoordinate(first, second)) return { lat: first, lng: second, format: '[lat,lng]' };
          if (isValidCoordinate(second, first)) return { lat: second, lng: first, format: '[lng,lat]' };
        }
        return null;
      }

      if (typeof value === 'object') {
        const rawLat = value.lat !== undefined ? value.lat : value.latitude;
        const rawLng = value.lng !== undefined ? value.lng : (value.lon !== undefined ? value.lon : value.longitude);
        const lat = Number(rawLat);
        const lng = Number(rawLng);
        if (isValidCoordinate(lat, lng)) return { lat, lng, format: '{lat,lng}' };
      }

      return null;
    };

    const hasValues = (value) => {
      if (Array.isArray(value)) return value.length > 0;
      return value !== null && value !== undefined && value !== '' && value !== false;
    };

    let firstValidPathCoordinate = null;
    let selectedApplicationCoordinate = null;

    for (let i = 0; i < path.length; i++) {
      const rawPathPoint = path[i];
      const coordinate = normalizeCoordinate(rawPathPoint);
      const pointIndexRaw = Array.isArray(rawPathPoint) && rawPathPoint.length > 2 ? rawPathPoint[2] : null;
      const pointIndex = Number(pointIndexRaw);
      const pointData = Number.isInteger(pointIndex) && pointIndex >= 0 && pointIndex < pontos.length
        ? pontos[pointIndex]
        : null;

      const iAppKey = this.p ? this.p.iApp : null;
      const iForaKey = this.p ? this.p.iFora : null;
      const appValue = pointData && iAppKey !== null && iAppKey !== undefined ? pointData[iAppKey] : null;
      const foraValue = pointData && iForaKey !== null && iForaKey !== undefined ? pointData[iForaKey] : null;
      const isApplication = hasValues(appValue) || hasValues(foraValue);

      if (coordinate && !firstValidPathCoordinate) {
        firstValidPathCoordinate = { lat: coordinate.lat, lng: coordinate.lng, source: `result.path[${i}]` };
      }

      if (coordinate && isApplication) {
        selectedApplicationCoordinate = {
          lat: coordinate.lat,
          lng: coordinate.lng,
          source: `result.path[${i}]`,
          pathIndex: i,
          pointIndex: Number.isFinite(pointIndex) ? pointIndex : null
        };
        break;
      }
    }

    if (selectedApplicationCoordinate) {
      return selectedApplicationCoordinate;
    }

    if (firstValidPathCoordinate) {
      return firstValidPathCoordinate;
    }

    const recursiveSources = [
      { name: 'result.polygons', value: resultPolygons },
      { name: 'state.polygons', value: statePolygons },
      { name: 'result.points', value: result && result.points },
      { name: 'result.shapes', value: result && result.shapes }
    ];

    const findNestedCoordinate = (value, currentPath, depth = 0) => {
      if (depth > 15 || value === null || value === undefined) return null;

      const direct = normalizeCoordinate(value);
      if (direct) {
        return { lat: direct.lat, lng: direct.lng, source: currentPath };
      }

      if (typeof value === 'string') {
        try {
          return findNestedCoordinate(JSON.parse(value), `${currentPath}<json>`, depth + 1);
        } catch (e) {
          return null;
        }
      }

      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          const found = findNestedCoordinate(value[i], `${currentPath}[${i}]`, depth + 1);
          if (found) return found;
        }
        return null;
      }

      if (typeof value === 'object') {
        const keys = Object.keys(value);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const found = findNestedCoordinate(value[key], `${currentPath}.${key}`, depth + 1);
          if (found) return found;
        }
      }

      return null;
    };

    for (let i = 0; i < recursiveSources.length; i++) {
      const source = recursiveSources[i];
      const found = findNestedCoordinate(source.value, source.name);
      if (found) {
        return found;
      }
    }
    return null;
  };

  calculateReplay3DExternalClimateDeltaT = (airTemperature, humidity) => {
    const temperature = Number(airTemperature);
    const relativeHumidity = Number(humidity);

    if (!Number.isFinite(temperature) || !Number.isFinite(relativeHumidity)) return null;

    const humidityNormalized = Math.max(0, Math.min(100, relativeHumidity));
    const wetBulb = temperature * Math.atan(0.151977 * Math.sqrt(humidityNormalized + 8.313659))
      + Math.atan(temperature + humidityNormalized)
      - Math.atan(humidityNormalized - 1.676331)
      + 0.00391838 * Math.pow(humidityNormalized, 1.5) * Math.atan(0.023101 * humidityNormalized)
      - 4.686035;

    return Number.isFinite(wetBulb) ? temperature - wetBulb : null;
  };

  buildReplay3DExternalClimateTimeline = (payload, coordinate) => {
    const timeline = [];
    const toNumber = (value) => {
      if (value === null || value === undefined || value === '') return null;
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const addItem = (item) => {
      if (!item) return;

      const datetimeEpoch = toNumber(item.datetimeEpoch);
      const datetime = datetimeEpoch !== null ? datetimeEpoch * 1000 : null;
      const airTemperature = toNumber(item.temp);
      const humidity = toNumber(item.humidity);
      const windSpeedKmh = toNumber(item.windspeed);
      const windDirection = toNumber(item.winddir);
      const pressure = toNumber(item.pressure);
      const rain = toNumber(item.precip);
      const solar = toNumber(item.solarradiation);
      const deltaT = this.calculateReplay3DExternalClimateDeltaT(airTemperature, humidity);

      if (!Number.isFinite(datetime) || datetime <= 0) return;

      timeline.push({
        datetime,
        source_name: this.props.res.CONSULTA_CLIMATICA,
        source_type: 'external_estimate',
        is_external_climate: true,
        lat: coordinate.lat,
        lng: coordinate.lng,
        air_temperature: airTemperature,
        air_humidity: humidity,
        wind_speed: windSpeedKmh !== null ? windSpeedKmh / 3.6 : null,
        wind_direction: windDirection,
        delta_t: Number.isFinite(deltaT) ? deltaT : null,
        pressure,
        rain,
        solar,
        temperature: null
      });
    };

    if (payload && Array.isArray(payload.days)) {
      payload.days.forEach((day) => {
        if (!day || !Array.isArray(day.hours)) return;
        day.hours.forEach(addItem);
      });
    } else if (payload && payload.currentConditions) {
      addItem(payload.currentConditions);
    }

    timeline.sort((a, b) => a.datetime - b.datetime);

    return timeline.filter((item, index, items) => index === 0 || item.datetime !== items[index - 1].datetime);
  };

  loadReplay3DExternalClimate = () => {
    const isAdmin = this.isReplay3DAdmin();
    if (!isAdmin || this.state.externalClimateLoading) {
      return;
    }

    const result = this.state.data;
    const startDate = this.normalizeReplay3DClimateDate(result && result.dateIni);
    const endDate = this.normalizeReplay3DClimateDate(result && result.dateFim);
    const coordinate = this.getReplay3DExternalClimateCoordinate(result);

    if (!startDate || !endDate || endDate < startDate || !coordinate) {
      notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ERRO_MSG,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }

    // LINK API GRATUITA PREVISÃO DO  TEMPO
    // https://www.visualcrossing.com/weather-api/

    const apiToken = '73H4M4NY7DNC7642VTHTWPENQ';
    const oneHour = 60 * 60 * 1000;
    const location = encodeURIComponent(`${coordinate.lat},${coordinate.lng}`);
    const queryStart = Math.floor((startDate - oneHour) / 1000);
    const queryEnd = Math.ceil((endDate + oneHour) / 1000);
    const apiUrl = `https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline/${location}/${queryStart}/${queryEnd}?unitGroup=metric&include=hours&elements=datetime,datetimeEpoch,temp,humidity,windspeed,winddir,pressure,precip,solarradiation&key=${apiToken}&contentType=json`;
    const options = {
      method: 'GET'
    };
    this.setState({ externalClimateLoading: true });

    fetch(apiUrl, options)
      .then((response) => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then((payload) => {
        const timeline = this.buildReplay3DExternalClimateTimeline(payload, coordinate)
          .filter((item) => item.datetime >= startDate - oneHour && item.datetime <= endDate + oneHour);
        if (!timeline.length) {
          throw new Error('NO_CLIMATE_DATA');
        }

        this.replay3DClimateTimeline = timeline;
        this.replay3DClimatePeriod = {
          startDateApplication: startDate,
          endDateApplication: endDate,
          source: 'external_estimate'
        };
        this.replay3DClimateKey = null;
        this.setState({
          climateTimeline: timeline,
          climatePeriod: this.replay3DClimatePeriod,
          externalClimateLoading: false
        });
      })
      .catch((error) => {
        this.setState({ externalClimateLoading: false });
        notification.open({
          message: this.props.res.ERRO,
          description: this.props.res.ERRO_CONSULTA_CLIMA_PERIODO,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      });
  };

  loadReplay3DClimate = (result) => {
    const startDate = this.normalizeReplay3DClimateDate(result && result.dateIni);
    const endDate = this.normalizeReplay3DClimateDate(result && result.dateFim);
    const interval = parseInt(localStorage.getItem('refreshInterval'), 10) || 300000;

    if (!startDate || !endDate || endDate < startDate) {
      this.replay3DClimateTimeline = [];
      this.replay3DClimatePeriod = null;
      this.replay3DClimateKey = null;
      this.replay3DClimateRequest = null;
      this.replay3DClimateRequestKey = null;
      this.setState({ climateTimeline: [], climatePeriod: null });
      return Promise.resolve();
    }

    const key = [this.props.guid, startDate, endDate, interval].join('|');
    if (this.replay3DClimateKey === key) {
      return Promise.resolve();
    }
    if (this.replay3DClimateRequest && this.replay3DClimateRequestKey === key) {
      return this.replay3DClimateRequest;
    }

    const apiUrl = Config.server + '/job_check/analise_climate/' + encodeURIComponent(this.props.guid) + '/' + encodeURIComponent(startDate) + '/' + encodeURIComponent(endDate) + '/' + encodeURIComponent(interval);

    this.replay3DClimateRequestKey = key;
    this.replay3DClimateRequest = fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    })
      .then((response) => {
        if (response.status !== 200) throw response;
        return response.json();
      })
      .then((climate) => {
        this.replay3DClimateTimeline = climate && Array.isArray(climate.climateTimeline) ? climate.climateTimeline : [];
        this.replay3DClimatePeriod = climate && climate.climatePeriod ? climate.climatePeriod : {
          startDateApplication: startDate,
          endDateApplication: endDate
        };
        this.replay3DClimateKey = key;
        this.setState({
          climateTimeline: this.replay3DClimateTimeline,
          climatePeriod: this.replay3DClimatePeriod
        }, () => {
        });
      })
      .catch((error) => {
        this.replay3DClimateTimeline = [];
        this.replay3DClimatePeriod = {
          startDateApplication: startDate,
          endDateApplication: endDate
        };
        this.replay3DClimateKey = null;
        this.setState({
          climateTimeline: [],
          climatePeriod: this.replay3DClimatePeriod
        });
      })
      .finally(() => {
        if (this.replay3DClimateRequestKey === key) {
          this.replay3DClimateRequest = null;
          this.replay3DClimateRequestKey = null;
        }
      });

    return this.replay3DClimateRequest;
  };

  openReplay3D = () => {
    this.play(false);
    const result = this.state.data;
    this.loadReplay3DClimate(result).finally(() => {
      this.setState({ showReplay3D: true });
    });
  };

  p = {};

  values = {};

  shouldOpenReplay3DFromUrl = () => {
    try {
      const search = window && window.location && window.location.search ? window.location.search : '';
      return search.indexOf('replay3d=1') >= 0 || search.indexOf('openReplay3D=1') >= 0;
    } catch (e) {
      return false;
    }
  };

  getReplay3DPlaneParamsFromUrl = () => {
    try {
      const params = new URLSearchParams(window.location.search || '');
      return {
        id: params.get('replayPlaneId'),
        model3D: params.get('replayModel3D') || '',
        brand: params.get('replayPlaneBrand') || '',
        model: params.get('replayPlaneModel') || ''
      };
    } catch (_) {
      return { id: null, model3D: '', brand: '', model: '' };
    }
  };

  ensureReplay3DPlaneFromUrl = () => {
    if (this.replay3DPlaneFromUrlPromise) return this.replay3DPlaneFromUrlPromise;

    const planeParams = this.getReplay3DPlaneParamsFromUrl();

    if (!planeParams.id) {
      const fallbackPlane = planeParams.model3D || planeParams.brand || planeParams.model ? {
        id: null,
        name: this.state.aeronave || '',
        model3D: planeParams.model3D,
        aircraftbrand: planeParams.brand,
        aircraftmodel: planeParams.model
      } : null;

      if (fallbackPlane) {
        this.setState({
          planes: [fallbackPlane],
          selectedPlaneId: null,
          selectedPlaneAircraftBrand: planeParams.brand
        });
      }

      this.replay3DPlaneFromUrlPromise = Promise.resolve(fallbackPlane);
      return this.replay3DPlaneFromUrlPromise;
    }

    const apiUrl = Config.server + '/plane/' + planeParams.id;
    const options = {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Cache-Control': 'no-cache'
      }
    };

    this.replay3DPlaneFromUrlPromise = fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        let planeResult = result && result.data !== undefined ? result.data : result;
        if (planeResult && planeResult.plane !== undefined) planeResult = planeResult.plane;
        const plane = Array.isArray(planeResult) ? planeResult[0] : planeResult;
        if (!plane) return null;

        const completePlane = Object.assign({}, plane, {
          model3D: plane.model3D || planeParams.model3D || '',
          aircraftbrand: plane.aircraftbrand || planeParams.brand || '',
          aircraftmodel: plane.aircraftmodel || planeParams.model || ''
        });

        this.setState((currentState) => {
          const currentPlanes = Array.isArray(currentState.planes) ? currentState.planes : [];
          const planes = currentPlanes.filter(item => !item || Number(item.id) !== Number(completePlane.id));
          planes.unshift(completePlane);

          return {
            planes: planes,
            aeronave: this.getPlaneDisplayName(completePlane) || currentState.aeronave,
            selectedPlaneId: completePlane.id,
            selectedPlaneAircraftBrand: this.getPlaneAircraftBrandName(completePlane),
            selectedPlaneIdAircraftBrand: completePlane.id_aircraftbrand !== undefined ? completePlane.id_aircraftbrand : null
          };
        });

        return completePlane;
      })
      .catch(() => {
        const fallbackPlane = {
          id: planeParams.id,
          name: this.state.aeronave || '',
          model3D: planeParams.model3D,
          aircraftbrand: planeParams.brand,
          model: planeParams.model
        };

        this.setState({
          planes: [fallbackPlane],
          selectedPlaneId: planeParams.id,
          selectedPlaneAircraftBrand: planeParams.brand
        });

        return fallbackPlane;
      });

    return this.replay3DPlaneFromUrlPromise;
  };

  componentDidMount() {
    this.autoOpenReplay3DRequested = this.shouldOpenReplay3DFromUrl();

    if (this.autoOpenReplay3DRequested) {
      this.setState({ tabMenu: '1', autoReplay3DOpening: true });
      this.ensureReplay3DPlaneFromUrl();
    }

    this.boot();
    uMarker(L);
    this.getAuto('pilot', 'pilots');
    this.getAuto('plane', 'planes');
    this.getAuto('client', 'clients');
  };

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.modalOpen && this.state.modalOpen && !this.state.profileLoaded) {
      this.getProfileAuto();
    }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      this.run = false;
      return;
    };
  };

  boot = () => {
    let local_ini = Config.place;
    navigator.geolocation.getCurrentPosition((position) => {
      if (!this.state.polygons) {
        this.setState({ lat: this.round_coord(position.coords.latitude), lng: this.round_coord(position.coords.longitude) });
        this.mymap.setView([this.round_coord(position.coords.latitude), this.round_coord(position.coords.longitude)]);
      }
    });

    this.mymap = L.map('mapid', { zoomControl: false, attributionControl: false, maxZoom: 20 }).setView(local_ini, 14);
    let tileConfig = Object.assign({}, Config.tile_google_config, { maxZoom: 20 });
    L.tileLayer(Config.tile_google, tileConfig).addTo(this.mymap);

    if (this.mymap.doubleClickZoom) {
      this.mymap.doubleClickZoom.disable();
    }

    this.featureGroupTemp = L.featureGroup();
    this.featureGroupTemp.addTo(this.mymap);

    //static
    this.featureGroupLS = L.featureGroup();
    this.fGAPPS['0'] = L.featureGroup();
    this.fGAPPS['1'] = L.featureGroup();
    this.fGAPPS['2'] = L.featureGroup();
    this.fGAPPS['3'] = L.featureGroup();
    this.fGAPPS['4'] = L.featureGroup();
    this.fGAPPS['5'] = L.featureGroup();
    this.fGAPPS['6'] = L.featureGroup();
    this.fGAPPS['7'] = L.featureGroup();
    this.fGAPPS['8'] = L.featureGroup();

    this.featureGroupPolyS = L.featureGroup();

    //animacao
    this.featureGroupI = L.featureGroup();
    this.featureGroupL = L.featureGroup();
    this.fGAPP['0'] = L.featureGroup();
    this.fGAPP['1'] = L.featureGroup();
    this.fGAPP['2'] = L.featureGroup();
    this.fGAPP['3'] = L.featureGroup();
    this.fGAPP['4'] = L.featureGroup();
    this.fGAPP['5'] = L.featureGroup();
    this.fGAPP['6'] = L.featureGroup();
    this.fGAPP['7'] = L.featureGroup();
    this.fGAPP['8'] = L.featureGroup();
    this.featureGroupPoly = L.featureGroup();

    this.mymap.createPane("marks").style.zIndex = 651;

    this.mymap.on('dragstart', () => {
      this.mapIsDragging = true;
    });

    this.mymap.on('dragend', () => {
      setTimeout(() => {
        this.mapIsDragging = false;
      }, 0);
    });

    this.mymap.on('movestart', () => {
      this.mapIsDragging = true;
    });

    this.mymap.on('moveend', () => {
      setTimeout(() => {
        this.mapIsDragging = false;
      }, 0);
    });

    this.mymap.on('click', () => {
      this.showBarChart(false);

      if (this.closeWaypointPopup) {
        this.closeWaypointPopup();
      }
    });

    this.mymap.on('dblclick', (e) => {
      if (!e || !e.latlng) return;
      if (this.mapIsDragging) return;
      if (this.state && this.state.ruler_a) return;

      if (!this.waypointMarker) {
        this.createWaypointMarker(e.latlng);
      } else {
        this.moveWaypointMarker(e.latlng);
      }
    });

    this.mymap.on('zoomend', () => {
      this.updateAllSwathWidths();
      this.updateWidth(this.selectedItem);
    });

    this.mymap.on('mouseup', e => {
      if (this.state.ruler_a && !this.mymap.dragging._enabled) {
        this.mymap.dragging.enable();
        if (this.ruler_p.second.lat === null) {
          this.drawCreateToolbar.addVertex(e.latlng);
        }
      }
    });

    this.mymap.on('draw:drawvertex', (e) => {
      if (this.drawCreateToolbar.type === 'polyline' && this.state.ruler_a) {
        let layerIds = Object.keys(e.layers._layers);
        if (layerIds.length > 1) {
          let v2 = e.layers._layers[layerIds[1]];
          this.ruler_p.second.lat = v2._latlng.lat;
          this.ruler_p.second.lng = v2._latlng.lng;
          requestAnimationFrame(() => this.completeRuler());
        } else if (layerIds.length === 1) {
          let v1 = e.layers._layers[layerIds[0]];
          this.ruler_p.first.lat = v1._latlng.lat;
          this.ruler_p.first.lng = v1._latlng.lng;
        }
      }
    });

    L.drawLocal.draw.handlers.polyline.tooltip.start = '';
    L.drawLocal.draw.handlers.polyline.tooltip.cont = '';

    this.createPieChart('pieChart1', 'aplicacao', this.state.tabMenu);
    this.createPieChart('pieChart2', 'area', this.state.tabMenu);
    this.createPieChart('pieChart3', 'altura', this.state.tabMenu);
    this.createPieChart('pieChart4', 'fluxo', this.state.tabMenu);
    this.createPieChart('pieChart5', 'velocidade', this.state.tabMenu);
    this.createPieChart('pieChart6', 'velocidadeVento', this.state.tabMenu);
    this.createPieChart('pieChart7', 'direcaoVento', this.state.tabMenu);
    this.createPieChart('pieChart8', 'deltaT', this.state.tabMenu);
    this.createPieChart('pieChart9', 'temperatura', this.state.tabMenu);
    this.createPieChart('pieChart10', 'humidade', this.state.tabMenu);
    this.createBarChart();

    if (this.state.task) {
      this.getTask(this.state.task);
    } else if (this.props.guid) {
      this.checkJob();

    }
    this.loadTask(false);
  };

  changeSize = (nome, value) => {
    this.setState({ [nome]: this.state[nome] + value });
  };

  useType = (type) => {
    if (type !== 'N') {
      this.p = {
        bearing: 'bearing', tempo: 'tempo', size: 'size', size_cross: 'size_cross', is_out: 'is_out',
        restante: 'restante', setAltura: 'setAltura', setFluxo: 'setFluxo', setLargura: 'setLargura',
        setVelocidade: 'setVelocidade', setVelocidadeV: 'setVelocidadeV', setDirecaoV: 'setDirecaoV',
        setTemperatura: 'setTemperatura', setUmidade: 'setUmidade', iApp: 'iApp', iSobre: 'iSobre',
        iFora: 'iFora', iLatlng: 'iLatlng', iAltura: 'iAltura', iFluxo: 'iFluxo', iVelocidade: 'iVelocidade',
        iVelocidadeV: 'iVelocidadeV', iDirecaoV: 'iDirecaoV', iTemperatura: 'iTemperatura', iHumidade: 'iHumidade', iDeltaT: 'iDeltaT',
      }
    } else {
      this.p = {
        bearing: 0, tempo: 1, size: 2, size_cross: 3, is_out: 4,
        restante: 5, setAltura: 6, setFluxo: 7, setLargura: 8,
        setVelocidade: 9, setVelocidadeV: 10, setDirecaoV: 11,
        setTemperatura: 12, setUmidade: 13, iApp: 14, iSobre: 15,
        iFora: 16, iLatlng: 17, iAltura: 18, iFluxo: 19, iVelocidade: 20,
        iVelocidadeV: 21, iDirecaoV: 22, iTemperatura: 23, iHumidade: 24, iDeltaT: 25,
      }
    }
  }

  updateWidth = (item) => {
    if (item) {
      for (let i = 0; i < item.length; i++) {
        if (item[i]) {
          const updateLayerWidth = (layer) => {
            const largura = layer._swathWidth !== undefined ? layer._swathWidth : item[i].largura;
            const anchor = layer._swathAnchor || item[i].anchor;
            layer.setStyle({ weight: this.getSwathPixelWidth(largura, anchor) });
          };
          if (item[i].item.options) {
            updateLayerWidth(item[i].item);
          } else {
            for (let index = 0; index < item[i].item.length; index++) {
              updateLayerWidth(item[i].item[index]);
            }
          }
        }
      }
    }
  };

  updateAllSwathWidths = () => {
    const updateGroups = (groups) => {
      if (!groups) return;

      Object.keys(groups).forEach((key) => {
        const group = groups[key];
        if (!group || !group.eachLayer) return;

        group.eachLayer((layer) => {
          if (layer && layer._swathWidth !== undefined) {
            layer.setStyle({
              weight: this.getSwathPixelWidth(layer._swathWidth, layer._swathAnchor)
            });
          }
        });
      });
    };

    updateGroups(this.fGAPPS);
    updateGroups(this.fGAPP);
  };

  loggedSwathWidths = new Set();

  getSwathAnchor = (latlng) => {
    if (Array.isArray(latlng) && Array.isArray(latlng[0])) {
      return latlng[latlng.length - 1];
    }
    return latlng;
  };

  getSwathPixelWidth = (larguraFaixa, latlng) => {
    const larguraMetros = Number(larguraFaixa);
    const anchor = this.getSwathAnchor(latlng);

    if (!this.mymap || !anchor || !Number.isFinite(larguraMetros) || larguraMetros <= 0) {
      return 1;
    }

    const latitude = Number(anchor[0]);
    const longitude = Number(anchor[1]);
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      return 1;
    }

    const point = L.latLng(latitude, longitude);
    const zoom = this.mymap.getZoom();
    const projected = this.mymap.project(point, zoom);
    const adjacentPoint = this.mymap.unproject(L.point(projected.x + 1, projected.y), zoom);
    const metrosPorPixel = this.mymap.distance(point, adjacentPoint);
    const larguraPixels = metrosPorPixel > 0 ? larguraMetros / metrosPorPixel : 1;

    // A log entry is emitted once for each configured width/zoom combination,
    // making it possible to compare the configured faixa with the map stroke
    // without inspecting the generated analysis payload.
    const logKey = `${zoom}/${larguraMetros}`;
    if (!this.loggedSwathWidths.has(logKey)) {
      this.loggedSwathWidths.add(logKey);
      console.debug('[job_analyze] largura da faixa renderizada', {
        larguraConfiguradaMetros: larguraMetros,
        larguraRenderizadaPixels: larguraPixels,
        zoom
      });
    }

    return larguraPixels;
  };

  handleChange = name => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleChangeTab = name => (event, newValue) => {
    let value = newValue ? newValue : event.target.value;
    let repeat = this.state[name] === newValue;
    this.setState({
      [name]: value,
    }, () => {
      if (newValue > 0 && this.state.showChart) {
        this.selectTiroChart(null, 0);
      } else {
        this.showBarChart(false);
      }
      if (!repeat && (name === 'tab' || name === 'tabSubMenuV' || name === 'tabSubMenuD')) {
        this.changeType(value);
      } else if (!repeat && name === 'tabMenu') {
        this.play(false);
        this.changeTabMenu(newValue);
        this.changeType(this.state.tab);
      }
    });

  };

  handleChangePerfil = (event) => {
    this.setState({ selectedPerfil: event.target.value });
    let perfil = this.state.listPerfis.find((item) => (item.id === event.target.value));
    this.selectPerfil(perfil);
  };

  handleCheck = id => (event) => {
    let temp = this.state.checkConfig;
    temp[id] = !temp[id];
    this.setState({
      checkConfig: temp,
    });
  };

  changeTabMenu = (type) => {
    if (type === '3') {
      this.play(false);
      this.mymap.removeLayer(this.featureGroupI);
      return;
    }

    if (type === '0' || type === '2') {
      this.updateMap('area', this.featureGroupPolyS);
      this.updateMap('caminho', this.featureGroupLS);
      this.updateMap('aplicacao', this.fGAPPS[this.state.tab]);

      this.mymap.removeLayer(this.featureGroupI);

      this.play(false);
      if (this.state.updateValuesAnimation) this.showStaticData(true);
      this.updateWidth(this.selectedItem);
    } else if (type === '1') {
      this.updateMap('area', this.featureGroupPoly);
      this.updateMap('caminho', this.featureGroupL);
      this.updateMap('aplicacao', this.fGAPP[this.state.tab]);

      this.featureGroupI.addTo(this.mymap);

      if (this.state.updateValuesAnimation) this.showExe(true);
    }
  };

  changeSettingsMargemDown = (value, setValue, margemDown, limiteDown, margemUp, keepSet) => {
    let temp_setValue = Number(this.state[setValue]);
    let temp_margemUp = this.state[margemUp];
    if (margemUp && !keepSet) {
      temp_setValue = (Number(temp_margemUp.text) - Number(value)) / 2 + Number(value);
    }
    let temp_margemDown = this.state[margemDown];
    temp_margemDown.text = value;
    if (!isNaN(value) &&
      Number(value) >= 0 &&
      (temp_setValue - Number(value)) >= 0) {
      temp_margemDown.valid = true;
      temp_margemDown.value = (temp_setValue - Number(value));
      let temp_limiteDown = this.state[limiteDown];
      let temp = (temp_setValue - this.state[margemDown].value - this.state[limiteDown].value);
      if (temp < 0) {
        temp_limiteDown.value = temp === 0 ? 0 : this.state[limiteDown].value + temp;
        if (temp_limiteDown.valid) temp_limiteDown.text = value - temp_limiteDown.value;
      }
      temp_limiteDown.text = (temp_setValue - temp_margemDown.value - temp_limiteDown.value);
      let update = { [margemDown]: temp_margemDown, [limiteDown]: temp_limiteDown, [setValue]: temp_setValue, selectedPerfil: 0 };
      if (margemUp) {
        temp_margemUp.value = Number(temp_margemUp.text) - temp_setValue;
        update[margemUp] = temp_margemUp;
      }
      this.setState(update);
    } else {
      temp_margemDown.valid = false;
      this.setState({ [margemDown]: temp_margemDown });
    }
  }

  changeSettingsMargemUp = (value, setValue, margemUp, limiteUp, limitMax, margemDown, keepSet) => {
    let temp_setValue = Number(this.state[setValue]);
    let temp_margemDown = this.state[margemDown];
    if (margemDown && !keepSet) {
      temp_setValue = (Number(value) - Number(temp_margemDown.text)) / 2 + Number(temp_margemDown.text);
    }
    let temp_margemUp = this.state[margemUp];
    temp_margemUp.text = value;
    if (!isNaN(value) &&
      ((limitMax && (temp_setValue + Number(value)) <= limitMax) || !limitMax) &&
      (Number(value) - temp_setValue) >= 0) {
      temp_margemUp.value = (Number(value) - temp_setValue);
      temp_margemUp.valid = true;
      let temp_limiteUp = this.state[limiteUp];
      if (limitMax && (temp_setValue + temp_margemUp.value + temp_limiteUp.value) > limitMax) {
        temp_limiteUp.value = limitMax - temp_margemUp.value;
      }
      temp_limiteUp.text = temp_setValue + temp_margemUp.value + temp_limiteUp.value;
      let update = { [margemUp]: temp_margemUp, [limiteUp]: temp_limiteUp, [setValue]: temp_setValue, selectedPerfil: 0 };
      if (margemDown) {
        temp_margemDown.value = temp_setValue - Number(temp_margemDown.text);
        update[margemDown] = temp_margemDown;
      }
      this.setState(update);
    } else {
      temp_margemUp.valid = false;
      this.setState({ [margemUp]: temp_margemUp });
    }
  }

  changeSettingsLimitDown = (value, setValue, margemDown, limiteDown) => {
    let temp_limitDown = this.state[limiteDown];
    temp_limitDown.text = value;
    if (!isNaN(value) &&
      Number(value) >= 0 &&
      Number(value) <= (Number(this.state[setValue]) - Number(this.state[margemDown].value))) {
      temp_limitDown.value = (Number(this.state[setValue]) - Number(this.state[margemDown].value) - Number(value))
      temp_limitDown.text = value;
      temp_limitDown.valid = true;
      this.setState({ [limiteDown]: temp_limitDown, selectedPerfil: 0 });
    } else {
      temp_limitDown.valid = false;
      this.setState({ [limiteDown]: temp_limitDown });
    }
  }

  changeSettingsLimitUp = (value, setValue, margemUp, limiteUp, limitMax) => {
    let temp_value = Number(value);
    let temp_setValue = Number(this.state[setValue]);
    let temp_margemUp = Number(this.state[margemUp].value);
    let temp_limiteUp = this.state[limiteUp];
    temp_limiteUp.text = value;
    if (!isNaN(value) &&
      ((limitMax && (temp_value) <= limitMax) || !limitMax) &&
      (temp_value) >= (temp_margemUp + temp_setValue)) {

      temp_limiteUp.value = (temp_value - (temp_setValue + temp_margemUp));
      temp_limiteUp.valid = true;
      this.setState({ [limiteUp]: temp_limiteUp, selectedPerfil: 0 });
    } else {
      temp_limiteUp.valid = false;
      this.setState({ [limiteUp]: temp_limiteUp });
    }
  }
  updateUrl = (guid) => {
    window.history.replaceState(null, "Travicar", "/app/qualidade/" + guid);
  };

  checkJob = () => {
    this.setState({ progress: !this.autoOpenReplay3DRequested }, () => {

      let guid = this.props.guid;
      let apiUrl = Config.server + '/job_check/analise/' + guid;
      let method = 'GET';

      let options = {
        method: method,
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt')
        }
      }

      fetch(apiUrl, options)
        .then((res) => {
          if (res.status !== 200) throw res;
          else return res.json();
        })
        .then(
          (result) => {
            if (result.task && result.task.id) {
              if (result.task.status === 'Processing') {
                this.setState({ progress: false });
                this.loadTask(true)
              } else {
                this.getTask(result.task.id, result.data);
              }
            } else {
              this.setState({ progress: false, autoReplay3DOpening: false });
            }
            if (result.job && result.job.id) {
              this.setState({ id_job: result.job.id, title: result.job.title });
            }
            if (result.guid_link) {
              this.updateUrl(result.guid_link);
            }
          }, (error) => {
            this.setState({ progress: false, autoReplay3DOpening: false });
            if (error.status === 405) {
              notification.open({
                message: this.props.res.PERMISSAO,
                description: this.props.res.PERMISSAO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            } else if (error.status === 401 || error.status === 403) {
              this.props.link('/login');
            } else if (error.status === 400) {
              error.json().then(
                (errCode) => {
                  notification.open({
                    message: this.props.res[errCode.code],
                    icon: <MaterialIcon icon="error" className="text-danger" />
                  });
                });
            } else {
              console.log(error);
              notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            }
          }
        );
    });
  };

  zoomInL = () => {
    this.mymap.zoomIn();
  };

  zoomOutL = () => {
    this.mymap.zoomOut();
  };

  formatRegua = (valor) => {
    let text = '';
    if (valor < 1000) {
      text = Math.round(valor) + ' m';
    } else {
      text = (Math.round(valor / 10) / 100) + ' km';
    }

    return text;
  };

  showMenu = () => {
    let dF = document.getElementById('divFloat');
    if (!dF.className.includes('div-listFloatC')) {
      dF.classList.toggle("div-listFloatC");
    } else {
      dF.classList.remove("div-listFloatC");
    }
  };

  showGoto = () => {
    if (this.state.goto) {
      this.setState({ goto: false });
    } else {
      this.setState({ goto: true, lat: this.round_coord(this.mymap.getCenter().lat), lng: this.round_coord(this.mymap.getCenter().lng) });
    }
  };
  goto = (asd) => {
    this.setState({ goto: false });
    this.mymap.setView([this.state.lat, this.state.lng]);
  };
  round_coord = (coord) => {
    return coord.toFixed(7);
  };

  formatCoordinateByMode = (value, type) => {
    if (value == null || value === '' || !isFinite(Number(value))) return '';

    if ((this.state.coordMode || 'dd') === 'dd') {
      return Number(value).toFixed(6);
    }

    return geo.toDMS(Number(value), type, 4, this.props.res);
  };

  toggleCoordMode = () => {
    const nextMode = (this.state.coordMode || 'dd') === 'dd' ? 'dms' : 'dd';

    this.setState({ coordMode: nextMode }, () => {
      if (this.waypointMarker) {
        const latlng = this.waypointMarker.getLatLng();
        this.waypointMarker.setPopupContent(this.formatWaypointPopup(latlng));
        this.openWaypointPopup();
      }
    });
  };

  buildWaypointIcon = () => {
    if (this.waypointIcon) return this.waypointIcon;

    this.waypointIcon = L.icon({
      iconUrl: pinWaypoint,
      iconSize: [30, 30],
      iconAnchor: [15, 30],
      popupAnchor: [0, -28]
    });

    return this.waypointIcon;
  };

  formatWaypointPopup = (latlng) => {
    const latText = latlng && latlng.lat != null ? this.formatCoordinateByMode(latlng.lat, 'latitude') : '';
    const lngText = latlng && latlng.lng != null ? this.formatCoordinateByMode(latlng.lng, 'longitude') : '';
    const modeLabel = (this.state.coordMode || 'dd').toUpperCase();

    return `
      <div style="font-size: 12px; line-height: 1.35;">
        <div style="margin-bottom: 4px;"><b>${modeLabel}</b></div>
        <div><b>${this.props.res.LAT || 'LAT'}:</b> ${latText}</div>
        <div><b>${this.props.res.LNG || 'LNG'}:</b> ${lngText}</div>
      </div>
    `;
  };

  openWaypointPopup = () => {
    if (this.waypointMarker) {
      this.waypointMarker.openPopup();
    }
  };

  closeWaypointPopup = () => {
    if (this.waypointMarker) {
      this.waypointMarker.closePopup();
    }
  };

  createWaypointMarker = (latlng) => {
    const icon = this.buildWaypointIcon();

    const marker = L.marker(latlng, {
      icon: icon,
      keyboard: false
    });

    marker.bindPopup(this.formatWaypointPopup(latlng), {
      closeButton: true,
      autoClose: false,
      closeOnClick: false
    });

    marker.on('click', (ev) => {
      if (ev && ev.originalEvent) {
        L.DomEvent.stopPropagation(ev.originalEvent);
      }
      this.openWaypointPopup();
    });

    marker.addTo(this.mymap);

    this.waypointMarker = marker;
    this.openWaypointPopup();
  };

  moveWaypointMarker = (latlng) => {
    if (!this.waypointMarker) {
      this.createWaypointMarker(latlng);
      return;
    }

    this.waypointMarker.setLatLng(latlng);
    this.waypointMarker.setPopupContent(this.formatWaypointPopup(latlng));
    this.openWaypointPopup();
  };

  handleStackClick = (tipo) => {

  };

  changeType = (type) => {
    let item = null, id = null;
    if (((this.state.tab === '4' && type === '0') || (this.state.tabSubMenuV === '0' && type === '4')) && !this.acc["divVen"]) {
      id = '4';
      document.getElementById("divVen").scrollIntoView({ behavior: "smooth", block: "start" });
      item = this.state.tabMenu === '0' || this.state.tabMenu === '2' ? this.velocidadeVentoS : this.velocidadeVento;
    } else if (((this.state.tab === '4' && type === '1') || (this.state.tabSubMenuV === '1' && type === '4')) && !this.acc["divVenD"]) {
      id = '5';
      document.getElementById("divVenD").scrollIntoView({ behavior: "smooth", block: "start" });
      item = this.state.tabMenu === '0' || this.state.tabMenu === '2' ? this.direcaoVentoS : this.direcaoVento;
    } else if (((this.state.tab === '5' && type === '0') || (this.state.tabSubMenuD === '0' && type === '5')) && !this.acc["divDeltaT"]) {
      id = '6';
      document.getElementById("divDeltaT").scrollIntoView({ behavior: "smooth", block: "start" });
      item = this.state.tabMenu === '0' || this.state.tabMenu === '2' ? this.deltaTS : this.deltaT;
    } else if (((this.state.tab === '5' && type === '1') || (this.state.tabSubMenuD === '1' && type === '5')) && !this.acc["divTemp"]) {
      id = '7';
      document.getElementById("divTemp").scrollIntoView({ behavior: "smooth", block: "start" });
      item = this.state.tabMenu === '0' || this.state.tabMenu === '2' ? this.temperaturaS : this.temperatura;
    } else if (((this.state.tab === '5' && type === '2') || (this.state.tabSubMenuD === '2' && type === '5')) && !this.acc["divHum"]) {
      id = '8';
      document.getElementById("divHum").scrollIntoView({ behavior: "smooth", block: "start" });
      item = this.state.tabMenu === '0' || this.state.tabMenu === '2' ? this.humidadeS : this.humidade;
    } else if (type === '1' && !this.acc["divAlt"]) {
      id = '1';
      document.getElementById("divAlt").scrollIntoView({ behavior: "smooth", block: "start" });
      item = this.state.tabMenu === '0' || this.state.tabMenu === '2' ? this.alturaS : this.altura;
    } else if (type === '2' && !this.acc["divFlo"]) {
      id = '2';
      document.getElementById("divFlo").scrollIntoView({ behavior: "smooth", block: "start" });
      item = this.state.tabMenu === '0' || this.state.tabMenu === '2' ? this.fluxoS : this.fluxo;
    } else if (type === '3' && !this.acc["divVel"]) {
      id = '3';
      document.getElementById("divVel").scrollIntoView({ behavior: "smooth", block: "start" });
      item = this.state.tabMenu === '0' || this.state.tabMenu === '2' ? this.velocidadeS : this.velocidade;
    } else if (type === '0' && !this.acc["divApp"]) {
      id = '0';
      document.getElementById("divApp").scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (item) {
      this.selectedItem = item;
      this.updateWidth(this.selectedItem);
    }
    if (id) {
      if (this.state.tabMenu === '0' || this.state.tabMenu === '2') {
        this.updateMap('aplicacao', this.fGAPPS[id]);
      } else {
        this.updateMap('aplicacao', this.fGAPP[id]);
      }
    }
  };

  getValidText = (value) => {
    if (value === undefined || value === null) return '';
    const text = String(value).trim();
    if (!text || text.toLowerCase() === 'undefined' || text.toLowerCase() === 'null') return '';
    return text;
  };

  normalizeQualitySetValue = (value) => {
    const number = Number(value);
    if (!Number.isFinite(number)) return 0;

    const nearestInteger = Math.round(number);
    if (Math.abs(number - nearestInteger) <= 0.001) return nearestInteger;
    return Math.round(number * 1000) / 1000;
  };

  formatQualityValue = (value, decimals = 3) => {
    const number = Number(value);
    if (!Number.isFinite(number)) return '0';
    const normalized = this.normalizeQualitySetValue(number);
    if (Number.isInteger(normalized)) return String(normalized);
    return String(Number(normalized.toFixed(decimals)));
  };

  getStaticQualityCategory = (valor, setValor, marginDown, marginUp, limitDown, limitUp) => {
    const valueNumber = Number(valor);
    const setNumber = Number(setValor);
    if (!Number.isFinite(valueNumber) || !Number.isFinite(setNumber)) return null;

    const minT = setNumber - Number(marginDown || 0);
    const maxT = setNumber + Number(marginUp || 0);
    const min = minT - Number(limitDown || 0);
    const max = maxT + Number(limitUp || 0);
    const epsilon = Math.max(1, Math.abs(setNumber), Math.abs(valueNumber)) * 1e-9;

    if (valueNumber >= minT - epsilon && valueNumber <= maxT + epsilon) return 'correto';
    if (valueNumber < min - epsilon) return 'incorretaInf';
    if (valueNumber < minT - epsilon) return 'aceitavelInf';
    if (valueNumber > max + epsilon) return 'incorretaSup';
    if (valueNumber > maxT + epsilon) return 'aceitavelSup';
    return 'correto';
  };

  calculateStaticQualityStats = (items, marginDown, marginUp, limitDown, limitUp, areaTotal, fixedSetValue = null, fallbackSetValue = null) => {
    const stats = {
      pontos: 0,
      soma: 0,
      correto: 0,
      aceitavelInf: 0,
      aceitavelSup: 0,
      incorretaInf: 0,
      incorretaSup: 0
    };

    if (!Array.isArray(items) || !items.length) return stats;

    let totalPontos = 0;
    for (let i = 0; i < items.length; i++) {
      const grupo = items[i];
      if (!grupo || !Array.isArray(grupo.item)) continue;

      for (let j = 0; j < grupo.item.length; j++) {
        const item = grupo.item[j];
        if (!item || !Array.isArray(item.valor)) continue;
        totalPontos += item.valor.length;
      }
    }

    if (!totalPontos) return stats;

    const areaPorPonto = Number(areaTotal) > 0 ? Number(areaTotal) / totalPontos : 0;
    const hasFixedSet =
      fixedSetValue !== null &&
      fixedSetValue !== undefined &&
      fixedSetValue !== '' &&
      Number.isFinite(Number(fixedSetValue));
    const hasFallbackSet = Number.isFinite(Number(fallbackSetValue)) && Number(fallbackSetValue) > 0;

    for (let i = 0; i < items.length; i++) {
      const grupo = items[i];
      if (!grupo || !Array.isArray(grupo.item)) continue;

      for (let j = 0; j < grupo.item.length; j++) {
        const item = grupo.item[j];
        if (!item || !Array.isArray(item.valor)) continue;

        for (let k = 0; k < item.valor.length; k++) {
          const valor = Number(item.valor[k]);
          const itemSet = Array.isArray(item.setValor) ? Number(item.setValor[k]) : NaN;
          const setValor = hasFixedSet
            ? Number(fixedSetValue)
            : (Number.isFinite(itemSet) && itemSet > 0
              ? itemSet
              : (hasFallbackSet ? Number(fallbackSetValue) : itemSet));
          if (!Number.isFinite(valor) || !Number.isFinite(setValor)) continue;

          stats.pontos += 1;
          stats.soma += valor;

          const category = this.getStaticQualityCategory(
            valor,
            setValor,
            marginDown,
            marginUp,
            limitDown,
            limitUp
          );

          if (category) stats[category] += areaPorPonto;
        }
      }
    }

    stats.media = stats.pontos > 0 ? stats.soma / stats.pontos : 0;
    delete stats.soma;
    return stats;
  };

  applyStaticQualityColors = (items, marginDown, marginUp, limitDown, limitUp, fixedSetValue = null, fallbackSetValue = null) => {
    if (!Array.isArray(items)) return [];

    const hasFixedSet =
      fixedSetValue !== null &&
      fixedSetValue !== undefined &&
      fixedSetValue !== '' &&
      Number.isFinite(Number(fixedSetValue));
    const hasFallbackSet = Number.isFinite(Number(fallbackSetValue)) && Number(fallbackSetValue) > 0;

    return items.map(grupo => ({
      ...grupo,
      item: Array.isArray(grupo.item) ? grupo.item.map(item => {
        const values = Array.isArray(item.valor) ? item.valor : [];
        const originalSetValues = Array.isArray(item.setValor) ? item.setValor : [];
        const categories = {
          correto: 0,
          aceitavelInf: 0,
          aceitavelSup: 0,
          incorretaInf: 0,
          incorretaSup: 0
        };

        const setValues = values.map((value, index) => {
          const originalSet = Number(originalSetValues[index]);
          const setValue = hasFixedSet
            ? Number(fixedSetValue)
            : (Number.isFinite(originalSet) && originalSet > 0
              ? originalSet
              : (hasFallbackSet ? Number(fallbackSetValue) : originalSet));
          const category = this.getStaticQualityCategory(
            value,
            setValue,
            marginDown,
            marginUp,
            limitDown,
            limitUp
          );
          if (category) categories[category] += 1;
          return setValue;
        });

        let dominantCategory = 'correto';
        let dominantCount = -1;
        Object.keys(categories).forEach(category => {
          if (categories[category] > dominantCount) {
            dominantCount = categories[category];
            dominantCategory = category;
          }
        });

        return {
          ...item,
          setValor: setValues,
          color: this.styles.stripColor[dominantCategory]
        };
      }) : []
    }));
  };

  useData = (result) => {
    const { res } = this.props;

    const id_job = this.state.id_job
    this.clear(true, () => {
      localStorage.setItem('check-task', result.task);

      let larguraValue, alturaValue, fluxoValue, velocidadeValue;
      larguraValue = Units.convertLength(result.data.larguraSet, 'm', res);
      alturaValue = Units.convertLength(result.data.alturaSet, 'm', res);
      fluxoValue = Units.convertFlow(result.data.fluxoSet, 'L', 'ha', res);
      velocidadeValue = Units.convertSpeed(result.data.velocidadeSet, 'km/h', res);

      let alturaMargemDown = this.state.alturaMargemDown;
      alturaMargemDown.text = alturaValue - alturaMargemDown.value;
      let alturaMargemUp = this.state.alturaMargemUp;
      alturaMargemUp.text = alturaValue + alturaMargemUp.value;
      let alturaLimiteDown = this.state.alturaLimiteDown;
      alturaLimiteDown.text = alturaValue - alturaMargemDown.value - alturaLimiteDown.value;
      let alturaLimiteUp = this.state.alturaLimiteUp;
      alturaLimiteUp.text = alturaValue + alturaMargemUp.value + alturaLimiteUp.value;

      let fluxoMargemDown = this.state.fluxoMargemDown;
      fluxoMargemDown.text = fluxoValue - fluxoMargemDown.value;
      let fluxoMargemUp = this.state.fluxoMargemUp;
      fluxoMargemUp.text = fluxoValue + fluxoMargemUp.value;
      let fluxoLimiteDown = this.state.fluxoLimiteDown;
      fluxoLimiteDown.text = fluxoValue - fluxoMargemDown.value - fluxoLimiteDown.value;
      let fluxoLimiteUp = this.state.fluxoLimiteUp;
      fluxoLimiteUp.text = fluxoValue + fluxoMargemUp.value + fluxoLimiteUp.value;

      let velocidadeMargemDown = this.state.velocidadeMargemDown;
      velocidadeMargemDown.text = velocidadeValue - velocidadeMargemDown.value;
      let velocidadeMargemUp = this.state.velocidadeMargemUp;
      velocidadeMargemUp.text = velocidadeValue + velocidadeMargemUp.value;
      let velocidadeLimiteDown = this.state.velocidadeLimiteDown;
      velocidadeLimiteDown.text = velocidadeValue - velocidadeMargemDown.value - velocidadeLimiteDown.value;
      let velocidadeLimiteUp = this.state.velocidadeLimiteUp;
      velocidadeLimiteUp.text = velocidadeValue + velocidadeMargemUp.value + velocidadeLimiteUp.value;

      let checkConfig = this.state.checkConfig;
      checkConfig[4] = result.data.weather.length > 0;

      let polys = [];
      for (let i = 0; i < result.data.shapes.length; i++) {
        const element = result.data.shapes[i];

        polys.push({
          guid: element.guid,
          name: element.name,
          points: element.latlngarray,
          type: element.type,
        });
      }
      this.polygonsDefault = polys;
      //this.onCloseEditMap(polys, false);
      let consumption_clima_api = 0;
      let limit_clima_api = 0;
      if (result.data.compConfig) {
        consumption_clima_api = result.data.compConfig.consumption_clima_api;
        limit_clima_api = result.data.compConfig.limit_clima_api;
      }
      let tabMenuItens = this.state.tabMenuItens;
      if (limit_clima_api > consumption_clima_api && result.data.weather.length === 0) {
        tabMenuItens[0].active = false;
      }

      const clienteValue = this.getValidText(result.data.cliente);
      const aeronaveValue = this.getValidText(result.data.aeronave);
      const pilotoValue = this.getValidText(result.data.piloto);

      this.setState({
        task: result.task.id,
        title_sk: result.data.title,
        larguraSet: larguraValue,
        alturaSet: alturaValue,
        alturaMargemDown: alturaMargemDown,
        alturaMargemUp: alturaMargemUp,
        alturaLimiteDown: alturaLimiteDown,
        alturaLimiteUp: alturaLimiteUp,
        fluxoSet: fluxoValue,
        fluxoMargemDown: fluxoMargemDown,
        fluxoMargemUp: fluxoMargemUp,
        fluxoLimiteDown: fluxoLimiteDown,
        fluxoLimiteUp: fluxoLimiteUp,
        velocidadeSet: velocidadeValue,
        velocidadeMargemDown: velocidadeMargemDown,
        velocidadeMargemUp: velocidadeMargemUp,
        velocidadeLimiteDown: velocidadeLimiteDown,
        velocidadeLimiteUp: velocidadeLimiteUp,
        larguraDefault: larguraValue,
        alturaDefault: alturaValue,
        fluxoDefault: fluxoValue,
        velocidadeDefault: velocidadeValue,

        cliente: clienteValue,
        aeronave: aeronaveValue,
        piloto: pilotoValue,
        gCliente: clienteValue,
        gAeronave: aeronaveValue,
        gPiloto: pilotoValue,

        fonstes: result.data.weather,
        limitWeather: limit_clima_api,
        limitConsumption: consumption_clima_api,
        tabMenuItens,
        checkConfig: checkConfig,
        tipoFonte: checkConfig[4] ? 'ESTACAO' : 'EXTERNO',

        state: 1,
        progress: false
      }, () => {
        this.mountListPerfis();
        this.getAreas(id_job);
      });
    });
  };

  play = (go) => {
    if (go && !this.state.play) {
      if (this.state.end) {
        this.setState({ end: false, tiro: 0, valueBar: 0 });
        this.featureGroupL.clearLayers();
        if (this.featureAtual.aplicacao) this.featureAtual.aplicacao.clearLayers();

        if (this.marker.marker) {
          this.featureGroupI.removeLayer(this.marker.marker);
        }

        this.exe(this.state.data);
      } else {
        this.pathMap(this.state.data, this.iPlay, this.state.area);
      }
    }
    this.setState({ play: go });
  };

  clearSeekPreview = () => {
    if (this.seekPreviewLine) {
      if (this.mymap && this.mymap.hasLayer(this.seekPreviewLine)) {
        this.mymap.removeLayer(this.seekPreviewLine);
      }
      this.seekPreviewLine = null;
    }

    if (this.seekPreviewMarker) {
      if (this.mymap && this.mymap.hasLayer(this.seekPreviewMarker)) {
        this.mymap.removeLayer(this.seekPreviewMarker);
      }
      this.seekPreviewMarker = null;
    }
  };

  drawSeekPreview = (value) => {
    if (!this.state.data || !this.state.data.path || this.state.data.path.length < 3) return;

    let total = this.state.data.path.length - 2;
    let previewTimeline = Math.round((value / 1000) * total) + 1;

    if (previewTimeline < 1) previewTimeline = 1;
    if (previewTimeline > total) previewTimeline = total;

    const previewPath = this.state.data.path.slice(0, previewTimeline + 1);
    const previewPoint = this.state.data.path[previewTimeline];

    this.clearSeekPreview();

    this.seekPreviewLine = new L.polyline(previewPath, {
      color: '#ffffff',
      weight: 2,
      opacity: 0.9,
      smoothFactor: 1,
      dashArray: '6, 6'
    });

    this.seekPreviewLine.addTo(this.mymap);

    const previewIcon = L.icon({
      iconUrl: Img_mark,
      iconAnchor: [21, 14],
      iconSize: [43.2, 28.8]
    });

    this.seekPreviewMarker = L.marker(
      new L.LatLng(previewPoint[0], previewPoint[1]),
      { icon: previewIcon, pane: 'marks' }
    );

    if (
      this.seekPreviewMarker.setRotationAngle &&
      this.state.data.pontos &&
      this.state.data.pontos[previewTimeline - 1]
    ) {
      this.seekPreviewMarker.setRotationAngle(
        this.state.data.pontos[previewTimeline - 1][this.p.bearing]
      );
    }

    this.seekPreviewMarker.addTo(this.mymap);
  };

  handleChangeBar = (event, value) => {
    this.isMovingBar = true;
    this.setState({ valueBar: value }, () => {
      this.drawSeekPreview(value);
    });
  };

  handleChangeBarCommit = (event, value) => {
    this.setState({ valueBar: value, loading: true }, () => {
      this.updateTime();
    });
  };

  prepareSeekSwap = () => {
    const originalFGAPP = {
      '0': this.fGAPP['0'],
      '1': this.fGAPP['1'],
      '2': this.fGAPP['2'],
      '3': this.fGAPP['3'],
      '4': this.fGAPP['4'],
      '5': this.fGAPP['5'],
      '6': this.fGAPP['6'],
      '7': this.fGAPP['7'],
      '8': this.fGAPP['8']
    };

    const tempFGAPP = {
      '0': new L.FeatureGroup(),
      '1': new L.FeatureGroup(),
      '2': new L.FeatureGroup(),
      '3': new L.FeatureGroup(),
      '4': new L.FeatureGroup(),
      '5': new L.FeatureGroup(),
      '6': new L.FeatureGroup(),
      '7': new L.FeatureGroup(),
      '8': new L.FeatureGroup()
    };

    this.seekSwap = {
      original: {
        featureGroupL: this.featureGroupL,
        featureGroupI: this.featureGroupI,
        fGAPP: originalFGAPP,
        featureAtual: this.featureAtual,
        marker: this.marker,
        line: this.line,
        lineAltura: this.lineAltura,
        lineFluxo: this.lineFluxo,
        lineVelocidade: this.lineVelocidade,
        lineVelocidadeVento: this.lineVelocidadeVento,
        lineDirecaoVento: this.lineDirecaoVento,
        lineDeltaT: this.lineDeltaT,
        lineTemperatura: this.lineTemperatura,
        lineHumidade: this.lineHumidade,
        altura: this.altura,
        fluxo: this.fluxo,
        velocidade: this.velocidade,
        velocidadeVento: this.velocidadeVento,
        direcaoVento: this.direcaoVento,
        deltaT: this.deltaT,
        temperatura: this.temperatura,
        humidade: this.humidade
      },
      temp: {
        featureGroupL: new L.FeatureGroup(),
        featureGroupI: new L.FeatureGroup(),
        fGAPP: tempFGAPP,
        featureAtual: {
          caminho: null,
          aplicacao: null,
          area: null,
        },
        marker: {
          base: null,
          marker: null,
          angle: 45
        },
        line: null,
        lineAltura: null,
        lineFluxo: null,
        lineVelocidade: null,
        lineVelocidadeVento: null,
        lineDirecaoVento: null,
        lineDeltaT: null,
        lineTemperatura: null,
        lineHumidade: null,
        altura: [],
        fluxo: [],
        velocidade: [],
        velocidadeVento: [],
        direcaoVento: [],
        deltaT: [],
        temperatura: [],
        humidade: []
      }
    };

    this.featureGroupL = this.seekSwap.temp.featureGroupL;
    this.featureGroupI = this.seekSwap.temp.featureGroupI;
    this.fGAPP = this.seekSwap.temp.fGAPP;
    this.featureAtual = this.seekSwap.temp.featureAtual;
    this.marker = this.seekSwap.temp.marker;
    this.line = this.seekSwap.temp.line;
    this.lineAltura = this.seekSwap.temp.lineAltura;
    this.lineFluxo = this.seekSwap.temp.lineFluxo;
    this.lineVelocidade = this.seekSwap.temp.lineVelocidade;
    this.lineVelocidadeVento = this.seekSwap.temp.lineVelocidadeVento;
    this.lineDirecaoVento = this.seekSwap.temp.lineDirecaoVento;
    this.lineDeltaT = this.seekSwap.temp.lineDeltaT;
    this.lineTemperatura = this.seekSwap.temp.lineTemperatura;
    this.lineHumidade = this.seekSwap.temp.lineHumidade;
    this.altura = this.seekSwap.temp.altura;
    this.fluxo = this.seekSwap.temp.fluxo;
    this.velocidade = this.seekSwap.temp.velocidade;
    this.velocidadeVento = this.seekSwap.temp.velocidadeVento;
    this.direcaoVento = this.seekSwap.temp.direcaoVento;
    this.deltaT = this.seekSwap.temp.deltaT;
    this.temperatura = this.seekSwap.temp.temperatura;
    this.humidade = this.seekSwap.temp.humidade;
  };

  finishSeekSwap = () => {
    if (!this.seekSwap) return null;

    const tempResult = {
      featureAtual: this.featureAtual,
      marker: this.marker,
      line: this.line,
      lineAltura: this.lineAltura,
      lineFluxo: this.lineFluxo,
      lineVelocidade: this.lineVelocidade,
      lineVelocidadeVento: this.lineVelocidadeVento,
      lineDirecaoVento: this.lineDirecaoVento,
      lineDeltaT: this.lineDeltaT,
      lineTemperatura: this.lineTemperatura,
      lineHumidade: this.lineHumidade,
      altura: this.altura,
      fluxo: this.fluxo,
      velocidade: this.velocidade,
      velocidadeVento: this.velocidadeVento,
      direcaoVento: this.direcaoVento,
      deltaT: this.deltaT,
      temperatura: this.temperatura,
      humidade: this.humidade
    };

    const original = this.seekSwap.original;
    const temp = this.seekSwap.temp;

    original.featureGroupL.clearLayers();
    original.featureGroupI.clearLayers();
    original.fGAPP['0'].clearLayers();
    original.fGAPP['1'].clearLayers();
    original.fGAPP['2'].clearLayers();
    original.fGAPP['3'].clearLayers();
    original.fGAPP['4'].clearLayers();
    original.fGAPP['5'].clearLayers();
    original.fGAPP['6'].clearLayers();
    original.fGAPP['7'].clearLayers();
    original.fGAPP['8'].clearLayers();

    const tempLineLayers = Object.values(temp.featureGroupL._layers);
    for (let i = 0; i < tempLineLayers.length; i++) {
      original.featureGroupL.addLayer(tempLineLayers[i]);
    }

    const tempIconLayers = Object.values(temp.featureGroupI._layers);
    for (let i = 0; i < tempIconLayers.length; i++) {
      original.featureGroupI.addLayer(tempIconLayers[i]);
    }

    for (let key in temp.fGAPP) {
      const layers = Object.values(temp.fGAPP[key]._layers);
      for (let i = 0; i < layers.length; i++) {
        original.fGAPP[key].addLayer(layers[i]);
      }
    }

    this.featureGroupL = original.featureGroupL;
    this.featureGroupI = original.featureGroupI;
    this.fGAPP = original.fGAPP;

    this.featureAtual = tempResult.featureAtual;
    this.marker = tempResult.marker;
    this.line = tempResult.line;
    this.lineAltura = tempResult.lineAltura;
    this.lineFluxo = tempResult.lineFluxo;
    this.lineVelocidade = tempResult.lineVelocidade;
    this.lineVelocidadeVento = tempResult.lineVelocidadeVento;
    this.lineDirecaoVento = tempResult.lineDirecaoVento;
    this.lineDeltaT = tempResult.lineDeltaT;
    this.lineTemperatura = tempResult.lineTemperatura;
    this.lineHumidade = tempResult.lineHumidade;
    this.altura = tempResult.altura;
    this.fluxo = tempResult.fluxo;
    this.velocidade = tempResult.velocidade;
    this.velocidadeVento = tempResult.velocidadeVento;
    this.direcaoVento = tempResult.direcaoVento;
    this.deltaT = tempResult.deltaT;
    this.temperatura = tempResult.temperatura;
    this.humidade = tempResult.humidade;

    this.seekSwap = null;

    return tempResult;
  };

  updateTime = (toTime) => {
    if (!this.state.data || !this.state.data.path || this.state.data.path.length < 3) return;

    const wasPlaying = this.state.play;

    this.run = false;
    this.new_run += 1;

    if (this.seekFinishFrame) {
      cancelAnimationFrame(this.seekFinishFrame);
      this.seekFinishFrame = null;
    }

    this.setState({ play: false, loading: true }, () => {
      this.play(false);

      this.runUpdate(toTime, wasPlaying, () => {
        this.isMovingBar = false;
      });
    });
  };

  runUpdate = (toTime, wasPlaying, callback) => {
    if (!this.state.data || !this.state.data.path || this.state.data.path.length < 3) {
      if (callback) callback();
      return;
    }

    const total = this.state.data.path.length - 2;
    let newTimeline = Math.round((this.state.valueBar / 1000) * total) + 1;

    if (typeof toTime === 'number') {
      newTimeline = toTime;
    }

    if (newTimeline < 1) newTimeline = 1;
    if (newTimeline > total) newTimeline = total;

    const currentTimeline = this.iPlay || 1;
    const diff = Math.abs(newTimeline - currentTimeline);

    if (newTimeline === currentTimeline) {
      this.clearSeekPreview();

      this.setState({
        play: wasPlaying,
        loading: false,
        end: newTimeline >= total,
        valueBar: Math.round((newTimeline / total) * 1000)
      }, () => {
        if (wasPlaying && newTimeline < total) {
          this.pathMap(this.state.data, this.iPlay, this.state.area);
        }
        if (callback) callback();
      });
      return;
    }

    if (diff <= 2) {
      this.iPlay = newTimeline;

      this.clearSeekPreview();

      this.setState({
        loading: false,
        play: false,
        end: newTimeline >= total,
        valueBar: Math.round((newTimeline / total) * 1000)
      }, () => {
        if (wasPlaying && newTimeline < total) {
          this.setState({ play: true }, () => {
            this.pathMap(this.state.data, this.iPlay, this.state.area);
            if (callback) callback();
          });
        } else {
          if (callback) callback();
        }
      });
      return;
    }

    this.run = false;
    this.new_run += 1;

    this.seekStateSnapshot = null;
    this.seekLine = null;

    this.prepareSeekSwap();

    this.setState({
      tiro: 0,
      time: 0,
      area: 0,
      correto: 0,
      fora: 0,
      sobre: 0,
      restante: 0,
      end: false,
      play: false,
      loading: true
    }, () => {
      this.exe(this.state.data, {
        autoPlay: false,
        startIndex: 1,
        startSize: 0,
        forcePlay: true,
        instant: true,
        silentSeek: true,
        stopAt: newTimeline,
        skipFitBounds: true,
        skipPolygons: true,
        skipChart: true,
        skipBarChart: true,
        skipPieChart: true,
        onStop: () => {
          const snapshot = this.seekStateSnapshot || {};

          this.finishSeekSwap();

          this.iPlay = newTimeline;

          this.seekFinishFrame = requestAnimationFrame(() => {
            this.setState({
              ...snapshot,
              play: false,
              loading: false,
              end: newTimeline >= total,
              valueBar: Math.round((newTimeline / total) * 1000)
            }, () => {
              this.seekLine = null;
              this.seekStateSnapshot = null;
              this.seekFinishFrame = null;

              this.updateMap('caminho', this.featureGroupL);
              this.updateMap('aplicacao', this.fGAPP[this.state.tab]);
              this.clearSeekPreview();

              if (wasPlaying && newTimeline < total) {
                this.setState({ play: true }, () => {
                  this.pathMap(this.state.data, this.iPlay, this.state.area);
                  if (callback) callback();
                });
              } else {
                if (callback) callback();
              }
            });
          });
        }
      });
    });
  };

  toggleSeekLayers = (show) => {
    if (!this.mymap) return;

    const featureGroupsAplicacao = [
      this.fGAPP['0'],
      this.fGAPP['1'],
      this.fGAPP['2'],
      this.fGAPP['3'],
      this.fGAPP['4'],
      this.fGAPP['5'],
      this.fGAPP['6'],
      this.fGAPP['7'],
      this.fGAPP['8']
    ];

    if (show) {
      if (this.state.tabMenu === '1') {
        if (this.featureGroupL && !this.mymap.hasLayer(this.featureGroupL)) {
          this.featureGroupL.addTo(this.mymap);
        }

        if (this.featureGroupI && !this.mymap.hasLayer(this.featureGroupI)) {
          this.featureGroupI.addTo(this.mymap);
        }

        const currentAppLayer = this.fGAPP[this.state.tab];
        if (currentAppLayer && !this.mymap.hasLayer(currentAppLayer)) {
          currentAppLayer.addTo(this.mymap);
        }
      }
    } else {
      if (this.featureGroupL && this.mymap.hasLayer(this.featureGroupL)) {
        this.mymap.removeLayer(this.featureGroupL);
      }

      if (this.featureGroupI && this.mymap.hasLayer(this.featureGroupI)) {
        this.mymap.removeLayer(this.featureGroupI);
      }

      for (let i = 0; i < featureGroupsAplicacao.length; i++) {
        if (featureGroupsAplicacao[i] && this.mymap.hasLayer(featureGroupsAplicacao[i])) {
          this.mymap.removeLayer(featureGroupsAplicacao[i]);
        }
      }
    }
  };

  clearAnimationMap = (callback) => {
    this.run = false;
    this.new_run += 1;

    if (this.featureGroupI) this.featureGroupI.clearLayers();
    if (this.featureGroupL) this.featureGroupL.clearLayers();

    if (this.fGAPP['0']) this.fGAPP['0'].clearLayers();
    if (this.fGAPP['1']) this.fGAPP['1'].clearLayers();
    if (this.fGAPP['2']) this.fGAPP['2'].clearLayers();
    if (this.fGAPP['3']) this.fGAPP['3'].clearLayers();
    if (this.fGAPP['4']) this.fGAPP['4'].clearLayers();
    if (this.fGAPP['5']) this.fGAPP['5'].clearLayers();
    if (this.fGAPP['6']) this.fGAPP['6'].clearLayers();
    if (this.fGAPP['7']) this.fGAPP['7'].clearLayers();
    if (this.fGAPP['8']) this.fGAPP['8'].clearLayers();

    this.featureAtual = {
      caminho: null,
      aplicacao: null,
      area: null,
    };

    this.marker = {
      base: null,
      marker: null,
      angle: 45
    };

    this.line = null;

    this.lineAltura = null;
    this.lineFluxo = null;
    this.lineVelocidade = null;
    this.lineVelocidadeVento = null;
    this.lineDirecaoVento = null;
    this.lineDeltaT = null;
    this.lineTemperatura = null;
    this.lineHumidade = null;

    this.altura = [];
    this.fluxo = [];
    this.velocidade = [];
    this.velocidadeVento = [];
    this.direcaoVento = [];
    this.deltaT = [];
    this.temperatura = [];
    this.humidade = [];

    this.seekLine = null;
    this.seekStateSnapshot = null;

    if (callback) callback();
  };

  polyMap = (poly) => {
    let myStyle = this.styles.area;
    let points = poly.poly;
    if (!points)
      points = JSON.parse(poly.points);
    let myLayer = L.polygon(points, myStyle);
    myLayer._leaflet_id = poly.guid;
    myLayer.addTo(this.featureGroupPoly);
    if (this.state.state === 1 || this.state.state === 0) {
      myLayer.bindTooltip(poly.name,
        { permanent: true, direction: "center", className: 'tool-tip-L tool-tip-size16-L' }
      ).openTooltip();
    }
  };
  restante = 0;//TODO: fix para a animage
  montaStaticData = (result) => {
    let tabMenuItens = this.state.tabMenuItens;
    tabMenuItens[0].active = true;
    tabMenuItens[1].active = true;
    if (tabMenuItens[2]) tabMenuItens[2].active = true;

    let tabItens = this.state.tabItens;
    tabItens[1].active = result.altura.length > 0 ? true : false;
    tabItens[2].active = result.fluxo.length > 0 ? true : false;
    tabItens[3].active = result.velocidade.length > 0 ? true : false;

    let tabItensVento = this.state.tabItensVento;
    tabItensVento[0].active = result.vento_velocidade.length > 0 ? true : false;
    tabItensVento[1].active = result.vento_angulo.length > 0 ? true : false;

    let tabItensDeltaT = this.state.tabItensDeltaT;
    tabItensDeltaT[1].active = result.temperatura.length > 0 ? true : false;
    tabItensDeltaT[2].active = result.humidade.length > 0 ? true : false;
    tabItensDeltaT[0].active = tabItensDeltaT[1].active && tabItensDeltaT[2].active;

    tabItens[4].active = tabItensVento[0].active || tabItensVento[1].active;
    tabItens[5].active = tabItensDeltaT[0].active || tabItensDeltaT[1].active || tabItensDeltaT[2].active;

    /*
    Índice de acerto: Aplicada interna / Aplicada * 100
    Índice de falha: (Talhão - (Aplicada interna -Sobreposta interna)) / Talhão * 100
    Índice de perda: (Sobreposta interna + (Aplicada - Aplicada interna - Aplicação carreador)) / Aplicada * 100
    Índice de uniformidade: (Aplicada interna - Sobreposta interna) / Talhão * 100
    */

    this.restante = result.total.restante;//TODO: fix para a animage

    const inVal = (result && result.total && isFinite(result.total.in)) ? result.total.in : 0;
    const overVal = (result && result.total && isFinite(result.total.over)) ? result.total.over : 0;

    const areaMissingOverRaw =
      (result && result.total && result.total.area_missing_over !== undefined && result.total.area_missing_over !== null && !isNaN(result.total.area_missing_over))
        ? Number(result.total.area_missing_over)
        : null;

    const areaBaseIndicesRaw =
      (result && result.total && result.total.area_base_indices && result.total.area_base_indices > 0)
        ? Number(result.total.area_base_indices)
        : null;

    const areaTotalRaw =
      (result && result.total && result.total.area ? Number(result.total.area) : 0);

    let areaBase = 0;

    if (areaBaseIndicesRaw !== null && isFinite(areaBaseIndicesRaw) && areaBaseIndicesRaw > 0) {
      areaBase = areaBaseIndicesRaw;
    } else if (areaMissingOverRaw !== null && isFinite(areaMissingOverRaw) && areaMissingOverRaw >= 0) {
      areaBase = (inVal - overVal) + areaMissingOverRaw;
    } else {
      areaBase = areaTotalRaw;
    }

    if (!isFinite(areaBase) || areaBase < 0) areaBase = 0;

    let restanteCalc = areaBase - inVal + overVal;

    if (!isFinite(restanteCalc) || restanteCalc < 0) restanteCalc = 0;

    if (areaMissingOverRaw !== null && isFinite(areaMissingOverRaw) && areaMissingOverRaw >= 0) {
      if (areaMissingOverRaw < restanteCalc) restanteCalc = areaMissingOverRaw;
    }

    let addCalc = isNaN(result.total.area_missing) || isNaN(result.total.area_missing_over) ? 0 : result.total.area_missing - result.total.area_missing_over;
    if (!isFinite(addCalc) || addCalc < 0) addCalc = 0;

    const cfluxo = result.total.fluxo.correto + (result.total.fluxo.aceitavel.up + result.total.fluxo.aceitavel.down) / 2;
    const tfluxo = result.total.fluxo.correto + result.total.fluxo.aceitavel.up + result.total.fluxo.aceitavel.down + result.total.fluxo.inaceitavel.up + result.total.fluxo.inaceitavel.down;
    const cAltura = result.total.altura.correto + (result.total.altura.aceitavel.up + result.total.altura.aceitavel.down) / 2;
    const tAltura = result.total.altura.correto + result.total.altura.aceitavel.up + result.total.altura.aceitavel.down + result.total.altura.inaceitavel.up + result.total.altura.inaceitavel.down;
    const cVelocidade = result.total.velocidade.correto + (result.total.velocidade.aceitavel.up + result.total.velocidade.aceitavel.down) / 2;
    const tVelocidade = result.total.velocidade.correto + result.total.velocidade.aceitavel.up + result.total.velocidade.aceitavel.down + result.total.velocidade.inaceitavel.up + result.total.velocidade.inaceitavel.down;
    const cVelocidadeV = result.total.vento_velocidade.correto + (result.total.vento_velocidade.aceitavel.up + result.total.vento_velocidade.aceitavel.down) / 2;
    const tVelocidadeV = result.total.vento_velocidade.correto + result.total.vento_velocidade.aceitavel.up + result.total.vento_velocidade.aceitavel.down + result.total.vento_velocidade.inaceitavel.up + result.total.vento_velocidade.inaceitavel.down;
    const cDirecaoV = (result.total.vento_angulo.correto.left + result.total.vento_angulo.correto.right) + (result.total.vento_angulo.aceitavel.left.up + result.total.vento_angulo.aceitavel.left.down) + (result.total.vento_angulo.aceitavel.right.up + result.total.vento_angulo.aceitavel.right.down) / 2;
    const tDirecaoV = (result.total.vento_angulo.correto.left + result.total.vento_angulo.correto.right) + (result.total.vento_angulo.aceitavel.left.up + result.total.vento_angulo.aceitavel.left.down + result.total.vento_angulo.inaceitavel.left.up + result.total.vento_angulo.inaceitavel.left.down) + (result.total.vento_angulo.aceitavel.right.up + result.total.vento_angulo.aceitavel.right.down + result.total.vento_angulo.inaceitavel.right.up + result.total.vento_angulo.inaceitavel.right.down);
    const cDeltaT = result.total.deltaT.correto + (result.total.deltaT.aceitavel.up + result.total.deltaT.aceitavel.down) / 2;
    const tDeltaT = result.total.deltaT.correto + result.total.deltaT.aceitavel.up + result.total.deltaT.aceitavel.down + result.total.deltaT.inaceitavel.up + result.total.deltaT.inaceitavel.down;
    const cTemperatura = result.total.temperatura.correto + (result.total.temperatura.aceitavel.up + result.total.temperatura.aceitavel.down) / 2;
    const tTemperatura = result.total.temperatura.correto + result.total.temperatura.aceitavel.up + result.total.temperatura.aceitavel.down + result.total.temperatura.inaceitavel.up + result.total.temperatura.inaceitavel.down;
    const cHumidade = result.total.humidade.correto + (result.total.humidade.aceitavel.up + result.total.humidade.aceitavel.down) / 2;
    const tHumidade = result.total.humidade.correto + result.total.humidade.aceitavel.up + result.total.humidade.aceitavel.down + result.total.humidade.inaceitavel.up + result.total.humidade.inaceitavel.down;
    const inMinusOver = (result && result.total) ? (result.total.in - result.total.over) : 0;

    let temp_uni = (areaBase > 0) ? Math.round((inMinusOver) / areaBase * 100) : 0;
    let temp_falha = (areaBase > 0) ? Math.round((areaBase - (inMinusOver)) / areaBase * 100) : 0;

    this.setState({
      polygons: result.polygons,
      timeS: result.total.tempo,
      areaS: result.total.app,
      corretoS: result.total.in,
      foraS: result.total.out,
      sobreS: result.total.over,

      restanteS: (restanteCalc > 0) ? restanteCalc : 0,
      app_extS: addCalc,
      tabMenu: '0',
      tabMenuItens: tabMenuItens,
      tabItens: tabItens,
      tabItensVento: tabItensVento,
      tabItensDeltaT: tabItensDeltaT,
      tabSubMenuD: tabItensDeltaT[0].active ? '0' : '1',
      gAcerto: Math.round(result.total.in / result.total.app * 100),
      gFalha: temp_falha < 100 ? temp_falha : 100,
      gPerda: Math.round((result.total.over + (result.total.app - result.total.in)) / result.total.app * 100),
      gUniformidade: temp_uni < 100 ? temp_uni : 100,

      gfluxo: Math.round(cfluxo / tfluxo * 100),
      gAltura: Math.round(cAltura / tAltura * 100),
      gVelocidade: Math.round(cVelocidade / tVelocidade * 100),
      gVelocidadeV: Math.round(cVelocidadeV / tVelocidadeV * 100),
      gDirecaoV: Math.round(cDirecaoV / tDirecaoV * 100),
      gDeltaT: Math.round(cDeltaT / tDeltaT * 100),
      gTemperatura: Math.round(cTemperatura / tTemperatura * 100),
      gHumidade: Math.round(cHumidade / tHumidade * 100),
    });

    if (Units.getAreaUnit(this.props.res) === 'ac') {
      this.updatePieChart([
        tools.ha_to_ac(result.total.in - result.total.over),
        tools.ha_to_ac(result.total.over),
        tools.ha_to_ac(result.total.out),
      ], 'aplicacao', '0');
      this.updatePieChart([
        tools.ha_to_ac(result.total.in - result.total.over),
        tools.ha_to_ac(addCalc > 0 ? addCalc : 0),
        tools.ha_to_ac(result.total.over),
        tools.ha_to_ac((restanteCalc > 0) ? restanteCalc : 0),
      ], 'area', '0');
      this.updatePieChart([
        tools.ha_to_ac(result.total.altura.correto),
        tools.ha_to_ac(result.total.altura.aceitavel.down),
        tools.ha_to_ac(result.total.altura.aceitavel.up),
        tools.ha_to_ac(result.total.altura.inaceitavel.down),
        tools.ha_to_ac(result.total.altura.inaceitavel.up),
      ], 'altura', '0');
      this.updatePieChart([
        tools.ha_to_ac(result.total.fluxo.correto),
        tools.ha_to_ac(result.total.fluxo.aceitavel.down),
        tools.ha_to_ac(result.total.fluxo.aceitavel.up),
        tools.ha_to_ac(result.total.fluxo.inaceitavel.down),
        tools.ha_to_ac(result.total.fluxo.inaceitavel.up),
      ], 'fluxo', '0');
      this.updatePieChart([
        tools.ha_to_ac(result.total.velocidade.correto),
        tools.ha_to_ac(result.total.velocidade.aceitavel.down),
        tools.ha_to_ac(result.total.velocidade.aceitavel.up),
        tools.ha_to_ac(result.total.velocidade.inaceitavel.down),
        tools.ha_to_ac(result.total.velocidade.inaceitavel.up),
      ], 'velocidade', '0');
      this.updatePieChart([
        tools.ha_to_ac(result.total.vento_velocidade.correto),
        tools.ha_to_ac(result.total.vento_velocidade.aceitavel.down),
        tools.ha_to_ac(result.total.vento_velocidade.aceitavel.up),
        tools.ha_to_ac(result.total.vento_velocidade.inaceitavel.down),
        tools.ha_to_ac(result.total.vento_velocidade.inaceitavel.up),
      ], 'velocidadeVento', '0');
      this.updatePieChart([
        tools.ha_to_ac(result.total.temperatura.correto),
        tools.ha_to_ac(result.total.temperatura.aceitavel.down),
        tools.ha_to_ac(result.total.temperatura.aceitavel.up),
        tools.ha_to_ac(result.total.temperatura.inaceitavel.down),
        tools.ha_to_ac(result.total.temperatura.inaceitavel.up),
      ], 'temperatura', '0');
      this.updatePieChart([
        tools.ha_to_ac(result.total.vento_angulo ? result.total.vento_angulo.correto.left + result.total.vento_angulo.correto.right : 0),
        tools.ha_to_ac(result.total.vento_angulo ? result.total.vento_angulo.aceitavel.left.down + result.total.vento_angulo.aceitavel.right.down : 0),
        tools.ha_to_ac(result.total.vento_angulo ? result.total.vento_angulo.aceitavel.left.up + result.total.vento_angulo.aceitavel.right.up : 0),
        tools.ha_to_ac(result.total.vento_angulo ? result.total.vento_angulo.inaceitavel.left.down + result.total.vento_angulo.inaceitavel.right.down : 0),
        tools.ha_to_ac(result.total.vento_angulo ? result.total.vento_angulo.inaceitavel.left.up + result.total.vento_angulo.inaceitavel.right.up : 0),
      ], 'direcaoVento', '0');
      this.updatePieChart([
        tools.ha_to_ac(result.total.deltaT.correto),
        tools.ha_to_ac(result.total.deltaT.aceitavel.down + result.total.deltaT.aceitavel.up),
        tools.ha_to_ac(0),
        tools.ha_to_ac(result.total.deltaT.inaceitavel.down + result.total.deltaT.inaceitavel.up),
        tools.ha_to_ac(0),
      ], 'deltaT', '0');
      this.updatePieChart([
        tools.ha_to_ac(result.total.humidade.correto),
        tools.ha_to_ac(result.total.humidade.aceitavel.down),
        tools.ha_to_ac(result.total.humidade.aceitavel.up),
        tools.ha_to_ac(result.total.humidade.inaceitavel.down),
        tools.ha_to_ac(result.total.humidade.inaceitavel.up),
      ], 'humidade', '0');
    } else {
      this.updatePieChart([result.total.in - result.total.over, result.total.over, result.total.out], 'aplicacao', '0');
      this.updatePieChart([result.total.in - result.total.over, addCalc > 0 ? addCalc : 0, result.total.over, (restanteCalc > 0) ? restanteCalc : 0], 'area', '0');
      this.updatePieChart([
        result.total.altura.correto,
        result.total.altura.aceitavel.down,
        result.total.altura.aceitavel.up,
        result.total.altura.inaceitavel.down,
        result.total.altura.inaceitavel.up,
      ], 'altura', '0');
      this.updatePieChart([
        result.total.fluxo.correto,
        result.total.fluxo.aceitavel.down,
        result.total.fluxo.aceitavel.up,
        result.total.fluxo.inaceitavel.down,
        result.total.fluxo.inaceitavel.up,
      ], 'fluxo', '0');
      this.updatePieChart([
        result.total.velocidade.correto,
        result.total.velocidade.aceitavel.down,
        result.total.velocidade.aceitavel.up,
        result.total.velocidade.inaceitavel.down,
        result.total.velocidade.inaceitavel.up,
      ], 'velocidade', '0');
      this.updatePieChart([
        result.total.vento_velocidade.correto,
        result.total.vento_velocidade.aceitavel.down,
        result.total.vento_velocidade.aceitavel.up,
        result.total.vento_velocidade.inaceitavel.down,
        result.total.vento_velocidade.inaceitavel.up,
      ], 'velocidadeVento', '0');
      this.updatePieChart([
        result.total.temperatura.correto,
        result.total.temperatura.aceitavel.down,
        result.total.temperatura.aceitavel.up,
        result.total.temperatura.inaceitavel.down,
        result.total.temperatura.inaceitavel.up,
      ], 'temperatura', '0');
      this.updatePieChart([
        result.total.vento_angulo ? result.total.vento_angulo.correto.left + result.total.vento_angulo.correto.right : 0,
        result.total.vento_angulo ? result.total.vento_angulo.aceitavel.left.down + result.total.vento_angulo.aceitavel.right.down : 0,
        result.total.vento_angulo ? result.total.vento_angulo.aceitavel.left.up + result.total.vento_angulo.aceitavel.right.up : 0,
        result.total.vento_angulo ? result.total.vento_angulo.inaceitavel.left.down + result.total.vento_angulo.inaceitavel.right.down : 0,
        result.total.vento_angulo ? result.total.vento_angulo.inaceitavel.left.up + result.total.vento_angulo.inaceitavel.right.up : 0,
      ], 'direcaoVento', '0');
      this.updatePieChart([
        result.total.deltaT.correto,
        result.total.deltaT.aceitavel.down + result.total.deltaT.aceitavel.up,
        0,
        result.total.deltaT.inaceitavel.down + result.total.deltaT.inaceitavel.up,
        0,
      ], 'deltaT', '0');
      this.updatePieChart([
        result.total.humidade.correto,
        result.total.humidade.aceitavel.down,
        result.total.humidade.aceitavel.up,
        result.total.humidade.inaceitavel.down,
        result.total.humidade.inaceitavel.up,
      ], 'humidade', '0');
    }

    for (let i = 0; i < result.polygons.length; i++) {
      const element = result.polygons[i];
      let poly = JSON.parse(element.points);

      let myStyle = this.styles.area_static;
      let myLayer = L.polygon(poly, myStyle);

      this.polyNames[element.guid + '_h'] = element.name;
      myLayer._leaflet_id = element.guid + '_h';

      //myLayer.addTo(this.fGAPPS['0']); //fG de aplicacao
      //myLayer.addTo(this.fGAPPS['1']); //fG de altura
      //myLayer.addTo(this.fGAPPS['2']); //fG de fluxo
      //myLayer.addTo(this.fGAPPS['3']); //fG de velocidade
      //myLayer.addTo(this.fGAPPS['4']); //fG de velocidade vento
      //myLayer.addTo(this.fGAPPS['5']); //fG de direcao vento
      //myLayer.addTo(this.fGAPPS['6']); //fG de deltaT
      //myLayer.addTo(this.fGAPPS['7']); //fG de temperatura
      //myLayer.addTo(this.fGAPPS['8']); //fG de humidade

      myLayer = L.polygon(poly, this.styles.area);
      this.polyNames[element.guid] = element.name;
      myLayer._leaflet_id = element.guid;
      myLayer.addTo(this.featureGroupPolyS);//fG de area

      myLayer.bindTooltip(element.name,
        { permanent: true, direction: "center", className: 'tool-tip-L tool-tip-size16-L' }
      ).openTooltip();
    }

    //linha do caminho
    let line = new L.polyline(result.path, this.styles.linha);
    line.addTo(this.featureGroupLS);
    //polygon de aplicacao correto
    for (let i = 0; i < result.app.length; i++) {
      const element = result.app[i];
      if (element.right.points.length > 1) {
        let right = JSON.parse(JSON.stringify(element.right.points));
        right.reverse();
        let left = JSON.parse(JSON.stringify(element.left.points));
        const latlng = left.concat(right);
        const poly = L.polygon(latlng, this.styles.correto_static);
        poly._leaflet_id = `ctiro${i}`;
        if (poly) {
          const pop = this.props.res.AREA + ': ' +
            `${Units.formatValue(Units.convertArea(L.GeometryUtil.geodesicArea(poly.getLatLngs()[0]), 'm2', this.props.res), this.props.res, 1)} ${Units.getAreaUnit(this.props.res)}`;
          poly.bindPopup(pop);
        }
        poly.addTo(this.fGAPPS['0']);
      }
    }
    //polygon de aplicacao fora da area
    for (let i = 0; i < result.fora.length; i++) {
      const element = result.fora[i];
      if (element.right.points.length > 1) {
        let right = JSON.parse(JSON.stringify(element.right.points));
        right.reverse();
        let left = JSON.parse(JSON.stringify(element.left.points));
        const latlng = left.concat(right);
        const poly = L.polygon(latlng, this.styles.fora_static);
        poly._leaflet_id = `ftiro${i}`;
        if (poly) {
          const pop = this.props.res.AREA + ': ' +
            `${Units.formatValue(Units.convertArea(L.GeometryUtil.geodesicArea(poly.getLatLngs()[0]), 'm2', this.props.res), this.props.res, 1)} ${Units.getAreaUnit(this.props.res)}`;
          poly.bindPopup(pop);
        }
        poly.addTo(this.fGAPPS['0']);
      }
    }
    //polygon de aplicacao sobreposicao
    for (let i = 0; i < result.sobre.length; i++) {
      const element = result.sobre[i];
      if (element.geometry) {
        const geometryLayer = L.geoJSON(element.geometry, { style: this.styles.sobre_static });
        geometryLayer.eachLayer((layer) => {
          layer.bindPopup(this.getOverlapPopup);
        });
        geometryLayer.addTo(this.fGAPPS['0']);
        continue;
      }
      const leftPoints = Array.isArray(element.left_points) ? element.left_points : [];
      const rightPoints = Array.isArray(element.right_points) ? element.right_points : [];
      const latlng = rightPoints.length > 0
        ? leftPoints.concat(rightPoints)
        : leftPoints;
      if (latlng.length >= 3) {
        const poly = L.polygon(latlng, this.styles.sobre_static);
        poly._leaflet_id = `stiro${i}`;
        if (poly) {
          poly.bindPopup(this.getOverlapPopup);

          /*poly.on('click', () => {
            console.log('right',right.map(i => ([i[1],i[0]])));
            console.log('left',left.map(i => ([i[1],i[0]])));
          });*/
        }
        poly.addTo(this.fGAPPS['0']);
      }
    }
    //polygon de area nao aplicada
    if (result.missing) {
      for (let i = 0; i < result.missing.length; i++) {
        const element = result.missing[i];
        const poly = L.polygon(element.points, this.styles.area_static);
        //let myLayer = L.geoJSON(element.poly, { style: this.styles.area_static });
        if (poly) {
          const pop = this.props.res.AREA + ': ' +
            `${Units.formatValue(Units.convertArea(element.area, 'm2', this.props.res), this.props.res, 1)} ${Units.getAreaUnit(this.props.res)}`;
          poly.bindPopup(pop);
        }
        poly.addTo(this.fGAPPS['0']);
      }
    }

    if (result.app_add) {
      for (let i = 0; i < result.app_add.length; i++) {
        const element = result.app_add[i];
        const poly = L.polygon(element.points, this.styles.app_add_static);
        if (poly) {
          const pop = this.props.res.AREA + ': ' +
            `${Units.formatValue(Units.convertArea(element.area, 'm2', this.props.res), this.props.res, 1)} ${Units.getAreaUnit(this.props.res)}`;
          poly.bindPopup(pop);
        }
        poly.addTo(this.fGAPPS['0']);
      }
    }

    this.updateMap('area', this.featureGroupPolyS);
    this.updateMap('aplicacao', this.fGAPPS['0']);
    //this.featureGroupLS.addTo(this.mymap);
    this.updateMap('caminho', this.featureGroupLS);

    let temp_altura, temp_fluxo, temp_velocidade, temp_velocidadeVento, temp_temperatura;


    temp_altura = (result.altura || []).map(el => ({
      ...el,
      item: (el.item || []).map(el2 => ({
        ...el2,
        valor: (el2.valor || []).map(a => Units.convertLength(a, 'm', this.props.res)),
        setValor: (el2.setValor || []).map(a => Units.convertLength(a, 'm', this.props.res))
      }))
    }));
    temp_fluxo = (result.fluxo || []).map(el => ({
      ...el,
      item: (el.item || []).map(el2 => ({
        ...el2,
        valor: (el2.valor || []).map(a => Units.convertFlow(a, 'L', 'ha', this.props.res)),
        setValor: (el2.setValor || []).map(a => Units.convertFlow(a, 'L', 'ha', this.props.res))
      }))
    }));
    temp_velocidade = (result.velocidade || []).map(el => ({
      ...el,
      item: (el.item || []).map(el2 => ({
        ...el2,
        valor: (el2.valor || []).map(a => Units.convertSpeed(a, 'km/h', this.props.res)),
        setValor: (el2.setValor || []).map(a => Units.convertSpeed(a, 'km/h', this.props.res))
      }))
    }));
    temp_velocidadeVento = (result.vento_velocidade || []).map(el => ({
      ...el,
      item: (el.item || []).map(el2 => ({
        ...el2,
        valor: (el2.valor || []).map(a => Units.convertSpeed(a, 'km/h', this.props.res)),
        setValor: (el2.setValor || []).map(a => Units.convertSpeed(a, 'km/h', this.props.res))
      }))
    }));
    temp_temperatura = this.props.res.LINGUA === 'en-US' ? (result.temperatura || []).map(el => ({
      ...el,
      item: (el.item || []).map(el2 => ({
        ...el2,
        valor: (el2.valor || []).map(a => tools.c_to_f(a)),
        setValor: (el2.setValor || []).map(a => tools.c_to_f(a))
      }))
    })) : result.temperatura;

    const alturaSetDisplay = this.state.checkConfig[1] ? Number(this.state.alturaSet) : null;
    const fluxoSetDisplay = this.state.checkConfig[2] ? Number(this.state.fluxoSet) : null;
    const fluxoDefaultDisplay = result.data.fluxoDefault > 0
      ? Units.convertFlow(result.data.fluxoDefault, 'L', 'ha', this.props.res)
      : (Number(this.state.fluxoSet) > 0 ? Number(this.state.fluxoSet) : null);
    const velocidadeSetDisplay = this.state.checkConfig[3] ? Number(this.state.velocidadeSet) : null;

    const alturaMargemDownStatic = Number(this.state.alturaMargemDown && this.state.alturaMargemDown.value) || 0;
    const alturaMargemUpStatic = Number(this.state.alturaMargemUp && this.state.alturaMargemUp.value) || 0;
    const alturaLimiteDownStatic = Number(this.state.alturaLimiteDown && this.state.alturaLimiteDown.value) || 0;
    const alturaLimiteUpStatic = Number(this.state.alturaLimiteUp && this.state.alturaLimiteUp.value) || 0;

    const fluxoMargemDownStatic = Number(this.state.fluxoMargemDown && this.state.fluxoMargemDown.value) || 0;
    const fluxoMargemUpStatic = Number(this.state.fluxoMargemUp && this.state.fluxoMargemUp.value) || 0;
    const fluxoLimiteDownStatic = Number(this.state.fluxoLimiteDown && this.state.fluxoLimiteDown.value) || 0;
    const fluxoLimiteUpStatic = Number(this.state.fluxoLimiteUp && this.state.fluxoLimiteUp.value) || 0;

    const velocidadeMargemDownStatic = Number(this.state.velocidadeMargemDown && this.state.velocidadeMargemDown.value) || 0;
    const velocidadeMargemUpStatic = Number(this.state.velocidadeMargemUp && this.state.velocidadeMargemUp.value) || 0;
    const velocidadeLimiteDownStatic = Number(this.state.velocidadeLimiteDown && this.state.velocidadeLimiteDown.value) || 0;
    const velocidadeLimiteUpStatic = Number(this.state.velocidadeLimiteUp && this.state.velocidadeLimiteUp.value) || 0;

    temp_altura = this.applyStaticQualityColors(
      temp_altura,
      alturaMargemDownStatic,
      alturaMargemUpStatic,
      alturaLimiteDownStatic,
      alturaLimiteUpStatic,
      alturaSetDisplay
    );

    temp_fluxo = this.applyStaticQualityColors(
      temp_fluxo,
      fluxoMargemDownStatic,
      fluxoMargemUpStatic,
      fluxoLimiteDownStatic,
      fluxoLimiteUpStatic,
      fluxoSetDisplay,
      fluxoDefaultDisplay
    );

    temp_velocidade = this.applyStaticQualityColors(
      temp_velocidade,
      velocidadeMargemDownStatic,
      velocidadeMargemUpStatic,
      velocidadeLimiteDownStatic,
      velocidadeLimiteUpStatic,
      velocidadeSetDisplay
    );


    const areaTotalAplicadaQualidade = (result && result.total && typeof result.total.app === 'number')
      ? result.total.app
      : 0;

    const alturaStaticStats = this.calculateStaticQualityStats(
      temp_altura,
      alturaMargemDownStatic,
      alturaMargemUpStatic,
      alturaLimiteDownStatic,
      alturaLimiteUpStatic,
      areaTotalAplicadaQualidade,
      alturaSetDisplay
    );

    const fluxoStaticStats = this.calculateStaticQualityStats(
      temp_fluxo,
      fluxoMargemDownStatic,
      fluxoMargemUpStatic,
      fluxoLimiteDownStatic,
      fluxoLimiteUpStatic,
      areaTotalAplicadaQualidade,
      fluxoSetDisplay,
      fluxoDefaultDisplay
    );

    const velocidadeStaticStats = this.calculateStaticQualityStats(
      temp_velocidade,
      velocidadeMargemDownStatic,
      velocidadeMargemUpStatic,
      velocidadeLimiteDownStatic,
      velocidadeLimiteUpStatic,
      areaTotalAplicadaQualidade,
      velocidadeSetDisplay
    );

    const fluxoPorSetStatic = {};
    const fluxoSetsAplicacaoStatic = [];
    if (temp_fluxo && temp_fluxo.length > 0) {
      let totalPontos = 0;

      for (let i = 0; i < temp_fluxo.length; i++) {
        const grupo = temp_fluxo[i];
        if (!grupo || !grupo.item || !grupo.item.length) continue;

        for (let j = 0; j < grupo.item.length; j++) {
          const item = grupo.item[j];
          if (!item || !item.valor || !item.valor.length || !item.setValor || !item.setValor.length) continue;

          const tam = Math.min(item.valor.length, item.setValor.length);
          totalPontos += tam;
        }
      }

      const areaTotalAplicada = (result && result.total && typeof result.total.app === 'number') ? result.total.app : 0;
      const areaPorPonto = totalPontos > 0 ? (areaTotalAplicada / totalPontos) : 0;

      const minOffset = fluxoMargemDownStatic;
      const maxOffset = fluxoMargemUpStatic;
      const limiteMin = fluxoLimiteDownStatic;
      const limiteMax = fluxoLimiteUpStatic;

      for (let i = 0; i < temp_fluxo.length; i++) {
        const grupo = temp_fluxo[i];
        if (!grupo || !grupo.item || !grupo.item.length) continue;

        for (let j = 0; j < grupo.item.length; j++) {
          const item = grupo.item[j];
          if (!item || !item.valor || !item.valor.length || !item.setValor || !item.setValor.length) continue;

          const tam = Math.min(item.valor.length, item.setValor.length);
          for (let k = 0; k < tam; k++) {
            const setValorRaw = Number(item.setValor[k]);
            const valor = Number(item.valor[k]);
            if (isNaN(setValorRaw) || isNaN(valor)) continue;

            const setValor = this.normalizeQualitySetValue(setValorRaw);
            const chave = String(setValor);
            if (!fluxoPorSetStatic[chave]) {
              fluxoPorSetStatic[chave] = {
                set: setValor,
                pontos: 0,
                media: 0,
                min: 0,
                max: 0,
                area: 0,
                correto: 0,
                aceitavelInf: 0,
                aceitavelSup: 0,
                incorretaInf: 0,
                incorretaSup: 0,
                soma: 0
              };
            }

            const stats = fluxoPorSetStatic[chave];

            stats.pontos += 1;
            stats.area += areaPorPonto;
            stats.soma += valor;

            if (stats.pontos === 1) {
              stats.min = valor;
              stats.max = valor;
            } else {
              if (valor < stats.min) stats.min = valor;
              if (valor > stats.max) stats.max = valor;
            }

            const min = setValor - minOffset - limiteMin;
            const minT = setValor - minOffset;
            const maxT = setValor + maxOffset;
            const max = setValor + maxOffset + limiteMax;

            if (valor >= minT && valor <= maxT) {
              stats.correto += areaPorPonto;
            } else if (valor > max) {
              stats.incorretaSup += areaPorPonto;
            } else if (valor > maxT) {
              stats.aceitavelSup += areaPorPonto;
            } else if (valor < min) {
              stats.incorretaInf += areaPorPonto;
            } else if (valor < minT) {
              stats.aceitavelInf += areaPorPonto;
            }
          }
        }
      }

      const chaves = Object.keys(fluxoPorSetStatic);
      for (let i = 0; i < chaves.length; i++) {
        const chave = chaves[i];
        const stats = fluxoPorSetStatic[chave];
        stats.media = stats.pontos > 0 ? (stats.soma / stats.pontos) : 0;
        delete stats.soma;
        fluxoSetsAplicacaoStatic.push(stats.set);
      }

      fluxoSetsAplicacaoStatic.sort((a, b) => a - b);
    }

    const staticQualityState = {
      fluxoSetsAplicacaoStatic: fluxoSetsAplicacaoStatic,
      fluxoPorSetStatic: fluxoPorSetStatic
    };

    if (alturaStaticStats.pontos > 0) {
      staticQualityState.corretoAltS = alturaStaticStats.correto;
      staticQualityState.aceitavelAltInfS = alturaStaticStats.aceitavelInf;
      staticQualityState.aceitavelAltSupS = alturaStaticStats.aceitavelSup;
      staticQualityState.incorretaAltInfS = alturaStaticStats.incorretaInf;
      staticQualityState.incorretaAltSupS = alturaStaticStats.incorretaSup;
    }

    if (fluxoStaticStats.pontos > 0) {
      staticQualityState.corretoFlxS = fluxoStaticStats.correto;
      staticQualityState.aceitavelFlxInfS = fluxoStaticStats.aceitavelInf;
      staticQualityState.aceitavelFlxSupS = fluxoStaticStats.aceitavelSup;
      staticQualityState.incorretaFlxInfS = fluxoStaticStats.incorretaInf;
      staticQualityState.incorretaFlxSupS = fluxoStaticStats.incorretaSup;
    }

    if (velocidadeStaticStats.pontos > 0) {
      staticQualityState.corretoVlcS = velocidadeStaticStats.correto;
      staticQualityState.aceitavelVlcInfS = velocidadeStaticStats.aceitavelInf;
      staticQualityState.aceitavelVlcSupS = velocidadeStaticStats.aceitavelSup;
      staticQualityState.incorretaVlcInfS = velocidadeStaticStats.incorretaInf;
      staticQualityState.incorretaVlcSupS = velocidadeStaticStats.incorretaSup;
    }

    this.setState(staticQualityState, () => {
      if (alturaStaticStats.pontos > 0) {
        this.updatePieChart([
          alturaStaticStats.correto,
          alturaStaticStats.aceitavelInf,
          alturaStaticStats.aceitavelSup,
          alturaStaticStats.incorretaInf,
          alturaStaticStats.incorretaSup
        ], 'altura', '0', undefined, true);
      }

      if (fluxoStaticStats.pontos > 0) {
        this.updatePieChart([
          fluxoStaticStats.correto,
          fluxoStaticStats.aceitavelInf,
          fluxoStaticStats.aceitavelSup,
          fluxoStaticStats.incorretaInf,
          fluxoStaticStats.incorretaSup
        ], 'fluxo', '0', undefined, true);
      }

      if (velocidadeStaticStats.pontos > 0) {
        this.updatePieChart([
          velocidadeStaticStats.correto,
          velocidadeStaticStats.aceitavelInf,
          velocidadeStaticStats.aceitavelSup,
          velocidadeStaticStats.incorretaInf,
          velocidadeStaticStats.incorretaSup
        ], 'velocidade', '0', undefined, true);
      }

      this.syncPieChartsFluxoPorSetStatic();
    });

    //polygon de altura da aplicacao 
    this.mapLines(temp_altura, 'altura', this.alturaS, '1');
    //polygon de fluxo da aplicacao 
    this.mapLines(temp_fluxo, 'fluxo', this.fluxoS, '2');
    //polygon de velocidade da aplicacao 
    this.mapLines(temp_velocidade, 'velocidade', this.velocidadeS, '3');
    //polygon de velocidade do vento da aplicacao 
    this.mapLines(temp_velocidadeVento, 'velocidadeVento', this.velocidadeVentoS, '4');
    //polygon de velocidade do vento da aplicacao 
    this.mapLines(result.vento_angulo, 'direcaoVento', this.direcaoVentoS, '5');
    //polygon de velocidade do vento da aplicacao 
    this.mapLines(result.deltaT, 'deltaT', this.deltaTS, '6');
    //polygon de velocidade do vento da aplicacao 
    this.mapLines(temp_temperatura, 'temperatura', this.temperaturaS, '7');
    //polygon de velocidade do vento da aplicacao 
    this.mapLines(result.humidade, 'humidade', this.humidadeS, '8');

    this.mymap.fitBounds(this.featureGroupLS.getBounds());
    this.updateAllSwathWidths();
  };

  mountListPerfis = () => {
    let url = Config.server + '/itens_profile_auto';
    let method = 'GET';

    let options = {
      method: method,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };
    fetch(url, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();

      })
      .then(
        (result) => {
          if (result) {
            if (result.length > 0) {
              if (result.length > 0 && typeof result[0].rel_config === 'string') {
                for (let i = 0; i < result.length; i++) {
                  result[i].rel_config = JSON.parse(result[i].rel_config);
                }
              }
              const normalizeProfileName = (value) => String(value == null ? '' : value)
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .trim()
                .toLowerCase();

              const defaultProfile = result.find((item) =>
                item && normalizeProfileName(item.name) === 'padrao'
              ) || result[0];

              this.setState({
                listPerfis: result,
                selectedPerfil: defaultProfile.id
              }, () => {
                this.selectPerfil(defaultProfile);
              });
            }
          } else {
            this.setState({ progress: false });
            notification.open({
              message: this.props.res.ARQUIVO_INVALIDO,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 400) {
            notification.open({
              message: this.props.res[error.statusText],
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  selectPerfil = (perfil, callback) => {
    if (!perfil) {
      if (callback) callback();
      return;
    }

    const update = {};
    const checkConfig = Array.isArray(this.state.checkConfig)
      ? [...this.state.checkConfig]
      : [false, false, false, false, false];

    if (perfil.rel_config && perfil.rel_config.larguraExd != null) {
      update.larguraExd = perfil.rel_config.larguraExd;
    }

    const params = Array.isArray(perfil.params) ? perfil.params : [];
    const res = this.props.res;

    const numberOrZero = (value) => {
      const number = Number(value);
      return Number.isFinite(number) ? number : 0;
    };

    const applyRange = (prefix, setValue, marginDown, marginUp, limitDown, limitUp) => {
      update[prefix + 'MargemDown'] = {
        value: marginDown,
        text: setValue - marginDown,
        valid: true
      };
      update[prefix + 'MargemUp'] = {
        value: marginUp,
        text: setValue + marginUp,
        valid: true
      };
      update[prefix + 'LimiteDown'] = {
        value: limitDown,
        text: setValue - marginDown - limitDown,
        valid: true
      };
      update[prefix + 'LimiteUp'] = {
        value: limitUp,
        text: setValue + marginUp + limitUp,
        valid: true
      };
    };

    for (let i = 0; i < params.length; i++) {
      const item = params[i];
      if (!item || !item.type) continue;

      const setCanonical = numberOrZero(item.set_a);
      const marginDownCanonical = numberOrZero(item.margin_down);
      const marginUpCanonical = numberOrZero(item.margin_up);
      const limitDownCanonical = numberOrZero(item.limit_down);
      const limitUpCanonical = numberOrZero(item.limit_up);

      if (item.type === 'altura') {
        checkConfig[1] = setCanonical > 0;

        const currentSet = numberOrZero(this.state.alturaSet);
        const setValue = setCanonical > 0
          ? Units.convertLength(setCanonical, 'm', res)
          : currentSet;

        const marginDown = Units.convertLength(marginDownCanonical, 'm', res);
        const marginUp = Units.convertLength(marginUpCanonical, 'm', res);
        const limitDown = Units.convertLength(limitDownCanonical, 'm', res);
        const limitUp = Units.convertLength(limitUpCanonical, 'm', res);

        if (setCanonical > 0) update.alturaSet = setValue;
        applyRange('altura', setValue, marginDown, marginUp, limitDown, limitUp);
      } else if (item.type === 'fluxo') {
        checkConfig[2] = setCanonical > 0;

        const currentSet = numberOrZero(this.state.fluxoSet);
        const setValue = setCanonical > 0
          ? Units.convertFlow(setCanonical, 'L', 'ha', res)
          : currentSet;

        const marginDown = Units.convertFlow(marginDownCanonical, 'L', 'ha', res);
        const marginUp = Units.convertFlow(marginUpCanonical, 'L', 'ha', res);
        const limitDown = Units.convertFlow(limitDownCanonical, 'L', 'ha', res);
        const limitUp = Units.convertFlow(limitUpCanonical, 'L', 'ha', res);

        if (setCanonical > 0) update.fluxoSet = setValue;
        applyRange('fluxo', setValue, marginDown, marginUp, limitDown, limitUp);
      } else if (item.type === 'velocidade') {
        checkConfig[3] = setCanonical > 0;

        const currentSet = numberOrZero(this.state.velocidadeSet);
        const setValue = setCanonical > 0
          ? Units.convertSpeed(setCanonical, 'km/h', res)
          : currentSet;

        const marginDown = Units.convertSpeed(marginDownCanonical, 'km/h', res);
        const marginUp = Units.convertSpeed(marginUpCanonical, 'km/h', res);
        const limitDown = Units.convertSpeed(limitDownCanonical, 'km/h', res);
        const limitUp = Units.convertSpeed(limitUpCanonical, 'km/h', res);

        if (setCanonical > 0) update.velocidadeSet = setValue;
        applyRange('velocidade', setValue, marginDown, marginUp, limitDown, limitUp);
      } else if (item.type === 'velocidadeV') {
        const currentSet = numberOrZero(this.state.velocidadeVSet);
        const setValue = setCanonical > 0
          ? Units.convertSpeed(setCanonical, 'km/h', res)
          : currentSet;

        const marginDown = Units.convertSpeed(marginDownCanonical, 'km/h', res);
        const marginUp = Units.convertSpeed(marginUpCanonical, 'km/h', res);
        const limitDown = Units.convertSpeed(limitDownCanonical, 'km/h', res);
        const limitUp = Units.convertSpeed(limitUpCanonical, 'km/h', res);

        if (setCanonical > 0) update.velocidadeVSet = setValue;
        applyRange('velocidadeV', setValue, marginDown, marginUp, limitDown, limitUp);
      } else if (item.type === 'temperatura') {
        const currentSet = numberOrZero(this.state.temperaturaSet);
        const setValue = setCanonical !== 0
          ? (res.LINGUA === 'en-US' ? tools.c_to_f(setCanonical) : setCanonical)
          : currentSet;

        if (res.LINGUA === 'en-US') {
          const marginDown = tools.c_to_f(setCanonical) - tools.c_to_f(setCanonical - marginDownCanonical);
          const marginUp = tools.c_to_f(setCanonical + marginUpCanonical) - tools.c_to_f(setCanonical);
          const limitDown =
            tools.c_to_f(setCanonical - marginDownCanonical) -
            tools.c_to_f(setCanonical - marginDownCanonical - limitDownCanonical);
          const limitUp =
            tools.c_to_f(setCanonical + marginUpCanonical + limitUpCanonical) -
            tools.c_to_f(setCanonical + marginUpCanonical);

          if (setCanonical !== 0) update.temperaturaSet = setValue;
          applyRange('temperatura', setValue, marginDown, marginUp, limitDown, limitUp);
        } else {
          if (setCanonical !== 0) update.temperaturaSet = setValue;
          applyRange(
            'temperatura',
            setValue,
            marginDownCanonical,
            marginUpCanonical,
            limitDownCanonical,
            limitUpCanonical
          );
        }
      } else if (item.type === 'umidade') {
        const setValue = setCanonical !== 0 ? setCanonical : numberOrZero(this.state.umidadeSet);
        if (setCanonical !== 0) update.umidadeSet = setValue;
        applyRange(
          'umidade',
          setValue,
          marginDownCanonical,
          marginUpCanonical,
          limitDownCanonical,
          limitUpCanonical
        );
      } else if (item.type === 'angulo') {
        update.anguloVMargemDown = {
          value: marginDownCanonical,
          text: marginDownCanonical,
          valid: true
        };
        update.anguloVMargemUp = {
          value: marginUpCanonical,
          text: marginUpCanonical,
          valid: true
        };
        update.anguloVLimiteDown = {
          value: limitDownCanonical,
          text: marginDownCanonical + limitDownCanonical,
          valid: true
        };
        update.anguloVLimiteUp = {
          value: limitUpCanonical,
          text: marginUpCanonical + limitUpCanonical,
          valid: true
        };
        update.espelharAnguloV =
          marginDownCanonical === marginUpCanonical &&
          limitDownCanonical === limitUpCanonical;
      }
    }

    update.checkConfig = checkConfig;
    this.setState(update, callback);
  };

  loadResultProfile = (profileName, callback) => {
    const apiUrl = Config.server + '/itens_profile_auto';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((profiles) => {
        const list = Array.isArray(profiles) ? profiles : [];

        for (let i = 0; i < list.length; i++) {
          if (typeof list[i].rel_config === 'string') {
            try {
              list[i].rel_config = JSON.parse(list[i].rel_config);
            } catch (e) {
              list[i].rel_config = null;
            }
          }
        }

        if (!list.length) {
          callback && callback();
          return;
        }

        const normalizeProfileName = (value) => String(value == null ? '' : value)
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim()
          .toLowerCase();

        const requestedName = normalizeProfileName(profileName);
        const customName = normalizeProfileName(this.props.res.CUSTOMIZADO);

        let profile = null;

        if (requestedName && requestedName !== customName) {
          profile = list.find((item) =>
            item && normalizeProfileName(item.name) === requestedName
          );
        }

        if (!profile) {
          profile = list.find((item) =>
            item && normalizeProfileName(item.name) === 'padrao'
          );
        }
        if (!profile) {
          profile = list[0];
        }

        this.setState({
          listPerfis: list,
          selectedPerfil: profile.id,
          nomePerfil: profile.name
        }, () => {
          this.selectPerfil(profile, callback);
        });
      })
      .catch(() => {
        callback && callback();
      });
  };

  mapLines = (itens, type, rvar, fg) => {
    rvar.length = 0;
    for (let i = 0; i < itens.length; i++) {
      let valores = { index: i, setValue: [], value: [], color: [], b: [], type: type };
      if (type === 'direcaoVento') {
        valores.plane_direction = [];
        valores.wind_direction = [];
      }
      let line = [];
      for (let j = 0; j < itens[i].item.length; j++) {
        const element = itens[i].item[j];
        const anchor = this.getSwathAnchor(element.points);
        const last = L.polyline(element.points, {
          color: element.color,
          weight: this.getSwathPixelWidth(element.weight, anchor),
          lineCap: 'butt',
          opacity: 1,
          smoothFactor: 1
        });
        last._swathWidth = element.weight;
        last._swathAnchor = anchor;
        rvar.push({ index: rvar.length, item: [last], largura: element.weight, anchor: anchor });

        for (let k = 0; k < element.valor.length; k++) {
          valores.setValue.push(element.setValor[k]);
          valores.value.push(element.valor[k]);
          valores.color.push(element.color);
          valores.b.push('');
          if (element.addValue) {
            if (!valores.addValue) {
              valores.addValue = [];
            }
            valores.addValue.push(element.addValue[k]);
          }

          if (type === 'direcaoVento') {
            if (element.plane_direction) {
              valores.plane_direction.push(element.plane_direction[k]);
            }
            if (element.wind_direction) {
              valores.wind_direction.push(element.wind_direction[k]);
            } else {
              valores.wind_direction.push(element.direcao[k]);
            }
          }
        }
        if (!this.values[type]) {
          this.values[type] = [];
        }

        last._leaflet_id = `vtiro/${i}/${j}`;
        line.push(last);
        last.on("click", () => {
          //this.showBarChart(true, line, valores);
          this.selectTiroChart(i, 0)
        });
        last.addTo(this.fGAPPS[fg]);
      }
      this.values[type].push({ valores, line });
    }
  }

  showStaticData = (show) => {
    if (show) {
      this.updatePieChart([this.state.corretoS - this.state.sobreS, this.state.sobreS, this.state.foraS], 'aplicacao', '0');
      this.updatePieChart([this.state.corretoS - this.state.sobreS, this.state.app_extS ? this.state.app_extS : 0, this.state.sobreS, this.state.restanteS], 'area', '0');
      this.updatePieChart([
        this.state.corretoAltS,
        this.state.aceitavelAltInfS,
        this.state.aceitavelAltSupS,
        this.state.incorretaAltInfS,
        this.state.incorretaAltSupS
      ], 'altura', '0');
      this.updatePieChart([
        this.state.corretoFlxS,
        this.state.aceitavelFlxInfS,
        this.state.aceitavelFlxSupS,
        this.state.incorretaFlxInfS,
        this.state.incorretaFlxSupS
      ], 'fluxo', '0');
      this.updatePieChart([
        this.state.corretoVlcS,
        this.state.aceitavelVlcInfS,
        this.state.aceitavelVlcSupS,
        this.state.incorretaVlcInfS,
        this.state.incorretaVlcSupS
      ], 'velocidade', '0');
    }
  };

  lineAltura = null;
  lineFluxo = null;
  lineVelocidade = null;
  lineVelocidadeVento = null;
  lineDirecaoVento = null;
  lineDeltaT = null;
  lineTemperatura = null;
  lineHumidade = null;
  pathMap = (path, i, startSize = 0, control = {}) => {
    let fastProgress = 0;
    let size = startSize;
    let temp_size = this.state.area;
    let size_sobre = this.state.sobre;
    let temp_size_correto = this.state.correto + size_sobre;
    let temp_size_fora = this.state.fora;
    let polyCorrect = null;
    let polyFora = null;
    let polySobre = [];
    const stopAt = control.stopAt;
    const instant = !!control.instant;
    const forcePlay = !!control.forcePlay;
    const silentSeek = !!control.silentSeek;
    const onStop = control.onStop;

    const run = (path, i, size) => {
      let {
        pontos, app, fora, sobre, altura, fluxo, velocidade, vento_velocidade, vento_angulo,
        deltaT = [], temperatura = [], humidade = []
      } = path;
      let line = path.path;
      let stateUpdate = {};
      let stateUpdateRun;
      let seekBatchSize = silentSeek ? 20 : 1;
      let time = 0;

      if (!line || line.length === 0) {
        this.play(false);
        //this.setState({ end: true });
        return;
      }

      let pTime = Date.now();
      this.iPlay = i;

      if (!line[i + 1] || !pontos[i] || !pontos[i + 1]) {
        this.play(false);
        this.setState({ end: true, valueBar: 1000 });
        if (onStop) onStop();
        return;
      }

      if (i < line.length - 1) {
        let batchCount = 0;

        while (batchCount < seekBatchSize && i < line.length - 1) {
          stateUpdate = {};
          stateUpdateRun = null;

          if (!this.isMovingBar && !silentSeek) {
            if (line.length > 2) {
              stateUpdate.valueBar = Math.round((i / (line.length - 2)) * 1000);
            } else {
              stateUpdate.valueBar = 0;
            }
          }

          let to = line[i + 1];
          time = (pontos[i + 1][this.p.tempo] - pontos[i][this.p.tempo]) > 2 ? 200 : (pontos[i + 1][this.p.tempo] - pontos[i][this.p.tempo]) * 1000;

          if (!instant) {
            if (time / this.state.sTime > 0) {
              this.moveMarker(to, time / this.state.sTime, pontos[i][this.p.bearing]);
            }
          } else if (this.marker && this.marker.marker) {
            this.marker.marker.setLatLng(to);
            if (this.marker.marker.setRotationAngle) {
              this.marker.marker.setRotationAngle(pontos[i][this.p.bearing]);
            }
          }

          pTime = (Date.now() - pTime);
          let point = line[i + 1];

          if (!silentSeek) {
            this.line.setLatLngs(this.line._latlngs.concat([point]));
          } else {
            if (!this.seekLine) this.seekLine = [line[0]];
            this.seekLine.push(point);
          }

          if (pontos[line[i + 1][2]][this.p.iApp].length > 0 || pontos[line[i + 1][2]][this.p.iFora].length > 0) {
            temp_size = size + pontos[line[i + 1][2]][this.p.size];

            //monta linha altura, fluxo e velocidade
            if (!this.lineAltura || !this.lineFluxo || !this.lineVelocidade) {
              this.lineAltura = { index: this.altura.length, item: [], largura: pontos[line[i + 1][2]][this.p.setLargura], title: this.props.res.TIRO + ' ' + (this.altura.length + 1) };
              this.altura.push(this.lineAltura);
              this.lineFluxo = { index: this.fluxo.length, item: [], largura: pontos[line[i + 1][2]][this.p.setLargura], title: this.props.res.TIRO + ' ' + (this.fluxo.length + 1) };
              this.fluxo.push(this.lineFluxo);
              this.lineVelocidade = { index: this.velocidade.length, item: [], largura: pontos[line[i + 1][2]][this.p.setLargura], title: this.props.res.TIRO + ' ' + (this.velocidade.length + 1) };
              this.velocidade.push(this.lineVelocidade);
              this.lineVelocidadeVento = { index: this.velocidadeVento.length, item: [], largura: pontos[line[i + 1][2]][this.p.setLargura], title: this.props.res.TIRO + ' ' + (this.velocidadeVento.length + 1) };
              this.velocidadeVento.push(this.lineVelocidadeVento);
              this.lineDirecaoVento = { index: this.direcaoVento.length, item: [], largura: pontos[line[i + 1][2]][this.p.setLargura], title: this.props.res.TIRO + ' ' + (this.direcaoVento.length + 1) };
              this.direcaoVento.push(this.lineDirecaoVento);
              this.lineTemperatura = { index: this.temperatura.length, item: [], largura: pontos[line[i + 1][2]][this.p.setLargura], title: this.props.res.TIRO + ' ' + (this.temperatura.length + 1) };
              this.temperatura.push(this.lineTemperatura);
              this.lineHumidade = { index: this.humidade.length, item: [], largura: pontos[line[i + 1][2]][this.p.setLargura], title: this.props.res.TIRO + ' ' + (this.humidade.length + 1) };
              this.humidade.push(this.lineHumidade);
              this.lineDeltaT = { index: this.deltaT.length, item: [], largura: pontos[line[i + 1][2]][this.p.setLargura], title: this.props.res.TIRO + ' ' + (this.deltaT.length + 1) };
              this.deltaT.push(this.lineDeltaT);
              // Start every quality layer at the previous application point.
              // The first measurement remains the only value recorded, while
              // its geometry covers the same initial interval as the
              // application polygon instead of creating a zero-length line.
              point = [[line[i][0], line[i][1]], [point[0], point[1]]];
            }
            //monta polygon aplicacao
            if (pontos[line[i + 1][2]][this.p.iApp].length > 0) {
              let appIndex = pontos[line[i + 1][2]][this.p.iApp];
              let appPointLeft = app[appIndex[0]].left.points[appIndex[1]];
              let appPointRight = app[appIndex[0]].right.points[appIndex[1]];
              polyCorrect = null;
              if (polyFora) {
                let tempArr = polyFora._latlngs;
                tempArr[0].unshift(new L.LatLng(appPointLeft[0], appPointLeft[1]));
                tempArr[0].push(new L.LatLng(appPointRight[0], appPointRight[1]));
                polyFora.setLatLngs(tempArr);
              } else {
                if (appIndex[1] > 0) {
                  let firstForaPointLeft = app[appIndex[0]].left.points[appIndex[1] - 1];
                  let firstForaPointRight = app[appIndex[0]].right.points[appIndex[1] - 1];
                  let tempArr = [new L.LatLng(firstForaPointLeft[0], firstForaPointLeft[1])];
                  tempArr.push(new L.LatLng(firstForaPointRight[0], firstForaPointRight[1]));
                  tempArr.unshift(new L.LatLng(appPointLeft[0], appPointLeft[1]));
                  tempArr.push(new L.LatLng(appPointRight[0], appPointRight[1]));
                  polyFora = this.aplMapCorrect(tempArr);
                }
              }
              temp_size_correto = temp_size - temp_size_fora;
              if (polyFora) {
                const pop = this.props.res.AREA + ': ' +
                  `${Units.formatValue(Units.convertArea(temp_size_correto, 'm2', this.props.res), this.props.res, 1)} ${Units.getAreaUnit(this.props.res)}`;
                polyFora.setPopupContent(pop);
              }
            } else {
              let foraIndex = pontos[line[i + 1][2]][this.p.iFora];
              let foraPointLeft = fora[foraIndex[0]].left.points[foraIndex[1]];
              let foraPointRight = fora[foraIndex[0]].right.points[foraIndex[1]];
              polyFora = null;
              if (polyCorrect) {
                let tempArr = polyCorrect._latlngs;
                tempArr[0].unshift(new L.LatLng(foraPointLeft[0], foraPointLeft[1]));
                tempArr[0].push(new L.LatLng(foraPointRight[0], foraPointRight[1]));
                polyCorrect.setLatLngs(tempArr);
              } else {
                if (foraIndex[1] > 0) {
                  let firstForaPointLeft = fora[foraIndex[0]].left.points[foraIndex[1] - 1];
                  let firstForaPointRight = fora[foraIndex[0]].right.points[foraIndex[1] - 1];
                  let tempArr = [new L.LatLng(firstForaPointLeft[0], firstForaPointLeft[1])];
                  tempArr.push(new L.LatLng(firstForaPointRight[0], firstForaPointRight[1]));
                  tempArr.unshift(new L.LatLng(foraPointLeft[0], foraPointLeft[1]));
                  tempArr.push(new L.LatLng(foraPointRight[0], foraPointRight[1]));
                  polyCorrect = this.aplMapFora(tempArr);
                }
              }
              temp_size_fora = temp_size - temp_size_correto;
              if (polyCorrect) {
                const pop = this.props.res.AREA + ': ' +
                  `${Units.formatValue(Units.convertArea(temp_size_fora, 'm2', this.props.res), this.props.res, 1)} ${Units.getAreaUnit(this.props.res)}`;
                polyCorrect.setPopupContent(pop);
              }
            }
            const overlapPoint = pontos[line[i + 1][2]];
            const overlapReferences = overlapPoint && overlapPoint[this.p.iSobre];
            if (Array.isArray(overlapReferences) && overlapReferences.length > 0) {
              //monta polygon de sobreposicao aplicacao
              for (let k = 0; k < overlapReferences.length; k++) {
                const sobreIndex = overlapReferences[k][0];
                let item_sobre = sobre[sobreIndex];
                if (!item_sobre || !Array.isArray(item_sobre.left_points) || item_sobre.left_points.length === 0) continue;
                let current_polySobre = polySobre.filter((item) => item.index === sobreIndex);
                if (item_sobre.geometry) {
                  if (current_polySobre.length === 0) {
                    const p = L.geoJSON(item_sobre.geometry, { style: this.styles.sobre });
                    p.bindPopup(this.getOverlapPopup);
                    p.addTo(this.fGAPP['0']);
                    polySobre.push({ index: sobreIndex, poly: p });
                  }
                } else {
                  // Rebuild the current boundary from its history. Appending to
                  // the previous ring keeps internal closing edges in the fill.
                  const currentPointIndex = line[i + 1][2];
                  const tempArr = [item_sobre.left_points.concat(item_sobre.right_points)
                    .filter((point) => point[2] <= currentPointIndex)
                    .map((point) => new L.LatLng(point[0], point[1]))];

                  if (current_polySobre.length > 0) {
                    current_polySobre[0].poly.setLatLngs(tempArr);
                  } else {
                    let p = this.aplMapsobre(tempArr);
                    polySobre.push({ index: sobreIndex, poly: p });
                  }
                }

                let temp_size_cross = overlapPoint[this.p.size_cross].filter((item) => (item.faixa === item_sobre.faixa_cross));
                if (temp_size_cross.length > 0) {
                  size_sobre += temp_size_cross[0].size;
                }
              }
            }
            if (this.state.updateValuesAnimation) {
              this.updatePieChart([temp_size_correto - size_sobre, size_sobre, temp_size_fora], 'aplicacao', this.state.tabMenu);
              this.updatePieChart([temp_size_correto - size_sobre, 0, size_sobre, this.restante - temp_size_correto], 'area', this.state.tabMenu);
            }
            //altura
            if (altura.length > 0) {
              let alturaIndex = pontos[line[i + 1][2]][this.p.iAltura];
              if (alturaIndex.length > 0) {
                const rawAlturaSet = pontos[line[i + 1][2]][this.p.setAltura];
                const rawAltura = altura[alturaIndex[0]].item[alturaIndex[1]].valor[alturaIndex[3]];
                this.lineAltura.setValue = Units.convertLength(rawAlturaSet, 'm', this.props.res);
                if (!this.lineAltura.value) this.lineAltura.value = [];
                let tempAltura = Units.convertLength(rawAltura, 'm', this.props.res);
                tempAltura = Math.round(tempAltura * 10) / 10;
                this.lineAltura.value.push(tempAltura);
                this.lineAltura.fGAPP_ID = '1';
                this.updateColorPath(this.lineAltura, point, this.lineAltura.setValue, tempAltura, altura[alturaIndex[0]].item[alturaIndex[1]].color, pontos[line[i + 1][2]][this.p.setLargura], this.altura.length - 1);

                if (this.state.updateValuesAnimation) {
                  stateUpdate.count_altura = this.state.count_altura + 1;
                  stateUpdate.atual_altura = tempAltura;
                  stateUpdate.media_altura = this.state.media_altura === 0 ? tempAltura : ((this.state.media_altura * this.state.count_altura) + tempAltura) / (this.state.count_altura + 1);

                  let min = this.state.alturaSet - this.state.alturaMargemDown.value - this.state.alturaLimiteDown.value;
                  let minT = this.state.alturaSet - this.state.alturaMargemDown.value;
                  let maxT = this.state.alturaSet + this.state.alturaMargemUp.value;
                  let max = this.state.alturaSet + this.state.alturaMargemUp.value + this.state.alturaLimiteUp.value;

                  if (tempAltura >= minT && tempAltura <= maxT) stateUpdate.corretoAlt = this.state.corretoAlt + (temp_size / 10000);
                  else if (tempAltura >= min && tempAltura < minT) stateUpdate.aceitavelAltInf = this.state.aceitavelAltInf + (temp_size / 10000);
                  else if (tempAltura > maxT && tempAltura <= max) stateUpdate.aceitavelAltSup = this.state.aceitavelAltSup + (temp_size / 10000);
                  else if (tempAltura < min) stateUpdate.incorretaAltInf = this.state.incorretaAltInf + (temp_size / 10000);
                  else if (tempAltura > max) stateUpdate.incorretaAltSup = this.state.incorretaAltSup + (temp_size / 10000);

                  this.updatePieChart([
                    this.state.corretoAlt,
                    this.state.aceitavelAltInf,
                    this.state.aceitavelAltSup,
                    this.state.incorretaAltInf,
                    this.state.incorretaAltSup
                  ], 'altura', this.state.tabMenu);
                }
              }
            }
            //fluxo
            if (fluxo.length > 0) {
              let fluxoIndex = pontos[line[i + 1][2]][this.p.iFluxo];
              if (fluxoIndex.length > 0) {
                const rawFluxoSet = pontos[line[i + 1][2]][this.p.setFluxo];
                const rawFluxo = fluxo[fluxoIndex[0]].item[fluxoIndex[1]].valor[fluxoIndex[3]];
                this.lineFluxo.setValue = Units.convertFlow(rawFluxoSet, 'L', 'ha', this.props.res);
                if (!this.lineFluxo.value) this.lineFluxo.value = [];
                let tempFluxo = Units.convertFlow(rawFluxo, 'L', 'ha', this.props.res);
                tempFluxo = Math.round(tempFluxo * 10) / 10;
                this.lineFluxo.value.push(tempFluxo);
                this.lineFluxo.fGAPP_ID = '2';

                this.updateColorPath(
                  this.lineFluxo,
                  point,
                  this.lineFluxo.setValue,
                  tempFluxo,
                  fluxo[fluxoIndex[0]].item[fluxoIndex[1]].color,
                  pontos[line[i + 1][2]][this.p.setLargura],
                  this.fluxo.length - 1,
                  fluxo[fluxoIndex[0]].item[fluxoIndex[1]].addValue
                );

                if (this.state.updateValuesAnimation) {
                  stateUpdate.count_fluxo = this.state.count_fluxo + 1;
                  stateUpdate.atual_fluxo = tempFluxo;
                  stateUpdate.media_fluxo = this.state.media_fluxo === 0 ? tempFluxo : ((this.state.media_fluxo * this.state.count_fluxo) + tempFluxo) / (this.state.count_fluxo + 1);

                  let min = this.state.fluxoSet - this.state.fluxoMargemDown.value - this.state.fluxoLimiteDown.value;
                  let minT = this.state.fluxoSet - this.state.fluxoMargemDown.value;
                  let maxT = this.state.fluxoSet + this.state.fluxoMargemUp.value;
                  let max = this.state.fluxoSet + this.state.fluxoMargemUp.value + this.state.fluxoLimiteUp.value;

                  if (tempFluxo >= minT && tempFluxo <= maxT) stateUpdate.corretoFlx = this.state.corretoFlx + (temp_size / 1000);
                  else if (tempFluxo > max) stateUpdate.incorretaFlxSup = this.state.incorretaFlxSup + (temp_size / 1000);
                  else if (tempFluxo > maxT) stateUpdate.aceitavelFlxSup = this.state.aceitavelFlxSup + (temp_size / 1000);
                  else if (tempFluxo < min) stateUpdate.incorretaFlxInf = this.state.incorretaFlxInf + (temp_size / 1000);
                  else if (tempFluxo < minT) stateUpdate.aceitavelFlxInf = this.state.aceitavelFlxInf + (temp_size / 1000);

                  this.updatePieChart([
                    this.state.corretoFlx,
                    this.state.aceitavelFlxInf,
                    this.state.aceitavelFlxSup,
                    this.state.incorretaFlxInf,
                    this.state.incorretaFlxSup
                  ], 'fluxo', this.state.tabMenu);
                }
              }
            }
            //velocidade
            if (velocidade.length > 0) {
              let velocidadeIndex = pontos[line[i + 1][2]][this.p.iVelocidade];
              if (velocidadeIndex.length > 0) {
                const rawVelocidadeSet = pontos[line[i + 1][2]][this.p.setVelocidade];
                const rawVelocidade = velocidade[velocidadeIndex[0]].item[velocidadeIndex[1]].valor[velocidadeIndex[3]];
                this.lineVelocidade.setValue = Units.convertSpeed(rawVelocidadeSet, 'km/h', this.props.res);
                if (!this.lineVelocidade.value) this.lineVelocidade.value = [];
                let tempVelocidade = Units.convertSpeed(rawVelocidade, 'km/h', this.props.res);
                tempVelocidade = Math.round(tempVelocidade * 10) / 10;
                this.lineVelocidade.value.push(tempVelocidade);
                this.lineVelocidade.fGAPP_ID = '3';
                this.updateColorPath(this.lineVelocidade, point, this.lineVelocidade.setValue, tempVelocidade, velocidade[velocidadeIndex[0]].item[velocidadeIndex[1]].color, pontos[line[i + 1][2]][this.p.setLargura], this.velocidade.length - 1);

                if (this.state.updateValuesAnimation) {
                  stateUpdate.count_velocidade = this.state.count_velocidade + 1;
                  stateUpdate.atual_velocidade = tempVelocidade;
                  stateUpdate.media_velocidade = this.state.media_velocidade === 0 ? tempVelocidade : ((this.state.media_velocidade * this.state.count_velocidade) + tempVelocidade) / (this.state.count_velocidade + 1);

                  let min = this.state.velocidadeSet - this.state.velocidadeMargemDown.value - this.state.velocidadeLimiteDown.value;
                  let minT = this.state.velocidadeSet - this.state.velocidadeMargemDown.value;
                  let maxT = this.state.velocidadeSet + this.state.velocidadeMargemUp.value;
                  let max = this.state.velocidadeSet + this.state.velocidadeMargemUp.value + this.state.velocidadeLimiteUp.value;

                  if (tempVelocidade >= minT && tempVelocidade <= maxT) stateUpdate.corretoVlc = this.state.corretoVlc + (temp_size / 1000);
                  else if (tempVelocidade > max) stateUpdate.incorretaVlcSup = this.state.incorretaVlcSup + (temp_size / 1000);
                  else if (tempVelocidade > maxT) stateUpdate.aceitavelVlcSup = this.state.aceitavelVlcSup + (temp_size / 1000);
                  else if (tempVelocidade < min) stateUpdate.incorretaVlcInf = this.state.incorretaVlcInf + (temp_size / 1000);
                  else if (tempVelocidade < minT) stateUpdate.aceitavelVlcInf = this.state.aceitavelVlcInf + (temp_size / 1000);

                  this.updatePieChart([
                    this.state.corretoVlc,
                    this.state.aceitavelVlcInf,
                    this.state.aceitavelVlcSup,
                    this.state.incorretaVlcInf,
                    this.state.incorretaVlcSup
                  ], 'velocidade', this.state.tabMenu);
                }
              }
            }
            //velocidade do vento
            if (vento_velocidade.length > 0) {
              let velocidadeVIndex = pontos[line[i + 1][2]][this.p.iVelocidadeV];
              if (velocidadeVIndex.length > 0) {
                this.lineVelocidadeVento.setValue = 0;//pontos[line[i + 1][2]].setVelocidade;
                if (!this.lineVelocidadeVento.value) this.lineVelocidadeVento.value = [];
                const rawVelocidadeVento = vento_velocidade[velocidadeVIndex[0]].item[velocidadeVIndex[1]].valor[velocidadeVIndex[3]];
                let tempVelocidadeVento = Units.convertSpeed(rawVelocidadeVento, 'km/h', this.props.res);
                tempVelocidadeVento = Math.round(tempVelocidadeVento * 10) / 10;
                this.lineVelocidadeVento.value.push(tempVelocidadeVento);
                this.lineVelocidadeVento.fGAPP_ID = '4';
                this.updateColorPath(this.lineVelocidadeVento, point, this.lineVelocidadeVento.setValue, tempVelocidadeVento, vento_velocidade[velocidadeVIndex[0]].item[velocidadeVIndex[1]].color, pontos[line[i + 1][2]][this.p.setLargura], this.velocidadeVento.length - 1);

                if (this.state.updateValuesAnimation) {
                  stateUpdate.count_velocidade_vento = this.state.count_velocidade_vento + 1;
                  stateUpdate.atual_velocidade_vento = tempVelocidadeVento;
                  stateUpdate.media_velocidade_vento = this.state.media_velocidade_vento === 0
                    ? tempVelocidadeVento
                    : ((this.state.media_velocidade_vento * this.state.count_velocidade_vento) + tempVelocidadeVento) / (this.state.count_velocidade_vento + 1);

                  let min = this.state.velocidadeVSet - this.state.velocidadeVMargemDown.value - this.state.velocidadeVLimiteDown.value;
                  let minT = this.state.velocidadeVSet - this.state.velocidadeVMargemDown.value;
                  let maxT = this.state.velocidadeVSet + this.state.velocidadeVMargemUp.value;
                  let max = this.state.velocidadeVSet + this.state.velocidadeVMargemUp.value + this.state.velocidadeVLimiteUp.value;

                  if (tempVelocidadeVento >= minT && tempVelocidadeVento <= maxT) stateUpdate.corretoVlcV = this.state.corretoVlcV + (temp_size / 1000);
                  else if (tempVelocidadeVento > max) stateUpdate.incorretaVlcVSup = this.state.incorretaVlcVSup + (temp_size / 1000);
                  else if (tempVelocidadeVento > maxT) stateUpdate.aceitavelVlcVSup = this.state.aceitavelVlcVSup + (temp_size / 1000);
                  else if (tempVelocidadeVento < min) stateUpdate.incorretaVlcVInf = this.state.incorretaVlcVInf + (temp_size / 1000);
                  else if (tempVelocidadeVento < minT) stateUpdate.aceitavelVlcVInf = this.state.aceitavelVlcVInf + (temp_size / 1000);

                  this.updatePieChart([
                    stateUpdate.corretoVlcV,
                    stateUpdate.aceitavelVlcVInf,
                    stateUpdate.aceitavelVlcVSup,
                    stateUpdate.incorretaVlcVInf,
                    stateUpdate.incorretaVlcVSup
                  ], 'velocidadeVento', this.state.tabMenu);
                }
              }
            }

            //direcao do vento
            if (vento_angulo.length > 0) {
              let direcaoVIndex = pontos[line[i + 1][2]][this.p.iDirecaoV];
              if (direcaoVIndex.length > 0) {
                this.lineDirecaoVento.setValue = 0;//pontos[line[i + 1][2]].setVelocidade;
                if (!this.lineDirecaoVento.value) this.lineDirecaoVento.value = [];
                let tempDirecaoVento = Math.round(vento_angulo[direcaoVIndex[0]].item[direcaoVIndex[1]].valor[direcaoVIndex[3]] * 10) / 10;
                this.lineDirecaoVento.value.push(tempDirecaoVento);
                this.lineDirecaoVento.fGAPP_ID = '5';
                this.updateColorPath(this.lineDirecaoVento, point, this.lineDirecaoVento.setValue, tempDirecaoVento, vento_angulo[direcaoVIndex[0]].item[direcaoVIndex[1]].color, pontos[line[i + 1][2]][this.p.setLargura], this.direcaoVento.length - 1);

                if (this.state.updateValuesAnimation) {
                  stateUpdate.windAngle = vento_angulo[direcaoVIndex[0]].item[direcaoVIndex[1]].direcao[direcaoVIndex[3]];
                  stateUpdate.planeAngle = pontos[i][this.p.bearing];

                  stateUpdate.count_angulo_vento = this.state.count_angulo_vento + 1;
                  stateUpdate.atual_velocidade_vento = tempDirecaoVento;
                  stateUpdate.media_angulo_vento = this.state.media_angulo_vento === 0
                    ? tempDirecaoVento
                    : ((this.state.media_angulo_vento * this.state.count_angulo_vento) + tempDirecaoVento) / (this.state.count_angulo_vento + 1);

                  let min = this.state.anguloVSet - this.state.anguloVMargemDown.value - this.state.anguloVLimiteDown.value;
                  let minT = this.state.anguloVSet - this.state.anguloVMargemDown.value;
                  let maxT = this.state.anguloVSet + this.state.anguloVMargemUp.value;
                  let max = this.state.anguloVSet + this.state.anguloVMargemUp.value + this.state.anguloVLimiteUp.value;

                  if (tempDirecaoVento >= minT && tempDirecaoVento <= maxT) stateUpdate.corretoAngV = this.state.corretoAngV + (temp_size / 1000);
                  else if (tempDirecaoVento > max) stateUpdate.incorretaAngVSup = this.state.incorretaAngVSup + (temp_size / 1000);
                  else if (tempDirecaoVento > maxT) stateUpdate.aceitavelAngVSup = this.state.aceitavelAngVSup + (temp_size / 1000);
                  else if (tempDirecaoVento < min) stateUpdate.incorretaAngVInf = this.state.incorretaAngVInf + (temp_size / 1000);
                  else if (tempDirecaoVento < minT) stateUpdate.aceitavelAngVInf = this.state.aceitavelAngVInf + (temp_size / 1000);

                  this.updatePieChart([
                    this.state.corretoAngV,
                    this.state.aceitavelAngVInf,
                    this.state.aceitavelAngVSup,
                    this.state.incorretaAngVInf,
                    this.state.incorretaAngVSup
                  ], 'direcaoVento', this.state.tabMenu);
                }
              }
            }

            // clima: temperatura
            if (temperatura.length > 0) {
              const temperaturaIndex = pontos[line[i + 1][2]][this.p.iTemperatura];
              if (Array.isArray(temperaturaIndex) && temperaturaIndex.length > 0) {
                this.lineTemperatura.setValue = pontos[line[i + 1][2]][this.p.setTemperatura];
                if (!this.lineTemperatura.value) this.lineTemperatura.value = [];
                const temperaturaAtual = Math.round(temperatura[temperaturaIndex[0]].item[temperaturaIndex[1]].valor[temperaturaIndex[3]] * 10) / 10;
                this.lineTemperatura.value.push(temperaturaAtual);
                this.lineTemperatura.fGAPP_ID = '7';
                this.updateColorPath(this.lineTemperatura, point, this.lineTemperatura.setValue, temperaturaAtual, temperatura[temperaturaIndex[0]].item[temperaturaIndex[1]].color, pontos[line[i + 1][2]][this.p.setLargura], this.temperatura.length - 1);
              }
            }

            // clima: umidade
            if (humidade.length > 0) {
              const humidadeIndex = pontos[line[i + 1][2]][this.p.iHumidade];
              if (Array.isArray(humidadeIndex) && humidadeIndex.length > 0) {
                this.lineHumidade.setValue = pontos[line[i + 1][2]][this.p.setUmidade];
                if (!this.lineHumidade.value) this.lineHumidade.value = [];
                const humidadeAtual = Math.round(humidade[humidadeIndex[0]].item[humidadeIndex[1]].valor[humidadeIndex[3]] * 10) / 10;
                this.lineHumidade.value.push(humidadeAtual);
                this.lineHumidade.fGAPP_ID = '8';
                this.updateColorPath(this.lineHumidade, point, this.lineHumidade.setValue, humidadeAtual, humidade[humidadeIndex[0]].item[humidadeIndex[1]].color, pontos[line[i + 1][2]][this.p.setLargura], this.humidade.length - 1);
              }
            }

            // clima: Delta T. Analises anteriores nao tinham o indice iDeltaT
            // serializado; o guard evita tentar interpretar a antiga cobertura
            // como um indice de camada.
            if (deltaT.length > 0) {
              const deltaTIndex = pontos[line[i + 1][2]][this.p.iDeltaT];
              if (Array.isArray(deltaTIndex) && deltaTIndex.length > 0) {
                this.lineDeltaT.setValue = 0;
                if (!this.lineDeltaT.value) this.lineDeltaT.value = [];
                const deltaTAtual = Math.round(deltaT[deltaTIndex[0]].item[deltaTIndex[1]].valor[deltaTIndex[3]] * 10) / 10;
                this.lineDeltaT.value.push(deltaTAtual);
                this.lineDeltaT.fGAPP_ID = '6';
                this.updateColorPath(this.lineDeltaT, point, this.lineDeltaT.setValue, deltaTAtual, deltaT[deltaTIndex[0]].item[deltaTIndex[1]].color, pontos[line[i + 1][2]][this.p.setLargura], this.deltaT.length - 1);
              }
            }

            if (this.state.updateValuesAnimation) {
              stateUpdate.area = temp_size;
              stateUpdate.fora = temp_size_fora;
              stateUpdate.correto = temp_size_correto - size_sobre;
              stateUpdate.sobre = size_sobre;
              stateUpdate.atual_angulo_vento = pontos[i][this.p.bearing];

              stateUpdateRun = () => {
                if (this.state.showChart) {
                  if (this.state.tab === '1') {
                    this.updateBarChart(null);
                  } else if (this.state.tab === '2') {
                    this.updateBarChart(null);
                  } else if (this.state.tab === '3') {
                    this.updateBarChart(null);
                  } else if (this.state.tab === '4') {
                    this.updateBarChart(null);
                  }
                }
              };
            }
          } else {
            if (!silentSeek && this.state.fastProgress) {
              if (++fastProgress <= 5 && line[i + 1] && pontos[i] && pontos[i + 1]) {
                run(path, ++i, size);
                return;
              } else {
                fastProgress = 0;
              }
            }

            polyFora = null;
            polyCorrect = null;
            this.lineAltura = null;
            this.lineFluxo = null;
            this.lineVelocidade = null;

            if (temp_size > 0) {
              size = temp_size;
              temp_size = 0;
            }
          }

          if (this.state.updateValuesAnimation) {
            stateUpdate.restante = this.restante;
            stateUpdate.time = pontos[line[i][2]][this.p.tempo] ? pontos[line[i][2]][this.p.tempo] : 0;
          }

          if (silentSeek && Object.keys(stateUpdate).length > 0) {
            this.seekStateSnapshot = {
              ...(this.seekStateSnapshot || {}),
              ...stateUpdate
            };
          }

          batchCount += 1;

          if (!silentSeek) {
            break;
          }

          if (stopAt && i >= stopAt) {
            break;
          }

          const canAdvanceBatch =
            this.run &&
            line.length - 2 > i &&
            this.current_run === this.new_run &&
            (forcePlay || this.state.play) &&
            (!stopAt || i < stopAt) &&
            line[i + 1] &&
            pontos[i] &&
            pontos[i + 1];

          if (!canAdvanceBatch || batchCount >= seekBatchSize) {
            break;
          }

          i += 1;
        }
      } else {
        if (!silentSeek && this.state.fastProgress) {
          if (++fastProgress <= 5 && line[i + 1] && pontos[i] && pontos[i + 1]) {
            run(path, ++i, size);
            return;
          } else {
            fastProgress = 0;
          }
        }

        polyFora = null;
        polyCorrect = null;
        this.lineAltura = null;
        this.lineFluxo = null;
        this.lineVelocidade = null;

        if (temp_size > 0) {
          size = temp_size;
          temp_size = 0;
        }
      }

      const continueRun = () => {
        const canContinue =
          this.run &&
          line.length - 2 > i &&
          this.current_run === this.new_run &&
          (forcePlay || this.state.play) &&
          (!stopAt || i < stopAt) &&
          line[i + 1] &&
          pontos[i] &&
          pontos[i + 1];

        if (canContinue) {
          setTimeout(() => {
            run(path, ++i, size);
          }, instant ? 0 : Math.max(0, (time - pTime) / this.state.sTime));
        } else if (stopAt && i >= stopAt) {
          this.iPlay = stopAt;

          if (silentSeek && this.seekLine && this.line) {
            this.line.setLatLngs(this.seekLine);
            this.seekLine = null;
          }

          if (onStop) onStop();
        } else if (line.length - 20 < i) {
          this.play(false);
          this.setState({ end: true, valueBar: 1000 });
        } else {
          if (silentSeek && this.seekLine && this.line) {
            this.line.setLatLngs(this.seekLine);
            this.seekLine = null;
          }

          if (onStop) onStop();
        }

        this.current_run = this.new_run;
      };

      if (Object.keys(stateUpdate).length > 0 && !silentSeek) {
        this.setState(stateUpdate, () => {
          if (stateUpdateRun) stateUpdateRun();
          continueRun();
        });
      } else {
        if (stateUpdateRun) stateUpdateRun();
        continueRun();
      }
    };

    run(path, i, size);
  };

  moveMarker = (pos, time, angle) => {
    this.marker.marker.slideTo(pos, {
      duration: time,
      rotationAngle: angle,
      keepAtCenter: this.state.follow
    });
  };

  falhaMap = (poly) => {
    let myStyle = {
      color: this.cores.falha,
      fillOpacity: .9,
      opacity: 0,
      className: 'aplicacao',
    };

    let myLayer = L.geoJSON(poly, { style: myStyle });
    myLayer.addTo(this.fGAPP['0']);
  };

  aplMapCorrect = (poly) => {
    let myStyle = this.styles.correto;

    let myLayer = L.polygon(poly, myStyle);

    let area = L.GeometryUtil.geodesicArea(myLayer.getLatLngs()[0]);
    const pop = this.props.res.AREA + ': ' +
      `${Units.formatValue(Units.convertArea(area, 'm2', this.props.res), this.props.res, 1)} ${Units.getAreaUnit(this.props.res)}`;
    myLayer.bindPopup(pop);

    myLayer.addTo(this.fGAPP['0']);

    return myLayer;
  };

  aplMapFora = (poly) => {
    let myStyle = this.styles.fora;
    let myLayer = L.polygon(poly, myStyle);

    let area = L.GeometryUtil.geodesicArea(myLayer.getLatLngs()[0]);
    const pop = this.props.res.AREA + ': ' +
      `${Units.formatValue(Units.convertArea(area, 'm2', this.props.res), this.props.res, 1)} ${Units.getAreaUnit(this.props.res)}`;
    myLayer.bindPopup(pop);

    myLayer.addTo(this.fGAPP['0']);

    return myLayer;
  };

  getOverlapPopup = (layer) => {
    // Turf 5 in the client uses a 6378137 m radius for area. Match the
    // 6371008.8 m radius used by Turf 7 in the analysis worker.
    // Keep the narrow strips' coordinates precise before calculating area.
    const area = turfArea(layer.toGeoJSON(15)) * Math.pow(6371008.8 / 6378137, 2);
    return this.props.res.AREA + ': ' +
      `${Units.formatValue(Units.convertArea(area, 'm2', this.props.res), this.props.res, 3)} ${Units.getAreaUnit(this.props.res)}`;
  };

  aplMapsobre = (poly) => {
    let myStyle = this.styles.sobre;

    let myLayer = L.polygon(poly, myStyle);
    myLayer.bindPopup(this.getOverlapPopup);
    myLayer.addTo(this.fGAPP['0']);

    return myLayer;
  };

  updateTask = () => {
    this.setState({ progress: true });
    let task = this.state.task;
    let apiUrl = Config.server + '/analise';

    if (!this.state.alturaMargemDown.valid ||
      !this.state.alturaMargemUp.valid ||
      !this.state.alturaLimiteDown.valid ||
      !this.state.alturaLimiteUp.valid ||
      !this.state.fluxoMargemDown.valid ||
      !this.state.fluxoMargemUp.valid ||
      !this.state.fluxoLimiteDown.valid ||
      !this.state.fluxoLimiteUp.valid ||
      !this.state.velocidadeMargemDown.valid ||
      !this.state.velocidadeMargemUp.valid ||
      !this.state.velocidadeLimiteDown.valid ||
      !this.state.velocidadeLimiteUp.valid ||
      (this.state.checkConfig[4] &&
        (!this.state.velocidadeVMargemDown.valid ||
          !this.state.velocidadeVMargemUp.valid ||
          !this.state.velocidadeVLimiteDown.valid ||
          !this.state.velocidadeVLimiteUp.valid ||
          (!this.state.espelharAnguloV && !this.state.anguloVMargemDown.valid) ||
          !this.state.anguloVMargemUp.valid ||
          (!this.state.espelharAnguloV && !this.state.anguloVLimiteDown.valid) ||
          !this.state.anguloVLimiteUp.valid ||
          !this.state.temperaturaMargemDown.valid ||
          !this.state.temperaturaMargemUp.valid ||
          !this.state.temperaturaLimiteDown.valid ||
          !this.state.temperaturaLimiteUp.valid ||
          !this.state.umidadeMargemDown.valid ||
          !this.state.umidadeMargemUp.valid ||
          !this.state.umidadeLimiteDown.valid ||
          !this.state.umidadeLimiteUp.valid))) {
      notification.open({
        message: this.props.res.CONFIG_INVALID,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
      return;
    }


    const formData = new URLSearchParams();
    formData.append('task', task);
    formData.append('polygons', JSON.stringify(this.state.polygons));

    formData.append('aeronave', this.state.aeronave);

    const selectedPlane = this.getSelectedPlaneFromState();
    if (selectedPlane) {
      if (selectedPlane.id !== null && selectedPlane.id !== undefined) {
        formData.append('id_plane', selectedPlane.id);
      }
      if (selectedPlane.id_aircraftbrand !== null && selectedPlane.id_aircraftbrand !== undefined) {
        formData.append('id_aircraftbrand', selectedPlane.id_aircraftbrand);
      }
      const selectedAircraftBrand = this.getPlaneAircraftBrandName(selectedPlane);
      if (selectedAircraftBrand) {
        formData.append('aircraftbrand', selectedAircraftBrand);
      }
    }

    formData.append('cliente', this.state.cliente);
    formData.append('piloto', this.state.piloto);
    formData.append('cultura', this.state.cultura);
    formData.append('nome', this.state.nome);
    formData.append('larguraDefault', Units.toCanonicalLength(this.state.larguraDefault, this.props.res));
    formData.append('alturaDefault', Units.toCanonicalLength(this.state.alturaDefault, this.props.res));
    formData.append('fluxoDefault', Units.toCanonicalFlow(this.state.fluxoDefault, this.props.res, 'L', 'ha'));
    formData.append('velocidadeDefault', Units.toCanonicalSpeed(this.state.velocidadeDefault, this.props.res));

    formData.append('larguraSet', this.state.checkConfig[0] ? Units.toCanonicalLength(this.state.larguraSet, this.props.res) : 0);
    formData.append('alturaSet', this.state.checkConfig[1] ? Units.toCanonicalLength(this.state.alturaSet, this.props.res) : 0);
    formData.append('fluxoSet', this.state.checkConfig[2] ? Units.toCanonicalFlow(this.state.fluxoSet, this.props.res, 'L', 'ha') : 0);
    formData.append('velocidadeSet', this.state.checkConfig[3] ? Units.toCanonicalSpeed(this.state.velocidadeSet, this.props.res) : 0);

    formData.append('alturaMargemUp', Units.toCanonicalLength(this.state.alturaMargemUp.value, this.props.res));
    formData.append('alturaMargemDown', Units.toCanonicalLength(this.state.alturaMargemDown.value, this.props.res));
    formData.append('alturaLimiteUp', Units.toCanonicalLength(this.state.alturaLimiteUp.value, this.props.res));
    formData.append('alturaLimiteDown', Units.toCanonicalLength(this.state.alturaLimiteDown.value, this.props.res));

    formData.append('fluxoMargemUp', Units.toCanonicalFlow(this.state.fluxoMargemUp.value, this.props.res, 'L', 'ha'));
    formData.append('fluxoMargemDown', Units.toCanonicalFlow(this.state.fluxoMargemDown.value, this.props.res, 'L', 'ha'));
    formData.append('fluxoLimiteUp', Units.toCanonicalFlow(this.state.fluxoLimiteUp.value, this.props.res, 'L', 'ha'));
    formData.append('fluxoLimiteDown', Units.toCanonicalFlow(this.state.fluxoLimiteDown.value, this.props.res, 'L', 'ha'));

    formData.append('velocidadeMargemUp', Units.toCanonicalSpeed(this.state.velocidadeMargemUp.value, this.props.res));
    formData.append('velocidadeMargemDown', Units.toCanonicalSpeed(this.state.velocidadeMargemDown.value, this.props.res));
    formData.append('velocidadeLimiteUp', Units.toCanonicalSpeed(this.state.velocidadeLimiteUp.value, this.props.res));
    formData.append('velocidadeLimiteDown', Units.toCanonicalSpeed(this.state.velocidadeLimiteDown.value, this.props.res));

    if (this.state.checkConfig[4]) {
      formData.append('velocidadeVSet', Units.toCanonicalSpeed(this.state.velocidadeVSet, this.props.res));
      formData.append('velocidadeVMargemUp', Units.toCanonicalSpeed(this.state.velocidadeVMargemUp.value, this.props.res));
      formData.append('velocidadeVMargemDown', Units.toCanonicalSpeed(this.state.velocidadeVMargemDown.value, this.props.res));
      formData.append('velocidadeVLimiteUp', Units.toCanonicalSpeed(this.state.velocidadeVLimiteUp.value, this.props.res));
      formData.append('velocidadeVLimiteDown', Units.toCanonicalSpeed(this.state.velocidadeVLimiteDown.value, this.props.res));

      if (this.props.res.LINGUA === 'en-US') {
        formData.append('temperaturaSet', tools.f_to_c(this.state.temperaturaSet));
        formData.append('temperaturaMargemUp', tools.f_to_c(this.state.temperaturaSet + this.state.temperaturaMargemUp.value) - tools.f_to_c(this.state.temperaturaSet));
        formData.append('temperaturaMargemDown', tools.f_to_c(this.state.temperaturaSet) - tools.f_to_c(this.state.temperaturaSet - this.state.temperaturaMargemDown.value));
        formData.append('temperaturaLimiteUp', tools.f_to_c(this.state.temperaturaSet + this.state.temperaturaMargemUp.value + this.state.temperaturaLimiteUp.value) - tools.f_to_c(this.state.temperaturaSet + this.state.temperaturaMargemUp.value));
        formData.append('temperaturaLimiteDown', tools.f_to_c(this.state.temperaturaSet - this.state.temperaturaMargemDown.value) - tools.f_to_c(this.state.temperaturaSet - this.state.temperaturaMargemDown.value - this.state.temperaturaLimiteDown.value));
      } else {
        formData.append('temperaturaSet', this.state.temperaturaSet);
        formData.append('temperaturaMargemUp', this.state.temperaturaMargemUp.value);
        formData.append('temperaturaMargemDown', this.state.temperaturaMargemDown.value);
        formData.append('temperaturaLimiteUp', this.state.temperaturaLimiteUp.value);
        formData.append('temperaturaLimiteDown', this.state.temperaturaLimiteDown.value);
      }
    }

    if (this.state.checkConfig[4]) {
      formData.append('anguloVSetRight', 90);
      formData.append('anguloVSetLeft', 270);
      formData.append('UmidadeSet', this.state.umidadeSet);
    }
    //formData.append('alturaMargem', this.state.alturaMargem);
    //formData.append('alturaLimite', this.state.alturaLimite);
    let perfil = this.state.selectedPerfil > 0
      ? this.state.listPerfis.find((item) => Number(item.id) === Number(this.state.selectedPerfil))
      : null;
    formData.append('profile', perfil ? perfil.name : this.props.res.CUSTOMIZADO);
    formData.append('larguraExd', !isNaN(this.state.larguraExd) ? this.state.larguraExd : 100);

    if (this.state.checkConfig[4]) {

      if (this.state.tipoFonte === 'EXTERNO') {
        formData.append('tipoFonte', 'api');
      } else {
        formData.append('tipoFonte', 'station');
        formData.append('fonteClima', this.state.fonteClima);
      }
      formData.append('anguloVMargemDown', this.state.anguloVMargemDown.value);
      formData.append('anguloVMargemUp', this.state.espelharAnguloV ? this.state.anguloVMargemDown.value : this.state.anguloVMargemUp.value);
      formData.append('anguloVLimiteDown', this.state.anguloVLimiteDown.value);
      formData.append('anguloVLimiteUp', this.state.espelharAnguloV ? this.state.anguloVLimiteDown.value : this.state.anguloVLimiteUp.value);

      formData.append('UmidadeMargemUp', this.state.umidadeMargemUp.value);
      formData.append('UmidadeMargemDown', this.state.umidadeMargemDown.value);
      formData.append('UmidadeLimiteUp', this.state.umidadeLimiteUp.value);
      formData.append('UmidadeLimiteDown', this.state.umidadeLimiteDown.value);
    }

    const options = {
      method: 'PUT',
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({ progress: false });
          if (result) {
            this.setState({ loading: true });
            setTimeout(() => {
              this.loadTask(true);
            }, 200);
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 400) {
            notification.open({
              message: this.props.res[error.statusText],
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  loadTask = (open) => {
    let apiUrl = Config.server + '/task/analise'

    if (this.props.guid) {
      apiUrl += '/' + this.props.guid
    }

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          if (this.state.openTask || open || this.state.loading) {
            setTimeout(() => {
              if (this.state.openTask) {
                this.loadTask(true);
              }
            }, 3000);
            this.setState({
              itensTask: result,
              openTask: open
            });
          } else {
            this.setState({ itensTask: result });
          }
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  toJSON = async (length, contentType, body, update) => {
    let loaded = 0;

    const reader = body.getReader(); // `ReadableStreamDefaultReader`
    const chunks = [];

    async function read() {
      const { done, value } = await reader.read();

      if (done) {
        const buffer = new Uint8Array(loaded);
        let offset = 0;
        for (const chunk of chunks) {
          buffer.set(chunk, offset);
          offset += chunk.length;
        }

        const arrayBuffer = buffer.buffer;

        if (contentType && contentType.includes('application/zip')) {
          const zip = new jszip();
          const zipContents = await zip.loadAsync(arrayBuffer);
          const jsonFile = zipContents.files['result.json'];
          if (jsonFile) {
            const jsonString = await jsonFile.async('string');
            const jsonData = JSON.parse(jsonString);
            return jsonData;
          } else {
            throw new Error('JSON file not found inside ZIP');
          }
        } else if (contentType && contentType.includes('application/json')) {
          // Process as JSON if content type is JSON
          const jsonData = JSON.parse(new TextDecoder().decode(arrayBuffer));
          return jsonData;
        }
      }

      chunks.push(value);
      loaded += value.length;

      update && update(loaded, length);

      return read(); // read the next chunk
    }

    return read();
  }

  getTask = async (task, data) => {
    if (task) {
      let tempTask = task;
      let apiUrl = Config.server + '/analise/' + task;

      const options = {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt')
        }
      }

      let result;
      if (data) {
        result = { data: data };
      } else {
        this.setState({ progress: true, progressValue: 0, openTask: false });
        try {
          const response = await fetch(apiUrl, options);
          result = await this.toJSON(
            response.headers.get('content-length'),
            response.headers.get('Content-Type'),
            response.body,
            (loaded, length) => {
              this.setState({ progressValue: (100 * loaded / length).toFixed() });
            }
          );
        } catch (error) {
          this.setState({ progress: false });
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
          return;
        }
      }

      if (result) {
        if (result.cantRun) {
          this.setState({ task: null, progress: false, progressValue: 0 });
        } else if (result.msg === "not ready.") {
          this.setState({ progress: false, progressValue: 0 });
          this.loadTask(true);
        } else {
          if (result.app) {
            this.setState({
              polygons_total: result.total.polygons_total,
              polygons_aplicados: result.total.polygons_applied
            });
            this.getConfigData(result, tempTask);
          } else if (result.data) {
            this.setState({ progress: false, progressValue: 0 });
            result.task = { id: task };
            this.useData(result);
          }
        }
      }
    }
  };

  getConfigData = (result, task) => {
    const { res } = this.props;

    this.useType(isNaN(result.pontos[0].bearing) ? 'N' : 'C');

    const nomePerfil = result.data.profile;
    const larguraExd = result.data.larguraExd > 0 ? result.data.larguraExd : this.state.larguraExd;

    const lSet = result.data.larguraSet > 0 ? result.data.larguraSet : result.data.larguraDefault > 0 ? result.data.larguraDefault : this.state.larguraSet;
    const aSet = result.data.alturaSet > 0 ? result.data.alturaSet : result.data.alturaDefault > 0 ? result.data.alturaDefault : this.state.alturaSet;
    const fSet = result.data.fluxoSet > 0 ? result.data.fluxoSet : result.data.fluxoDefault > 0 ? result.data.fluxoDefault : this.state.fluxoSet;
    const vSet = result.data.velocidadeSet > 0 ? result.data.velocidadeSet : result.data.velocidadeDefault > 0 ? result.data.velocidadeDefault : this.state.velocidadeSet;
    const vvSet = result.data.velocidadeVSet > 0 ? result.data.velocidadeVSet : 10;
    //const dvSetDown = result.data.anguloVSetDown > 0 ? result.data.anguloVSetDown : 90;
    //const dvSetUp = result.data.anguloVSetUp > 0 ? result.data.anguloVSetUp : 270;
    const tSet = result.data.temperaturaSet > 0 ? result.data.temperaturaSet : 22.5;
    const hSet = result.data.UmidadeSet > 0 ? result.data.UmidadeSet : 52.5;

    const lSetDisplay = Units.convertLength(lSet, 'm', res);
    const aSetDisplay = aSet ? Units.convertLength(aSet, 'm', res) : 0;
    const fSetDisplay = Units.convertFlow(fSet, 'L', 'ha', res);
    const vSetDisplay = Units.convertSpeed(vSet, 'km/h', res);

    const alturaMargemDownDisplay = Units.convertLength(result.data.alturaMargemDown, 'm', res);
    const alturaMargemUpDisplay = Units.convertLength(result.data.alturaMargemUp, 'm', res);
    const alturaLimiteDownDisplay = Units.convertLength(result.data.alturaLimiteDown, 'm', res);
    const alturaLimiteUpDisplay = Units.convertLength(result.data.alturaLimiteUp, 'm', res);

    const fluxoMargemDownDisplay = Units.convertFlow(result.data.fluxoMargemDown, 'L', 'ha', res);
    const fluxoMargemUpDisplay = Units.convertFlow(result.data.fluxoMargemUp, 'L', 'ha', res);
    const fluxoLimiteDownDisplay = Units.convertFlow(result.data.fluxoLimiteDown, 'L', 'ha', res);
    const fluxoLimiteUpDisplay = Units.convertFlow(result.data.fluxoLimiteUp, 'L', 'ha', res);

    const velocidadeMargemDownDisplay = Units.convertSpeed(result.data.velocidadeMargemDown, 'km/h', res);
    const velocidadeMargemUpDisplay = Units.convertSpeed(result.data.velocidadeMargemUp, 'km/h', res);
    const velocidadeLimiteDownDisplay = Units.convertSpeed(result.data.velocidadeLimiteDown, 'km/h', res);
    const velocidadeLimiteUpDisplay = Units.convertSpeed(result.data.velocidadeLimiteUp, 'km/h', res);


    localStorage.setItem('check-task', task);
    const idJob = this.state.id_job;
    const titleJob = this.state.title;
    const checkConfig = this.state.checkConfig;
    checkConfig[0] = result.data.larguraSet > 0;
    checkConfig[1] = result.data.alturaSet > 0;
    checkConfig[2] = result.data.fluxoSet > 0;
    checkConfig[3] = result.data.velocidadeSet > 0;
    checkConfig[4] = result.data.velocidadeVSet > 0;
    /*checkConfig[5] = vvSet > 0;
    checkConfig[6] = vvSet > 0;
    checkConfig[7] = vvSet > 0;
    checkConfig[9] = vvSet > 0;*/

    this.clear(true, () => {
      const clienteValue = this.getValidText(result.data.cliente);
      const aeronaveValue = this.getValidText(result.data.aeronave);
      const pilotoValue = this.getValidText(result.data.piloto);

      let state = {
        progress: false, progressValue: 0,

        id_job: idJob,
        title: titleJob,
        task: task,
        title_sk: result.title,
        state: 3,
        showLimit: false,
        larguraSet: lSetDisplay,
        alturaSet: aSetDisplay,
        fluxoSet: fSetDisplay,
        velocidadeSet: vSetDisplay,

        nomePerfil,
        larguraExd,

        checkConfig: checkConfig,
        //fonstes: result.data.weatherdata,
        tipoFonte: result.data.sourceType === 'station' ? 'ESTACAO' : 'EXTERNO',
        fonteClima: !isNaN(result.data.sourceId) ? result.data.sourceId : 0,

        cultura: result.data.cultura,
        nome: result.data.nome,
        aeronave: aeronaveValue,
        cliente: clienteValue,
        piloto: pilotoValue,

        gCultura: result.data.cultura,
        gNome: result.data.nome,
        gAeronave: aeronaveValue,
        gCliente: clienteValue,
        gPiloto: pilotoValue,

        dateIni: tools.dateTimeZoneFormat(result.dateIni, this.props.res.FORMAT_DATAHORAMIN, this.props.res.timezone),
        dateFim: tools.dateTimeZoneFormat(result.dateFim, this.props.res.FORMAT_DATAHORAMIN, this.props.res.timezone),
        area_talhoes: (result.total.area ? result.total.area : 0),
        distancia_percorrida: (result.total.distancia ? result.total.distancia : 0),

        //altura
        media_alturaS: (result.total.altura.media ? result.total.altura.media : 0),
        corretoAltS: (result.total.altura.correto ? result.total.altura.correto : 0),
        aceitavelAltInfS: (result.total.altura.aceitavel.down ? result.total.altura.aceitavel.down : 0),
        aceitavelAltSupS: (result.total.altura.aceitavel.up ? result.total.altura.aceitavel.up : 0),
        incorretaAltInfS: (result.total.altura.inaceitavel.down ? result.total.altura.inaceitavel.down : 0),
        incorretaAltSupS: (result.total.altura.inaceitavel.up ? result.total.altura.inaceitavel.up : 0),

        alturaMargemDown: {
          value: alturaMargemDownDisplay,
          text: aSetDisplay - alturaMargemDownDisplay,
          valid: true
        },
        alturaMargemUp: {
          value: alturaMargemUpDisplay,
          text: aSetDisplay + alturaMargemUpDisplay,
          valid: true
        },
        alturaLimiteDown: {
          value: alturaLimiteDownDisplay,
          text: aSetDisplay - alturaMargemDownDisplay - alturaLimiteDownDisplay,
          valid: true
        },
        alturaLimiteUp: {
          value: alturaLimiteUpDisplay,
          text: aSetDisplay + alturaMargemUpDisplay + alturaLimiteUpDisplay,
          valid: true
        },
        //fluxo
        media_fluxoS: (result.total.fluxo.media ? result.total.fluxo.media : 0),// fluxoMedioTeste,
        corretoFlxS: (result.total.fluxo.correto ? result.total.fluxo.correto : 0),
        aceitavelFlxInfS: (result.total.fluxo.aceitavel.down ? result.total.fluxo.aceitavel.down : 0),
        aceitavelFlxSupS: (result.total.fluxo.aceitavel.up ? result.total.fluxo.aceitavel.up : 0),
        incorretaFlxInfS: (result.total.fluxo.inaceitavel.down ? result.total.fluxo.inaceitavel.down : 0),
        incorretaFlxSupS: (result.total.fluxo.inaceitavel.up ? result.total.fluxo.inaceitavel.up : 0),

        fluxoMargemDown: {
          value: fluxoMargemDownDisplay,
          text: fSetDisplay - fluxoMargemDownDisplay,
          valid: true
        },
        fluxoMargemUp: {
          value: fluxoMargemUpDisplay,
          text: fSetDisplay + fluxoMargemUpDisplay,
          valid: true
        },
        fluxoLimiteDown: {
          value: fluxoLimiteDownDisplay,
          text: fSetDisplay - fluxoMargemDownDisplay - fluxoLimiteDownDisplay,
          valid: true
        },
        fluxoLimiteUp: {
          value: fluxoLimiteUpDisplay,
          text: fSetDisplay + fluxoMargemUpDisplay + fluxoLimiteUpDisplay,
          valid: true
        },
        //velocidade
        media_velocidadeS: (result.total.velocidade.media ? result.total.velocidade.media : 0),
        corretoVlcS: (result.total.velocidade.correto ? result.total.velocidade.correto : 0),
        aceitavelVlcInfS: (result.total.velocidade.aceitavel.down ? result.total.velocidade.aceitavel.down : 0),
        aceitavelVlcSupS: (result.total.velocidade.aceitavel.up ? result.total.velocidade.aceitavel.up : 0),
        incorretaVlcInfS: (result.total.velocidade.inaceitavel.down ? result.total.velocidade.inaceitavel.down : 0),
        incorretaVlcSupS: (result.total.velocidade.inaceitavel.up ? result.total.velocidade.inaceitavel.up : 0),

        velocidadeMargemDown: {
          value: velocidadeMargemDownDisplay,
          text: vSetDisplay - velocidadeMargemDownDisplay,
          valid: true
        },
        velocidadeMargemUp: {
          value: velocidadeMargemUpDisplay,
          text: vSetDisplay + velocidadeMargemUpDisplay,
          valid: true
        },
        velocidadeLimiteDown: {
          value: velocidadeLimiteDownDisplay,
          text: vSetDisplay - velocidadeMargemDownDisplay - velocidadeLimiteDownDisplay,
          valid: true
        },
        velocidadeLimiteUp: {
          value: velocidadeLimiteUpDisplay,
          text: vSetDisplay + velocidadeMargemUpDisplay + velocidadeLimiteUpDisplay,
          valid: true
        },

        progress: false,
      };
      if (result.id_job) {
        state.id_job = result.id_job;
      }

      if (checkConfig[4]) {
        let converted = {
          velocidadeVSet: Units.convertSpeed(vvSet, 'km/h', res),
          velocidadeVMargemDown: {
            value: Units.convertSpeed(result.data.velocidadeVMargemDown, 'km/h', res),
            text: Units.roundValue(Units.convertSpeed(vvSet - result.data.velocidadeVMargemDown, 'km/h', res)),
            valid: true
          },
          velocidadeVMargemUp: {
            value: Units.convertSpeed(result.data.velocidadeVMargemUp, 'km/h', res),
            text: Units.roundValue(Units.convertSpeed(vvSet + result.data.velocidadeVMargemUp, 'km/h', res)),
            valid: true
          },
          velocidadeVLimiteDown: {
            value: Units.convertSpeed(result.data.velocidadeVLimiteDown, 'km/h', res),
            text: Units.roundValue(Units.convertSpeed(vvSet - result.data.velocidadeVMargemDown - result.data.velocidadeVLimiteDown, 'km/h', res)),
            valid: true
          },
          velocidadeVLimiteUp: {
            value: Units.convertSpeed(result.data.velocidadeVLimiteUp, 'km/h', res),
            text: Units.roundValue(Units.convertSpeed(vvSet + result.data.velocidadeVMargemUp + result.data.velocidadeVLimiteUp, 'km/h', res)),
            valid: true
          }
        };

        if (res.LINGUA === 'en-US') {
          converted = {
            ...converted,
            temperaturaSet: tools.c_to_f(tSet),
            temperaturaMargemDown: {
              value: tools.c_to_f(tSet) - tools.c_to_f(tSet - result.data.temperaturaMargemDown),
              text: tools.round(tools.c_to_f(tSet - result.data.temperaturaMargemDown), 2),
              valid: true
            },
            temperaturaMargemUp: {
              value: tools.c_to_f(tSet + result.data.temperaturaMargemUp) - tools.c_to_f(tSet),
              text: tools.round(tools.c_to_f(tSet + result.data.temperaturaMargemUp), 2),
              valid: true
            },
            temperaturaLimiteDown: {
              value: tools.c_to_f(tSet) - (tools.c_to_f(tSet) - tools.c_to_f(tSet - result.data.temperaturaMargemDown)) - tools.c_to_f(tSet - result.data.temperaturaMargemDown - result.data.temperaturaLimiteDown),
              text: tools.round(tools.c_to_f(tSet - result.data.temperaturaMargemDown - result.data.temperaturaLimiteDown), 2),
              valid: true
            },
            temperaturaLimiteUp: {
              value: tools.c_to_f(tSet + result.data.temperaturaMargemUp + result.data.temperaturaLimiteUp) - tools.c_to_f(tSet) - (tools.c_to_f(tSet + result.data.temperaturaMargemUp) - tools.c_to_f(tSet)),
              text: tools.round(tools.c_to_f(tSet + result.data.temperaturaMargemUp + result.data.temperaturaLimiteUp), 2),
              valid: true
            }
          };
        } else {
          converted = {
            ...converted,
            temperaturaSet: tSet,
            temperaturaMargemDown: { value: result.data.temperaturaMargemDown, text: tSet - result.data.temperaturaMargemDown, valid: true },
            temperaturaMargemUp: { value: result.data.temperaturaMargemUp, text: tSet + result.data.temperaturaMargemUp, valid: true },
            temperaturaLimiteDown: { value: result.data.temperaturaLimiteDown, text: tSet - result.data.temperaturaMargemDown - result.data.temperaturaLimiteDown, valid: true },
            temperaturaLimiteUp: { value: result.data.temperaturaLimiteUp, text: tSet + result.data.temperaturaMargemUp + result.data.temperaturaLimiteUp, valid: true }
          };
        }
        state = {
          ...state, ...converted, ...{
            //velocidade vento
            media_velocidade_ventoS: (result.total.vento_velocidade.media ? result.total.vento_velocidade.media : 0),
            corretoVlcVS: (result.total.vento_velocidade.correto ? result.total.vento_velocidade.correto : 0),
            aceitavelVlcVInfS: (result.total.vento_velocidade.aceitavel.down ? result.total.vento_velocidade.aceitavel.down : 0),
            aceitavelVlcVSupS: (result.total.vento_velocidade.aceitavel.up ? result.total.vento_velocidade.aceitavel.up : 0),
            incorretaVlcVInfS: (result.total.vento_velocidade.inaceitavel.down ? result.total.vento_velocidade.inaceitavel.down : 0),
            incorretaVlcVSupS: (result.total.vento_velocidade.inaceitavel.up ? result.total.vento_velocidade.inaceitavel.up : 0),

            //angulo vento                          
            //media_angulo_ventoS: (result.total.vento_angulo.media ? result.total.vento_angulo.media : 0),
            corretoAngVS: (result.total.vento_angulo.correto.left ? result.total.vento_angulo.correto.left + result.total.vento_angulo.correto.right : 0),
            aceitavelAngVInfS: (result.total.vento_angulo.aceitavel.left ? result.total.vento_angulo.aceitavel.left.down + result.total.vento_angulo.aceitavel.right.down : 0),
            aceitavelAngVSupS: (result.total.vento_angulo.aceitavel.left ? result.total.vento_angulo.aceitavel.left.up + result.total.vento_angulo.aceitavel.right.up : 0),
            incorretaAngVInfS: (result.total.vento_angulo.inaceitavel.left ? result.total.vento_angulo.inaceitavel.left.down + result.total.vento_angulo.inaceitavel.right.down : 0),
            incorretaAngVSupS: (result.total.vento_angulo.inaceitavel.left ? result.total.vento_angulo.inaceitavel.left.up + result.total.vento_angulo.inaceitavel.right.up : 0),

            media_angulo_up: result.total.vento_angulo.media.up,
            media_angulo_down: result.total.vento_angulo.media.down,
            //delta-t
            media_DeltaTS: (result.total.deltaT.media),
            corretoDeltaT: (result.total.deltaT.correto ? result.total.deltaT.correto : 0),
            aceitavelDeltaTInfS: (result.total.deltaT.aceitavel.down ? result.total.deltaT.aceitavel.down : 0),
            aceitavelDeltaTSupS: (result.total.deltaT.aceitavel.up ? result.total.deltaT.aceitavel.up : 0),
            incorretaDeltaTInfS: (result.total.deltaT.inaceitavel.down ? result.total.deltaT.inaceitavel.down : 0),
            incorretaDeltaTSupS: (result.total.deltaT.inaceitavel.up ? result.total.deltaT.inaceitavel.up : 0),

            //temperatura
            media_temperaturaS: (result.total.temperatura.media ? result.total.temperatura.media : 0),
            corretoTempVS: (result.total.temperatura.correto ? result.total.temperatura.correto : 0),
            aceitavelTempInfS: (result.total.temperatura.aceitavel.down ? result.total.temperatura.aceitavel.down : 0),
            aceitavelTempSupS: (result.total.temperatura.aceitavel.up ? result.total.temperatura.aceitavel.up : 0),
            incorretaTempInfS: (result.total.temperatura.inaceitavel.down ? result.total.temperatura.inaceitavel.down : 0),
            incorretaTempSupS: (result.total.temperatura.inaceitavel.up ? result.total.temperatura.inaceitavel.up : 0),

            //humidade
            media_UmidadeS: (result.total.humidade.media ? result.total.humidade.media : 0),
            corretoUmiVS: (result.total.humidade.correto ? result.total.humidade.correto : 0),
            aceitavelUmiInfS: (result.total.humidade.aceitavel.down ? result.total.humidade.aceitavel.down : 0),
            aceitavelUmiSupS: (result.total.humidade.aceitavel.up ? result.total.humidade.aceitavel.up : 0),
            incorretaUmiInfS: (result.total.humidade.inaceitavel.down ? result.total.humidade.inaceitavel.down : 0),
            incorretaUmiSupS: (result.total.humidade.inaceitavel.up ? result.total.humidade.inaceitavel.up : 0),

            anguloVMargemDown: {
              value: result.data.anguloVMargemDown,
              text: result.data.anguloVMargemDown,
              valid: true
            },
            anguloVMargemUp: {
              value: result.data.anguloVMargemUp,
              text: result.data.anguloVMargemUp,
              valid: true
            },
            anguloVLimiteDown: {
              value: result.data.anguloVLimiteDown,
              text: result.data.anguloVMargemDown + result.data.anguloVLimiteDown,
              valid: true
            },
            anguloVLimiteUp: {
              value: result.data.anguloVLimiteUp,
              text: result.data.anguloVMargemUp + result.data.anguloVLimiteUp,
              valid: true
            },

            umidadeSet: hSet,
            umidadeMargemDown: {
              value: result.data.UmidadeMargemDown,
              text: hSet - result.data.UmidadeMargemDown,
              valid: true
            },
            umidadeMargemUp: {
              value: result.data.UmidadeMargemUp,
              text: hSet + result.data.UmidadeMargemUp,
              valid: true
            },
            umidadeLimiteDown: {
              value: result.data.UmidadeLimiteDown,
              text: hSet - result.data.UmidadeMargemDown - result.data.UmidadeLimiteDown,
              valid: true
            },
            umidadeLimiteUp: {
              value: result.data.UmidadeLimiteUp,
              text: hSet + result.data.UmidadeMargemUp + result.data.UmidadeLimiteUp,
              valid: true
            },
          }
        };
      }
      this.setState(state, () => {
        this.loadResultProfile(nomePerfil, () => {
          this.loadResult(result);
        });
      });
    });

  }

  getAreas = (id_job) => {
    if (!id_job) {
      this.onCloseEditMap(this.polygonsDefault, false);
    } else {
      let apiUrl = Config.server + '/job_area/' + id_job + '/area';
      let method = 'GET';

      let options = {
        method: method,
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt')
        }
      }

      fetch(apiUrl, options)
        .then((res) => {
          if (res.status !== 200) throw res;
          else return res.json();
        })
        .then(
          (result) => {
            //this.setState({ progress: false });
            if (result.length > 0) {
              this.onCloseEditMap(result, false);
            } else {
              this.onCloseEditMap(this.polygonsDefault, false);
            }
          },
          (error) => {
            this.setState({ progress: false });
            if (error.status === 405) {
              notification.open({
                message: this.props.res.PERMISSAO,
                description: this.props.res.PERMISSAO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            } else if (error.status === 401 || error.status === 403) {
              console.log(error);
              this.props.link('/login');
            }
            else {
              console.log(error);
              notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            }
          }
        );
    }
  };

  loadResult = (result) => {
    this.seekLineCache = null;

    const autoOpenReplay3D = this.autoOpenReplay3DRequested || this.shouldOpenReplay3DFromUrl();
    this.replay3DClimateTimeline = [];
    this.replay3DClimatePeriod = null;
    this.replay3DClimateKey = null;
    this.replay3DClimateRequest = null;
    this.replay3DClimateRequestKey = null;

    const state = {
      data: result,
      valueBar: 0,
      autoReplay3DOpening: false,
      climateTimeline: [],
      climatePeriod: null,
      externalClimateLoading: false
    };

    if (autoOpenReplay3D) {
      this.pendingReplay3DQualityResult = result;
      state.polygons = Array.isArray(result.polygons) ? result.polygons : [];
      state.tabMenu = '1';

      this.setState(state, () => {
        Promise.all([
          this.loadReplay3DClimate(result),
          this.ensureReplay3DPlaneFromUrl()
        ]).finally(() => {
          this.setState({
            showReplay3D: true,
            climateTimeline: this.replay3DClimateTimeline || [],
            climatePeriod: this.replay3DClimatePeriod || null
          });
        });
      });
      return;
    }

    this.setState(state, () => {
      this.loadReplay3DClimate(result);
    });
    this.exe(result);
    this.montaStaticData(result);
  };

  closeReplay3D = () => {
    const pendingResult = this.pendingReplay3DQualityResult;
    this.pendingReplay3DQualityResult = null;

    this.setState({ showReplay3D: false, autoReplay3DOpening: false }, () => {
      if (!pendingResult) return;

      this.exe(pendingResult);
      this.montaStaticData(pendingResult);
    });
  };

  exe = (result, options = {}) => {
    const {
      autoPlay = true,
      startIndex: rawStartIndex = 1,
      startSize = 0,
      forcePlay = false,
      instant = false,
      silentSeek = false,
      stopAt = null,
      skipFitBounds = false,
      skipPolygons = false,
      onStop = null,
      skipChart = false,
      skipBarChart = false,
      skipPieChart = false
    } = options;

    if (!skipPolygons) {
      for (let i = 0; i < result.polygons.length; i++) {
        const element = result.polygons[i];
        let poly = JSON.parse(element.points);
        //this.poly.push(turf.polygon([this.geoInvertArray(poly)]));
        this.polyMap({ poly: poly, type: element.type, guid: element.guid });
      }
    }

    let myStyle = this.styles.linha;
    if (result.pontos.length === 0) return;
    if (!result.path || result.path.length < 2) return;

    let startIndex = rawStartIndex;
    if (startIndex < 1) startIndex = 1;
    if (startIndex >= result.path.length) startIndex = result.path.length - 1;

    let startPoint = result.path[startIndex - 1];
    let nextPoint = result.path[startIndex];

    if (!startPoint || !nextPoint) return;

    let p1 = new L.LatLng(startPoint[0], startPoint[1]);

    this.line = new L.polyline([startPoint, nextPoint], myStyle);
    this.line.addTo(this.featureGroupL);

    let dIcon = null;
    let c = JSON.parse(localStorage.getItem('c-estimate'));
    if (c && c.base && c.base.length > 0) {
      dIcon = L.icon({
        iconUrl: Marks[11].img,
        iconAnchor: [13, 33]
      });
      this.marker.base = L.marker(p1, { icon: dIcon, pane: 'marks' });
    }

    dIcon = L.icon({
      iconUrl: Img_mark,
      iconAnchor: [21, 14],
      iconSize: [43.2, 28.8]
    });
    this.marker.marker = L.marker(p1, { icon: dIcon, pane: 'marks' });

    if (this.marker.base) {
      this.marker.base.addTo(this.featureGroupI);
    }

    this.marker.marker.addTo(this.featureGroupI);

    if (!skipFitBounds) {
      if (Object.keys(this.featureGroupPoly._layers).length > 0) {
        this.mymap.fitBounds(this.featureGroupPoly.getBounds());
      } else if (Object.keys(this.featureGroupI._layers).length > 0) {
        this.mymap.fitBounds(this.featureGroupI.getBounds());
      }
    }

    this.run = true;
    this.current_run = this.new_run;

    if (autoPlay === false) {
      this.pathMap(result, startIndex, startSize || 0, {
        forcePlay: forcePlay,
        instant: instant,
        silentSeek: silentSeek,
        stopAt: stopAt,
        onStop: onStop,
        skipChart: skipChart,
        skipBarChart: skipBarChart,
        skipPieChart: skipPieChart
      });
    } else {
      this.pathMap(result, 1, 0, {
        forcePlay: forcePlay,
        instant: instant,
        silentSeek: silentSeek,
        stopAt: stopAt,
        onStop: onStop,
        skipChart: skipChart,
        skipBarChart: skipBarChart,
        skipPieChart: skipPieChart
      });
    }
  };

  showExe = (show) => {
    if (show) {
      this.updatePieChart([this.state.correto - this.state.sobre, this.state.sobre, this.state.fora], 'aplicacao', '1');
      this.updatePieChart([this.state.correto - this.state.sobre, this.state.app_add ? this.state.app_add : 0, this.state.sobre, this.state.restante], 'area', '1');
      this.updatePieChart([this.state.corretoAlt, this.state.aceitavelAltInf, this.state.aceitavelAltSup, this.state.incorretaAltInf, this.state.incorretaAltSup], 'altura', '1');
      this.updatePieChart([this.state.corretoFlx, this.state.aceitavelFlxInf, this.state.aceitavelFlxSup, this.state.incorretaFlxInf, this.state.incorretaFlxSup], 'fluxo', '1');
      this.updatePieChart([this.state.corretoVlc, this.state.aceitavelVlcInf, this.state.aceitavelVlcSup, this.state.incorretaVlcInf, this.state.incorretaVlcSup], 'velocidade', '1');
    }
  };

  clear = (state, call) => {
    this.mymap.removeLayer(this.featureGroupI);
    this.featureGroupI.clearLayers();
    this.mymap.removeLayer(this.featureGroupL);
    this.featureGroupL.clearLayers();
    this.mymap.removeLayer(this.fGAPP['1']);
    this.fGAPP['1'].clearLayers();
    this.mymap.removeLayer(this.fGAPP['2']);
    this.fGAPP['2'].clearLayers();
    this.mymap.removeLayer(this.fGAPP['3']);
    this.fGAPP['3'].clearLayers();
    this.mymap.removeLayer(this.fGAPP['0']);
    this.fGAPP['0'].clearLayers();
    this.mymap.removeLayer(this.featureGroupPoly);
    this.featureGroupPoly.clearLayers();
    this.mymap.removeLayer(this.featureGroupLS);
    this.featureGroupLS.clearLayers();
    this.mymap.removeLayer(this.fGAPPS['1']);
    this.fGAPPS['1'].clearLayers();
    this.mymap.removeLayer(this.fGAPPS['2']);
    this.fGAPPS['2'].clearLayers();
    this.mymap.removeLayer(this.fGAPPS['3']);
    this.fGAPPS['3'].clearLayers();
    this.mymap.removeLayer(this.fGAPPS['0']);
    this.fGAPPS['0'].clearLayers();
    this.mymap.removeLayer(this.featureGroupPolyS);
    this.featureGroupPolyS.clearLayers();
    this.featureGroupTemp.clearLayers();

    this.featureAtual = {
      caminho: null,
      aplicacao: null,
      area: null,
      //icone: null
    };
    this.marker = {
      base: null,
      marker: null,
      angle: 45
    };
    this.marker_heat = null;
    this.run = true;
    this.current_run = 0;
    this.new_run = 0;
    this.iPlay = 1;
    this.line = null;
    this.altura = [];
    this.fluxo = [];
    this.alturaS = [];
    this.fluxoS = [];
    this.selectedPath = null;

    this.lineClick = false;

    this.updatePieChart([0, 0, 0], 'aplicacao', '0');
    this.updatePieChart([0, 0, 0, 0], 'area', '0');
    this.updatePieChart([0, 0, 0, 0, 0], 'altura', '0');
    this.updatePieChart([0, 0, 0, 0, 0], 'fluxo', '0');

    const temp = {
      id_job: this.state.id_job,
      title: this.state.title,
      task: this.state.task,
      polygons_total: this.state.polygons_total,
      polygons_aplicados: this.state.polygons_aplicados,
      clients: this.state.clients,
      pilots: this.state.pilots,
      planes: this.state.planes,
      selectedPlaneId: this.state.selectedPlaneId,
      selectedPlaneAircraftBrand: this.state.selectedPlaneAircraftBrand,
      selectedPlaneIdAircraftBrand: this.state.selectedPlaneIdAircraftBrand
    };
    if (state) {
      this.setState(JSON.parse(JSON.stringify(this.base)), () => {
        this.setState(temp, () => {
          if (call) {
            call();
          }
        });
      });
    } else {
      if (call) {
        call();
      }
    }
    this.loadTask(false);
  };

  updateColorPath = (path, latlng, setValue, value, color, largura, index, addValue) => {
    const updateGraph = () => {
      if (!path.valores || index !== path.valores.index) {
        let valores = null;
        valores = {
          index: index,
          setValue: [setValue],
          value: [value],
          color: [color],
          b: ['']
        };
        if (addValue) {
          valores.addValue = [addValue];
        }
        path.valores = valores;
      } else {
        path.valores.setValue.push(setValue);
        path.valores.value.push(value);
        path.valores.color.push(color);
        path.valores.b.push('');
        if (addValue) {
          path.valores.addValue = [addValue];
        }
      }
    }

    //let color = this.getColor(value, margin, setValue, 2, 10, 'hex');
    const larguraFaixa = Number(largura);
    const anchor = this.getSwathAnchor(latlng);
    let last = path.item.length > 0 ? path.item[path.item.length - 1] : null;
    const shouldStartNewLayer = !last || last.options.color !== color || last._swathWidth !== larguraFaixa;

    if (last) {
      let last_latlng = last._latlngs;
      last_latlng.push(new L.LatLng(latlng[0], latlng[1]));
      last.setLatLngs(last_latlng);
      last._swathAnchor = anchor;
      if (!shouldStartNewLayer) {
        updateGraph();
      }
    }

    if (shouldStartNewLayer) {
      let temp_ll = last ? [last._latlngs[last._latlngs.length - 2], last._latlngs[last._latlngs.length - 1]] : null;
      let last_latlng = temp_ll ? temp_ll : latlng;
      last = L.polyline(last_latlng, {
        color: color,
        weight: this.getSwathPixelWidth(larguraFaixa, anchor),
        lineCap: 'butt',
        opacity: 1,
        smoothFactor: 1
      });
      last._swathWidth = larguraFaixa;
      last._swathAnchor = anchor;
      path.item.push(last);

      last.addTo(this.fGAPP[path.fGAPP_ID]);
      updateGraph();

      last.on("click", () => {
        this.showBarChart(true, path.item, path.valores);
      });
    }
  };

  scrollFluxoSetStaticToValue = (setValue) => {
    const isStatic = (this.state.tabMenu === '0' || this.state.tabMenu === '2');
    if (!isStatic) return;

    if (setValue === undefined || setValue === null || setValue === '') return;

    const key = String(Number(setValue));
    const elId = `divFloSet_${key}`;

    const el = document.getElementById(elId);
    if (!el) return;

    const divFlo = document.getElementById('divFlo');
    if (divFlo) {
      divFlo.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    setTimeout(() => {
      const el2 = document.getElementById(elId);
      if (el2) el2.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 250);
  };

  showBarChart = (show, item, valores) => {
    if (show) {
      this.barChart.resetZoom();
      this.selectedPath = { item: item, valores: valores };

      const tabItem = this.state.tabItens && this.state.tabItens[this.state.tab] ? this.state.tabItens[this.state.tab] : null;
      let extraState = null;

      if (tabItem && tabItem.type === 'fluxo' && valores && valores.value && valores.value.length) {
        let soma = 0;
        let count = 0;

        const setCount = {};

        for (let i = 0; i < valores.value.length; i++) {
          const v = Number(valores.value[i]);
          if (!isFinite(v)) continue;

          soma += v;
          count += 1;

          const sRaw = (valores.setValue && valores.setValue[i] != null) ? valores.setValue[i] : this.state.fluxoSet;
          const s = Number(sRaw);
          const setKey = String(isFinite(s) ? s : this.state.fluxoSet);
          setCount[setKey] = (setCount[setKey] || 0) + 1;
        }

        let fluxoSet = null;
        let maior = -1;
        for (const k in setCount) {
          if (setCount[k] > maior) {
            maior = setCount[k];
            fluxoSet = Number(k);
          }
        }

        extraState = {
          barInfoFluxo: {
            fluxoSet: isFinite(fluxoSet) ? fluxoSet : null,
            fluxoMedio: count > 0 ? (soma / count) : 0
          }
        };
      } else {
        extraState = { barInfoFluxo: null };
      }

      this.setState(Object.assign(
        { showChart: show, barTitle: this.props.res.TIRO + ' ' + (valores.index + 1), chartIndex: valores.index },
        extraState
      ));

      if (valores.setValue) {
        this.hoverBar({ index: 0 });
        //this.hoverBar({ datasetIndex: 0, index: valores.addValue[0].pos, pos: 'teste' });
        this.updateBarChart(valores);

        if (tabItem && tabItem.type === 'fluxo') {
          const setValue = (valores && valores.setValue && valores.setValue.length) ? valores.setValue[0] : null;
          this.scrollFluxoSetStaticToValue(setValue);
        }
      }

      this.lineClick = true;
    } else if (!this.lineClick) {
      this.removeMarkerHeat();
      this.setState({ showChart: show });
    } else {
      this.lineClick = false;
    }
  };

  selectTiroChart = (index, target) => {
    let i = index === null ? this.state.chartIndex + target : index;

    const type = this.state.tabItens[this.state.tab];
    const item = this.values[type.type][i];

    this.removeMarkerHeat();
    if (item) {
      this.showBarChart(true, item.line, item.valores);
    }
  };

  //buffer 
  limitPieChart = { last: Date.now() };
  bufferPieChart = (values, variavel, tipo) => {
    let limitTime = 500; //ms de intervalo entre o update da mesma variavel
    let limitLast = 50;  //ms de intervalo entre todos os update
    if (this.limitPieChart[variavel] && this.limitPieChart[variavel].timeout) {
      clearTimeout(this.limitPieChart[variavel].timeout);//reseta o timeout caso chame novamamente
    }
    //verifica se esta dentro do limitTime da mesma [variavel] e limitLast de todos os charts
    let newDate = Date.now();
    let canRunC = this.limitPieChart[variavel] && ((this.limitPieChart[variavel].lapsetime + limitTime) < newDate);
    let canRunL = this.limitPieChart[variavel] && ((this.limitPieChart.last + limitLast) < newDate);
    if (!this.limitPieChart[variavel] || (canRunL && canRunC)) {
      if (!this.limitPieChart[variavel]) {
        this.limitPieChart[variavel] = {};
      }
      this.limitPieChart[variavel].lapsetime = newDate;// + (limitLast * 2);
      this.limitPieChart.last = newDate;
      return true;
    } else {
      //timeout caso seja ultima vez chamado
      this.limitPieChart[variavel].timeout = setTimeout(() => {
        this.updatePieChart(values, variavel, tipo);
      }, canRunL ? limitLast : limitTime);
      return false;
    }
  };
  updatePieChart = (values, variavel, tipo, animation, force = false) => {
    values = values.map(value => Units.roundValue(value));

    if (force && this.limitPieChart[variavel] && this.limitPieChart[variavel].timeout) {
      clearTimeout(this.limitPieChart[variavel].timeout);
      this.limitPieChart[variavel].timeout = null;
    }

    if (force || this.bufferPieChart(values, variavel, tipo)) {
      this.pieChartData[tipo === '1' ? 'anime' : 'info'] = values;
      this.pieChart[variavel].data.datasets[0].data = values;
      this.pieChart[variavel].update();
      let v = 0;
      for (let i = 0; i < values.length; i++) {
        v += values[i];
      }
      let update = this.state.legend;
      for (let i = 0; i < values.length; i++) {
        update[variavel]['data' + (i + 1)] = v === 0 ? 0 : Math.round(100 * values[i] / v);
      }
      this.setState({ legend: update });
    }
  };
  createPieChart = (canvas, variavel, tipo) => {
    this.pieChartData[tipo === '1' ? 'anime' : 'info'] = [0, 0, 0];
    let ctx = document.getElementById(canvas).getContext('2d');
    let colors = variavel === 'aplicacao'
      ? [
        this.styles.correto_static.color,
        this.styles.sobre_static.light_color,
        this.styles.fora_static.color,
      ]
      : variavel === 'area'
        ? [
          this.styles.correto_static.color,
          this.styles.app_add_static.color,
          this.styles.sobre_static.light_color,
          this.styles.area_static.color,
        ]
        : [
          this.styles.stripColor.correto,
          this.styles.stripColor.aceitavelInf,
          this.styles.stripColor.aceitavelSup,
          this.styles.stripColor.incorretaInf,
          this.styles.stripColor.incorretaSup,
        ];


    this.pieChart[variavel] = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: false,
        datasets: [{
          backgroundColor: colors,
          data: colors.map((item, key) => (0))
        }]
      }
    });
  };

  updateBarChart = (valores) => {
    if (valores && valores.b.length > 0) {
      this.barChart.data.datasets[1].data = valores.value;
      this.barChart.data.datasets[0].data = valores.setValue;
      this.barChart.data.datasets[1].backgroundColor = valores.color;
      this.barChart.data.labels = valores.b;
      this.barChart.data.addValue = valores.addValue;
    }

    this.barChart.update();
  };

  syncPieChartsFluxoPorSetStatic = () => {
    const sets = (this.state.fluxoSetsAplicacaoStatic && this.state.fluxoSetsAplicacaoStatic.length)
      ? this.state.fluxoSetsAplicacaoStatic
      : [];

    if (!sets.length) return;

    for (let i = 0; i < sets.length; i++) {
      const setValor = sets[i];
      const chave = String(setValor);

      const stats = (this.state.fluxoPorSetStatic && this.state.fluxoPorSetStatic[chave])
        ? this.state.fluxoPorSetStatic[chave]
        : null;

      if (!stats) continue;

      const corretoSet = (typeof stats.correto === 'number') ? stats.correto : 0;
      const aceitavelInfSet = (typeof stats.aceitavelInf === 'number') ? stats.aceitavelInf : 0;
      const aceitavelSupSet = (typeof stats.aceitavelSup === 'number') ? stats.aceitavelSup : 0;
      const incorretaInfSet = (typeof stats.incorretaInf === 'number') ? stats.incorretaInf : 0;
      const incorretaSupSet = (typeof stats.incorretaSup === 'number') ? stats.incorretaSup : 0;

      const canvasId = `pieChart4_${chave}`;
      const variavelKey = `fluxo_${chave}`;

      const canvasEl = document.getElementById(canvasId);
      if (!canvasEl) continue;

      if (!this.pieChart) this.pieChart = {};

      if (!this.pieChart[variavelKey]) {
        this.createPieChart(canvasId, variavelKey, this.state.tabMenu);
      }

      const values = [
        corretoSet,
        aceitavelInfSet,
        aceitavelSupSet,
        incorretaInfSet,
        incorretaSupSet,
      ];

      this.pieChart[variavelKey].data.datasets[0].data = values;
      this.pieChart[variavelKey].update();
    }
  };

  createBarChart = () => {
    var ctx = document.getElementById("barChart").getContext('2d');
    this.barChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: [],
        datasets: [{
          type: 'line',  // override the default type
          data: [],
          borderColor: 'rgb(0, 0, 0)',
          borderWidth: 1
        }, {
          data: [],
          backgroundColor: [],
        }]
      },
      options: {
        elements: {
          point: {
            radius: 0
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              footer: (info) => {
                const mode = this.barChart.data.addValue ?
                  this.barChart.data.addValue[info[0].dataIndex].mode === 0 ? 'Manual' :
                    this.barChart.data.addValue[info[0].dataIndex].mode === 1 ? 'Automático' :
                      'Under flow' : null;
                return !this.barChart.data.addValue ? null :
                  `pos: ${this.barChart.data.addValue[info[0].dataIndex].pos}\n${mode}`;
              }
            }
          },
          zoom: {
            pan: {
              enabled: true,
              mode: 'x',
              modifierKey: 'ctrl',
            },
            zoom: {
              drag: {
                enabled: true
              },
              mode: 'x',
            },
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              display: false,
            },
          },
          X: {
            grid: {
              display: false,
            },
          }
        },
        maintainAspectRatio: false,
        onHover: (evt, item) => {
          if (item.length) {
            this.hoverBar(item[0]);
          }
        },
        onClick: (evt, item) => {
          if (item.length) {
            //console.log(">data", item[0]._index);
          }
        }
      }
    });
  };
  hoverBar = (item) => {
    //console.log('item', item);
    if (item.pos) return;

    if (item) {
      this.removeMarkerHeat();
      let value = 0
      let cood = null;
      let total = 0;
      let plane_direction = 0
      let wind_direction = 0;
      for (let i = 0; i < this.selectedPath.item.length; i++) {
        let n = this.selectedPath.item[i]._latlngs.length - 1;
        total += n;
        if (item.index <= total) {
          total -= n;
          cood = this.selectedPath.item[i]._latlngs[item.index - total];
          if (this.selectedPath.valores.setValue) {
            value = this.selectedPath.valores.value[item.index];
          }
          if (this.selectedPath.valores.type === 'direcaoVento') {
            plane_direction = this.selectedPath.valores.plane_direction[item.index];
            wind_direction = this.selectedPath.valores.wind_direction[item.index];
          }
          break;
        }
        total -= 1;
      }

      let up = null;
      let down = null;
      if (this.selectedPath.valores.type === 'altura') {
        up = this.state.alturaMargemUp.value;
        down = this.state.alturaMargemDown.value;
      } else if (this.selectedPath.valores.type === 'fluxo') {
        up = this.state.fluxoMargemUp.value;
        down = this.state.fluxoMargemDown.value;
      } else if (this.selectedPath.valores.type === 'velocidade') {
        up = this.state.velocidadeMargemUp.value;
        down = this.state.velocidadeMargemDown.value;
      } else if (this.selectedPath.valores.type === 'velocidadeVento') {
        up = this.state.velocidadeVMargemUp.value;
        down = this.state.velocidadeVMargemDown.value;
      } else if (this.selectedPath.valores.type === 'direcaoVento') {
        up = this.state.anguloVMargemUp.value;
        down = this.state.anguloVMargemDown.value;

        this.updatePlaneGraph(plane_direction, wind_direction);

      } else if (this.selectedPath.valores.type === 'temperatura') {
        up = this.state.temperaturaMargemUp.value;
        down = this.state.temperaturaMargemDown.value;
      } else if (this.selectedPath.valores.type === 'humidade') {
        up = this.state.umidadeMargemUp.value;
        down = this.state.umidadeMargemDown.value;
      } else if (this.selectedPath.valores.type === 'deltaT') {
        up = 2;
        down = 8;
      }

      let icon = value > up.value ? Img_up
        : value < down.value ? Img_down
          : Img_fine;
      let dIcon = L.icon({
        iconUrl: icon,
        iconSize: [30, 48],
        iconAnchor: [18, 50]
      });
      this.marker_heat = L.marker(cood, { icon: dIcon, pane: 'marks' });
      this.marker_heat.addTo(this.featureGroupTemp);
    }
  };

  updatePlaneGraph = (plane_direction, wind_direction) => {
    this.setState({ angulo_plane: plane_direction, angulo_wind: wind_direction })
  };

  removeMarkerHeat = () => {
    if (this.marker_heat) {
      this.featureGroupTemp.removeLayer(this.marker_heat);
    }
  };

  downloadRel = () => {
    let apiUrl = Config.server + '/relanalise';
    let method = 'POST';

    const formData = new URLSearchParams();
    formData.append('culture', this.props.res.LINGUA);
    formData.append('task', this.state.task);
    formData.append('checkResumo', this.state.checkResumo);
    formData.append('checkDetailFluxo', this.state.checkDetailFluxo);
    formData.append('checkMapa', this.state.checkMapa);
    formData.append('checkResumoCobertura', this.state.checkResumoCobertura);
    formData.append('checkResumoAltura', this.state.checkResumoAltura);
    formData.append('checkResumoFluxo', this.state.checkResumoFluxo);
    formData.append('checkResumoVelocidade', this.state.checkResumoVelocidade);
    formData.append('checkResumoDeltat', this.state.checkResumoDeltat);
    formData.append('checkResumoTemperatura', this.state.checkResumoTemperatura);
    formData.append('checkResumoUmidade', this.state.checkResumoUmidade);
    formData.append('checkResumoVelocidadeVento', this.state.checkResumoVelocidadeVento);
    formData.append('checkResumoAnguloVento', this.state.checkResumoAnguloVento);

    let options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.blob();
      })
      .then(
        (result) => {
          this.setState({ progress: false });
          let file_name = "ALS" + (this.state.title_sk && this.state.title === '...' ? this.state.title_sk : this.state.title).replace(/[^a-z0-9_]/gi, "") + '.pdf';
          if (result.type === 'application/pdf' && result.size > 0) {
            saveAs(result, file_name);
          } else {
            console.log(result);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };


  normalizeReplay3DText = (value) => {
    if (value === null || value === undefined) return '';

    let text = String(value).toLowerCase();

    if (text.normalize) {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return text;
  };

  getPlaneDisplayName = (plane) => {
    if (!plane) return '';

    if (plane.name !== null && plane.name !== undefined) {
      return String(plane.name);
    }

    if (plane.original_name !== null && plane.original_name !== undefined) {
      return String(plane.original_name);
    }

    return '';
  };

  getSelectedPlaneFromState = () => {
    const planes = Array.isArray(this.state.planes) ? this.state.planes : [];
    const selectedPlaneId = this.state.selectedPlaneId;
    const aeronave = this.state.aeronave ? String(this.state.aeronave).trim() : '';

    if (selectedPlaneId !== null && selectedPlaneId !== undefined && selectedPlaneId !== '') {
      for (let i = 0; i < planes.length; i++) {
        if (planes[i] && Number(planes[i].id) === Number(selectedPlaneId)) {
          return planes[i];
        }
      }
    }

    if (!aeronave) return null;

    const aeronaveNormalized = this.normalizeReplay3DText(aeronave);

    for (let i = 0; i < planes.length; i++) {
      const plane = planes[i];
      if (!plane) continue;

      const nameNormalized = this.normalizeReplay3DText(plane.name);
      const originalNameNormalized = this.normalizeReplay3DText(plane.original_name);

      if (nameNormalized === aeronaveNormalized || originalNameNormalized === aeronaveNormalized) {
        return plane;
      }
    }

    let possiblePlanes = [];
    for (let i = 0; i < planes.length; i++) {
      const plane = planes[i];
      if (!plane) continue;

      const nameNormalized = this.normalizeReplay3DText(plane.name);
      const originalNameNormalized = this.normalizeReplay3DText(plane.original_name);

      if (
        (nameNormalized && nameNormalized.indexOf(aeronaveNormalized) >= 0) ||
        (originalNameNormalized && originalNameNormalized.indexOf(aeronaveNormalized) >= 0)
      ) {
        possiblePlanes.push(plane);
      }
    }

    return possiblePlanes.length === 1 ? possiblePlanes[0] : null;
  };

  getPlaneAircraftBrandName = (plane) => {
    return plane && plane.aircraftbrand ? plane.aircraftbrand : '';
  };

  normalizeReplay3DModelId = (value) => {
    const text = this.normalizeReplay3DText(value).trim();
    const compactText = text.replace(/[^a-z0-9]+/g, '');

    if (text === 'emb200' || compactText === 'emb200') return 'emb200';
    if (text === 'air-tractor-at-502b' || compactText === 'airtractorat502b') return 'air-tractor-at-502b';
    if (text === 'air-tractor-at-802' || compactText === 'airtractorat802') return 'air-tractor-at-802';
    if (text === 'cessna-188' || compactText === 'cessna188') return 'cessna-188';

    return '';
  };

  getPlaneModel3D = (plane) => {
    return this.normalizeReplay3DModelId(plane && plane.model3D);
  };

  getPlaneReplay3DIdentificationText = (plane) => {
    if (!plane) return '';

    return this.normalizeReplay3DText(
      [plane.aircraftbrand, plane.aircraftmodel].filter(Boolean).join(' ')
    );
  };

  inferReplay3DModelId = (plane) => {
    const text = this.getPlaneReplay3DIdentificationText(plane);
    const compactText = text.replace(/[^a-z0-9]+/g, '');

    if (compactText.indexOf('cessna') >= 0) {
      return 'cessna-188';
    }

    const isAirTractor = compactText.indexOf('airtractor') >= 0;
    if (isAirTractor && compactText.indexOf('802') >= 0) {
      return 'air-tractor-at-802';
    }

    if (isAirTractor) {
      return 'air-tractor-at-502b';
    }

    return 'emb200';
  };

  getReplay3DModelType = () => {
    const plane = this.getSelectedPlaneFromState();
    const model3D = this.getPlaneModel3D(plane);
    const inferredModel3D = this.inferReplay3DModelId(plane);
    const selectedModel3D = model3D || inferredModel3D;

    return selectedModel3D;
  };

  getReplay3DModelItemText = (item, depth) => {
    if (item === null || item === undefined) return '';
    if (depth === undefined) depth = 0;
    if (depth > 2) return '';

    if (typeof item === 'string' || typeof item === 'number') {
      return this.normalizeReplay3DText(item);
    }

    if (Array.isArray(item)) {
      let arrayText = '';
      for (let i = 0; i < item.length; i++) {
        arrayText += ' ' + this.getReplay3DModelItemText(item[i], depth + 1);
      }
      return arrayText;
    }

    if (typeof item === 'object') {
      const keys = [
        'id',
        'key',
        'code',
        'type',
        'name',
        'label',
        'title',
        'model',
        'modelName',
        'aircraft',
        'brand',
        'url',
        'path',
        'file'
      ];

      let text = '';
      for (let i = 0; i < keys.length; i++) {
        if (item[keys[i]] !== null && item[keys[i]] !== undefined) {
          text += ' ' + this.getReplay3DModelItemText(item[keys[i]], depth + 1);
        }
      }
      return text;
    }

    return '';
  };

  matchReplay3DModelItem = (item, modelType) => {
    const text = this.getReplay3DModelItemText(item);
    const compactText = text.replace(/[\s_-]+/g, '');

    if (modelType === 'airtractor') {
      return compactText.indexOf('airtractor') >= 0;
    }

    return compactText.indexOf('emb200') >= 0 ||
      compactText.indexOf('embraer') >= 0;
  };

  reorderReplay3DModelArray = (models, modelType) => {
    if (!Array.isArray(models) || models.length <= 1) return models;

    let selectedIndex = -1;

    for (let i = 0; i < models.length; i++) {
      if (this.matchReplay3DModelItem(models[i], modelType)) {
        selectedIndex = i;
        break;
      }
    }

    if (selectedIndex <= 0) return models;

    const selectedModel = models[selectedIndex];
    const orderedModels = [selectedModel];

    for (let i = 0; i < models.length; i++) {
      if (i !== selectedIndex) {
        orderedModels.push(models[i]);
      }
    }

    return orderedModels;
  };

  getReplay3DModelCatalog = () => {
    const modelType = this.getReplay3DModelType();
    const catalog = aircraftReplay3DModel;

    if (Array.isArray(catalog)) {
      return this.reorderReplay3DModelArray(catalog, modelType);
    }

    if (catalog && typeof catalog === 'object') {
      const listKeys = ['models', 'items', 'aircrafts', 'aircraft', 'planes', 'catalog'];

      for (let i = 0; i < listKeys.length; i++) {
        const key = listKeys[i];

        if (Array.isArray(catalog[key])) {
          const newCatalog = Object.assign({}, catalog);
          newCatalog[key] = this.reorderReplay3DModelArray(catalog[key], modelType);
          return newCatalog;
        }
      }
    }

    return catalog;
  };

  selectPlane = (plane) => {
    if (!plane) return;

    const planeName = this.getPlaneDisplayName(plane);
    const aircraftBrand = this.getPlaneAircraftBrandName(plane);
    const idAircraftBrand = plane.id_aircraftbrand !== null && plane.id_aircraftbrand !== undefined
      ? plane.id_aircraftbrand
      : null;

    this.setState({
      aeronave: planeName,
      selectedPlaneId: plane.id !== null && plane.id !== undefined ? plane.id : null,
      selectedPlaneAircraftBrand: aircraftBrand,
      selectedPlaneIdAircraftBrand: idAircraftBrand
    });
  };

  handlePlaneChange = (event) => {
    this.setState({
      aeronave: event.target.value,
      selectedPlaneId: null,
      selectedPlaneAircraftBrand: '',
      selectedPlaneIdAircraftBrand: null
    });
  };

  getAuto = (api, variavel) => {
    let apiUrl = Config.server + '/' + api;
    let method = 'GET';

    let options = {
      method: method,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          const list = Array.isArray(result) ? result : [];

          this.setState({ [variavel]: list }, () => {
            if (variavel === 'planes') {
              const selectedPlane = this.getSelectedPlaneFromState();

              if (selectedPlane) {
                this.setState({
                  selectedPlaneId: selectedPlane.id !== null && selectedPlane.id !== undefined ? selectedPlane.id : null,
                  selectedPlaneAircraftBrand: this.getPlaneAircraftBrandName(selectedPlane),
                  selectedPlaneIdAircraftBrand: selectedPlane.id_aircraftbrand !== null && selectedPlane.id_aircraftbrand !== undefined ? selectedPlane.id_aircraftbrand : null
                });
              }
            }
          });
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          } else if (error.status === 400) {
            error.json().then(
              (errCode) => {
                notification.open({
                  message: this.props.res[errCode.code],
                  icon: <MaterialIcon icon="error" className="text-danger" />
                });
              });
          } else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  geojsonToLeafletArray = (poly) => {
    let array = [];
    for (let i = 0; i < poly.length; i++) {
      const element = poly[i];
      if (element) {
        array = array.concat([[element[1], element[0]]]);
      }
    }
    return array
  };
  callNew = () => {
    this.setState({
      clear: true,
      new: {
        msg: this.props.res.NOVO_ANALISE_CONFIRM,
        func: () => {
          this.clear(true, () => {
            //this.setState({ id_job: this.state.id_job, task: this.state.task });
          }
          );
          localStorage.setItem('check-task', 'null');
        }
      }
    });
  };

  updateMap = (type, featureGroup) => {
    if (this.featureAtual[type]) this.mymap.removeLayer(this.featureAtual[type]);
    this.featureAtual[type] = featureGroup;
    let types = this.state.listTypes.filter(item => item.type === type);
    if (types.length > 0 && types[0].active) {
      this.featureAtual[type].addTo(this.mymap);

      if (type === 'area' || type === 'aplicacao') this.checkTitleMap(this.state.listTypes);
    }
  };

  setStack = (item) => {
    let list = this.state.listTypes;
    item.active = !item.active;
    this.setState({ listTypes: list });
    //remove ou add layers no mapa
    if (item.type !== 'name') {
      if (item.active) {
        this.featureAtual[item.type].addTo(this.mymap);
      } else {
        this.mymap.removeLayer(this.featureAtual[item.type]);
      }
    }
    //remove ou add label no mapa
    if (item.type === 'area' || item.type === 'name') this.checkTitleMap(list);
  };

  checkTitleMap = (list) => {
    //let show = list[2].active || list[1].active ? (list[2].active ? 1 : 2) : 0;
    for (let tag in this.polyNames) {
      if (list[2].active && !tag.includes('_h')) {
        const myLayer = this.mymap._layers[tag];
        if (myLayer !== undefined) {
          if (list[3].active) {
            myLayer.unbindTooltip();
            myLayer.bindTooltip(this.polyNames[tag],
              { permanent: true, direction: "center", className: 'tool-tip-L tool-tip-size16-L' }
            ).openTooltip();
          } else {
            myLayer.unbindTooltip();
          }
        }
      }
    }
  }

  onCloseEditMap = (itens, move = true) => {
    this.changeTabMenu(this.state.tabMenu);
    if (!itens || !(itens instanceof Array) || itens.length === 0) {
      this.setState({ showForm: false });
      return;
    }
    this.clear(false, () => {
      this.featureGroupPoly.addTo(this.mymap);
      for (let i = 0; i < itens.length; i++) {
        this.polyMap(itens[i]);
      }
      if (itens.length > 0) this.mymap.fitBounds(this.featureGroupPoly.getBounds());
      let state = { showForm: false };
      if (itens && itens.length > 0) state.polygons = itens;
      this.setState(state, () => {
        if (move) document.getElementById("divAreas").scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  };

  getBackgroud = () => {
    if (this.typeMapItem === 'analise') {
      return null;
    } else {
      if (this.featureAtual['area']) this.mymap.removeLayer(this.featureAtual['area']);
      if (this.featureAtual['caminho']) this.mymap.removeLayer(this.featureAtual['caminho']);
      if (this.featureAtual['aplicacao']) this.mymap.removeLayer(this.featureAtual['aplicacao']);

      let type = this.state.tabMenu;
      let tab = this.state.tab;
      let poly = null;
      let path = null;
      let app = null;
      let back = [];
      if (type === '0' || type === '2') {
        poly = this.featureGroupPolyS;
        path = this.featureGroupLS;
        if (tab === '0') {
          app = this.fGAPPS[this.state.tab];
        } else {
          for (let item in this.fGAPPS[this.state.tab]._layers) {
            if (item.includes('_h')) back.push(this.fGAPPS[this.state.tab]._layers[item]);
          }
          if (tab === '1') {
            app = this.alturaS;
          } else if (tab === '2') {
            app = this.fluxoS;
          } else if (tab === '3') {
            app = this.velocidadeS;
          }
        }
      } else if (type === '1') {
        poly = this.featureGroupPoly;
        path = this.this.featureGroupL;
        if (tab === '0') {
          app = this.this.fGAPP[this.state.tab];
        } else {
          for (let item in this.fGAPP[this.state.tab]._layers) {
            if (item.includes('_h')) back.push(this.fGAPP[this.state.tab]._layers[item]);
          }
          if (tab === '1') {
            app = this.altura;
          } else if (tab === '2') {
            app = this.fluxo;
          } else if (tab === '3') {
            app = this.velocidade;
          }
        }
      }

      return { poly, back, path, app, type: tab, largura: this.state.larguraSet };
    }
  };

  showMapItem = (type) => {
    this.typeMapItem = type;
    this.setState({ showForm: true })
  };

  showAutoComplete = (divName) => (event) => {
    let dF = document.getElementById(divName);
    if (!dF) return;

    const show = () => {
      dF.classList.remove("sr-only");
      if (!dF.className.includes('autoDiv')) {
        dF.classList.add("autoDiv");
      }
    };

    const hide = () => {
      dF.classList.remove("autoDiv");
      if (!dF.className.includes('sr-only')) {
        dF.classList.add("sr-only");
      }
    };

    if (event && event.type === 'focus') {
      show();
      return;
    }

    if (event && event.type === 'blur') {
      setTimeout(() => hide(), 150);
      return;
    }

    if (!dF.className.includes('autoDiv')) {
      show();
    } else {
      hide();
    }
  };

  limitChar = (string, limit) => {
    let ret = string;
    let size = SPW(string, { font: "Arial", size: 16 });
    if (size > limit) {
      ret = string.slice(0, (string.length * (limit - 16) / size)) + '...';
    }
    return ret;
  };

  updateAccrodion = (div, is) => {
    this.acc[div] = !is;
  };

  regua = (start) => {
    if (this.state.create) {
      this.cancelCreate();
    }
    if (this.state.edit) {
      this.cancelEdit();
    }

    this.featureGroupTemp.removeLayer(this.mymap._layers['regua']);
    this.featureGroupTemp.removeLayer(this.mymap._layers['reguaM1']);
    this.featureGroupTemp.removeLayer(this.mymap._layers['reguaM2']);
    this.ruler_p.second.lat = null;
    this.ruler_p.second.lng = null;
    if (!start && (this.state.ruler_a || this.ruler_p.first.lat)) {
      this.setState({ ruler_a: false });
      this.mymap.dragging.enable();
      this.ruler_p = { first: { lat: null, lng: null }, second: { lat: null, lng: null } };
      if (this.drawCreateToolbar) {
        this.drawCreateToolbar.disable();
      }
    } else {
      this.setState({ ruler_a: true });
      this.drawCreateToolbar = new L.Draw.Polyline(this.mymap);
      this.drawCreateToolbar.enable();
      if (start) {
        this.drawCreateToolbar.addVertex(start);
      }
    }
  };

  completeRuler = () => {
    if (this.drawCreateToolbar) {
      this.drawCreateToolbar.disable();
    }

    let latlngs = [
      [this.ruler_p.first.lat, this.ruler_p.first.lng],
      [this.ruler_p.second.lat, this.ruler_p.second.lng]
    ];
    let latlngF = L.latLng([this.ruler_p.first.lat, this.ruler_p.first.lng]);
    let latlngS = L.latLng([this.ruler_p.second.lat, this.ruler_p.second.lng]);
    let text = latlngF.distanceTo(latlngS);


    let polyline = L.polyline(latlngs);

    polyline._leaflet_id = 'regua';
    polyline.bindTooltip(this.formatRegua(text), { permanent: true }).openTooltip()
    polyline.addTo(this.featureGroupTemp);

    let m1 = L.marker([this.ruler_p.first.lat, this.ruler_p.first.lng], {
      icon: new L.DivIcon({
        iconSize: new L.Point(10, 10),
        className: 'leaflet-div-icon leaflet-editing-icon my-own-icon',
      })
    })
    m1.on('mousedown', (e) => {
      this.mymap.dragging.disable();
      this.regua([this.ruler_p.second.lat, this.ruler_p.second.lng]);
    })
    m1._leaflet_id = 'reguaM1';
    m1.addTo(this.featureGroupTemp);

    let m2 = L.marker([this.ruler_p.second.lat, this.ruler_p.second.lng], {
      icon: new L.DivIcon({
        iconSize: new L.Point(10, 10),
        className: 'leaflet-div-icon leaflet-editing-icon my-own-icon',
      })
    });
    m2.on('mousedown', (e) => {
      this.mymap.dragging.disable();
      this.regua([this.ruler_p.first.lat, this.ruler_p.first.lng]);
    })
    m2._leaflet_id = 'reguaM2';
    m2.addTo(this.featureGroupTemp);
  };

  cancelRuler = () => {
    if (this.ruler_p.first.lat) {
      this.regua();
    }
  };

  task_title = '...';
  checkTitle = (task, i) => {
    if (this.task_title !== task.job_title) {
      if (this.state.itensTask.length - 1 === i) {
        this.task_title = '...';
      } else {
        this.task_title = task.job_title;
      }
      return true;
    }
    if (this.state.itensTask.length - 1 === i) {
      this.task_title = '...';
    }
    return false;
  };

  openModal = () => {
    this.setState({ modalOpen: true });
  };

  closeModal = () => {
    this.setState({ modalOpen: false });
  };

  getProfileAuto = () => {
    const apiUrl = Config.server + '/profile_auto_quality';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        const rel_config = result[0]?.rel_config || null;
        if (!rel_config) return;

        const newState = {};

        for (const key of [
          'checkResumoCobertura',
          'checkResumoAltura',
          'checkResumoFluxo',
          'checkResumoVelocidade',
          'checkResumoVelocidadeVento',
          'checkResumoAnguloVento',
          'checkResumoTemperatura',
          'checkResumoUmidade',
          'checkResumoDeltat'
        ]) {
          if (rel_config.hasOwnProperty(key)) {
            newState[key] = rel_config[key];
          }
        }

        newState.profileLoaded = true;

        this.setState(newState, () => {
          //console.log('STATES ATUALIZADOS', this.state);
        });
      })
      .catch((error) => {
        console.error(error);
        const msg =
          error.status === 405 ? this.props.res.PERMISSAO_MSG :
            error.status === 401 || error.status === 403 ? 'Login necessário' :
              this.props.res.ERRO_MSG;

        notification.open({
          message: this.props.res.ERRO,
          description: msg,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });

        if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        }
      });
  };

  render() {
    const { res, link } = this.props;
    const styleTitle = { marginTop: '1rem', width: 'auto', height: '2.3rem', marginBottom: '-1.5rem', textDecoration: 'underline', textAlign: 'center' };
    const replay3DIsAdmin = this.isReplay3DAdmin();
    const replay3DClimateTimelineLength = Array.isArray(this.state.climateTimeline) ? this.state.climateTimeline.length : 0;
    const replay3DAllowExternalClimateLookup = replay3DIsAdmin && replay3DClimateTimelineLength === 0;

    return (
      <div className="rowMapCO maxVHMap">
        <Dialog
          open={this.state.clear}
          onClose={() => this.setState({ clear: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {this.state.new.msg}
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => this.state.new.func()} color="primary">
              {res.SIM}
            </Button>
            <Button onClick={() => this.setState({ clear: false })} color="primary" autoFocus>
              {res.NAO}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog onClose={event => this.setState({ openTask: false })} aria-labelledby="simple-dialog-title" open={this.state.openTask}>
          <DialogTitle id="simple-dialog-title">{res.PROCESSANDO}</DialogTitle>
          <List>
            {this.state.itensTask.map((task, i) => (
              <>
                {this.checkTitle(task, i) &&
                  <div style={{ borderTop: 'solid 1px rgba(0, 0, 0, 0.12)', padding: '0 1rem', fontSize: '14px', backgroundColor: '#f2f2f2' }}>{task.job_title}</div>
                }
                <ListItem button onClick={(event) => task.progress === 100 && this.getTask(task.id)} key={task.id}>
                  <ListItemText primary={task.title} />
                  <div style={{ height: '1rem', width: '2.5rem', textAlign: 'right', alignSelf: 'baseline', marginTop: '.3rem' }}>{task.progress + '%'}</div>
                </ListItem>
              </>
            ))}
          </List>
        </Dialog>
        <Backd style={{ zIndex: 1002, color: '#fff' }} open={!this.state.autoReplay3DOpening && (this.state.progress || this.state.loading)}>
          {this.state.progressValue > 0 ?
            <CircularProgress style={{ scale: '2' }} variant="determinate" value={this.state.progressValue} color="inherit" disableShrink /> :
            <CircularProgress color="inherit" disableShrink />
          }
        </Backd>
        {this.state.autoReplay3DOpening && !this.state.showReplay3D ?
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(12, 18, 14, 0.72)',
              backdropFilter: 'blur(3px)',
              WebkitBackdropFilter: 'blur(3px)'
            }}
          >
            <div
              style={{
                width: 'min(360px, calc(100vw - 48px))',
                padding: '28px 24px',
                borderRadius: '14px',
                background: 'rgba(255, 255, 255, 0.96)',
                boxShadow: '0 12px 34px rgba(0, 0, 0, 0.28)',
                textAlign: 'center',
                color: '#2a3521'
              }}
            >
              <CircularProgress style={{ color: '#1f8f47', marginBottom: '14px' }} size={42} thickness={4} disableShrink />
              <div style={{ fontSize: '16px', fontWeight: 700, marginBottom: '6px', color: '#2a3521' }}>{res.CARREGANDO_REPLAY_3D}</div>
              <div style={{ fontSize: '13px', lineHeight: 1.35, color: '#63745a' }}>{res.PREPARANDO_MAPA_AERONAVE_DADOS_VOO}</div>
            </div>
          </div>
          : null}
        <Dialog onClose={this.onCloseEditMap} fullWidth={true} maxWidth='lg' aria-labelledby="simple-dialog-title" open={this.state.showForm}>
          <MapItem link={link} res={res} type={this.typeMapItem} itens={this.state.polygons} getBackgroud={this.getBackgroud} idJob={this.state.id_job} onClose={this.onCloseEditMap} />
        </Dialog>
        <div className='title-grid'>
          <div className="divContent padding-title">
            <div>
              <div><h1 className='title-align'>{res.QUALIDADE}</h1></div>
              <div className='zoomButton'>
                <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} disabled={this.state.state !== 1 || this.state.loading} className="popUpButton" onClick={event => this.updateTask()} title={res.GERAR_ANALISE}>
                  <SvgIcon viewBox="-2 0 26 26" className="iconArrow"
                    style={{ color: 'white', width: '2rem', height: '2rem' }}>
                    <path id="polygon"
                      d="M3.5 18.99l11 .01c.67 0 1.27-.33 1.63-.84L20.5 12l-4.37-6.16c-.36-.51-.96-.84-1.63-.84l-11 .01L8.34 12 3.5 18.99z"
                    />
                  </SvgIcon>
                </Button>
                <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} disabled={this.state.state !== 3} className="popUpButton" onClick={() => this.setState({ modalOpen: true })} title={res.RELATÓRIO_QUALIDADE}>
                  <SvgIcon viewBox="0 0 1000 1000" className="iconArrow"
                    style={{ color: 'white', transform: 'rotate(180deg)', width: '2rem', height: '2rem' }}>
                    <path id="polygon" d="M326.156 867.15l462.329 0c20.0054,0 29.8386,-9.83318 29.8386,-29.8047l0 -633.189c0,-20.0054 -9.83318,-29.8386 -29.8386,-29.8386l-462.329 0c-19.8359,0 -29.8386,9.83318 -29.8386,29.8386l0 633.189c0,19.9715 10.0027,29.8047 29.8386,29.8047zm166.52 -540.486l195.307 0 0 -32.6529 -195.307 0 0 32.6529zm-63.5087 0l46.8263 0 0 -32.6529 -46.8263 0 0 32.6529zm0 63.0001l46.8263 0 0 -32.6529 -46.8263 0 0 32.6529zm63.5087 0l195.307 0 0 -32.6529 -195.307 0 0 32.6529zm-63.5087 66.3231l46.8263 0 0 -32.6529 -46.8263 0 0 32.6529zm63.5087 0l195.307 0 0 -32.6529 -195.307 0 0 32.6529zm68.8322 165.503l98.1622 55.8457c9.83318,-17.3267 14.648,-35.8402 14.648,-55.8457 0,-31.161 -10.986,-57.8123 -32.992,-79.6487 -22.006,-22.006 -48.4877,-32.992 -79.8183,-32.992 -31.161,0 -57.8462,10.986 -79.8522,32.992 -22.006,21.8364 -32.992,48.4877 -32.992,79.6487 0,31.0254 10.986,57.5071 32.992,79.6826 22.006,22.1755 48.6912,33.1615 79.8522,33.1615l0 -112.844zm20.9887 31.3305l9.83318 112.336c34.5178,-3.32294 61.8473,-18.8187 81.9883,-46.8263l-91.8215 -65.5093zm-237.319 163.163l0 -587.99 426.828 0 0 587.99 -426.828 0zm-96.6703 4.84877l47.8096 0 0 -44.0119 -31.161 0 0 -504.306 31.161 0 0 -46.0125 -47.8096 0c-16.852,0 -25.3289,8.68032 -25.3289,26.0071l0 542.825c0,16.9877 8.47688,25.4984 25.3289,25.4984z" />
                  </SvgIcon>
                </Button>
                <Button variant="contained" color="primary" disabled={this.state.itensTask.length === 0 && !this.state.loading} className="popUpButton" onClick={event => this.loadTask(true)} title={res.EXIBIR_ANALISE}>
                  <MaterialIcon icon="settings" className="iconMap highlightSVG" />
                </Button>
              </div>
            </div>
          </div>
          <div id="divFloat" className="div-list_p divContentList list-p">
            <div>
              <div style={{ marginTop: '-.9rem', height: '5rem', padding: '1rem' }}>
                <Tab value={this.state.tabMenu} handleChange={this.handleChangeTab} name="tabMenu" itens={this.state.tabMenuItens} />
              </div>
            </div>
            <div className="div-list_h">
              <div style={{ paddingLeft: '.5rem' }} className="div-list_box">
                <div style={{ width: 'calc(100% - .7rem)', height: '100%', position: 'absolute', zIndex: 10, backgroundColor: 'white', display: this.state.task ? 'none' : 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ marginBottom: '.5rem', fontWeight: 'bold' }}> {res.IMPORTAR_JOB + ' (.zjob)'} </div>
                    <label htmlFor="contained-button-file">
                      <Button component="span" variant="contained" color="primary" style={{ marginRight: '.4rem' }} className="popUpButton" title={res.IMPORTAR_JOB}>
                        <SvgIcon viewBox="0 0 1000 1000" className="iconArrow"
                          style={{ color: 'white', transform: 'rotate(180deg)', width: '2rem', height: '2rem' }}>
                          <path id="polygon" d="M122.513 646.499c3.66376,13.0115 11.813,21.1608 24.4821,24.3451l273.344 0 36.1582 0.47937 25.5093 0 -0.513611 13.662 0 107.002c4.17737,9.51892 
                            9.69012,14.8605 16.504,16.1959 6.84814,1.16418 14.5181,3.97192 23.0098,8.14929 8.14929,-4.17737 15.4768,-6.98511 22.1537,-8.14929 6.67694,-1.33539 12.3267,-6.84814 
                            16.8464,-16.6752l0 -106.523 0 -13.662 25.5093 0 35.6446 -0.47937 273.344 0c12.3267,-3.18439 20.5102,-11.3337 24.4821,-24.3451l-0.47937 -88.8204 -365.828 0 -6.84814 
                            -69.3374 0.992981 10.1695 3.01318 -106.009 16.1616 0 4.34857 145.66 4.31433 -145.66 16.1616 0 4.34857 145.66 4.00616 -145.66 15.9904 0 4.48553 145.66 4.34857 
                            -145.66 10.3407 0c0.992981,-0.513611 1.81476,-0.992981 2.67078,-1.33539 0.821777,-0.342407 1.64355,-0.650574 2.63653,-0.992981l4.34857 147.988 4.48553 
                            -156.822c0.684814,-0.992981 1.19842,-2.67078 1.849,-5.34155l-1.33539 -6.33453 3.83496 -143.16 -18.0106 0 2.84198 102.174 -0.513611 -1.50659 -11.6418 0 3.32135 
                            -100.668 -18.49 0 2.97894 100.668 -12.3267 0 3.01318 -100.668 -18.0106 0 2.84198 100.668 -12.1555 0 2.97894 -100.668 -18.1476 0 2.49957 100.668 -12.1897 0 2.84198 
                            -100.668 -18.0106 0 2.84198 100.668 -1.81476 0c-4.00616,-1.67779 -7.36175,-4.17737 -10.3407,-7.32751l2.97894 -93.3402 -18.1476 0 2.49957 92.8266c-3.01318,3.32135 
                            -6.50574,5.82092 -10.8543,7.84112l-0.821777 0 2.32837 -100.668 -17.9764 0 2.80774 100.668 -12.1555 0 3.01318 -100.668 -18.1818 0 3.01318 100.668 -12.6691 0 2.80774 
                            -100.668 -17.9764 0 2.97894 100.668 -12.3267 0 3.01318 -100.668 -18.1818 0 3.01318 100.668 -12.1555 0 -2.49957 8.8341 1.98596 -7.32751 2.84198 -102.174 -18.0106 0 
                            4.34857 143.16 -1.849 6.33453c-0.342407,-1.33539 0.342407,0.513611 1.849,5.34155l4.99914 156.822 4.31433 -147.988c0,0 1.67779,0.821777 4.82794,2.32837l10.8543 0 4.31433 
                            145.66 4.51977 -145.66 15.9904 0 4.48553 145.66 3.83496 -145.66 16.6752 0 3.83496 145.66 4.34857 -145.66 16.1616 0 2.97894 100.668 -6.33453 64.5095 -365.828 0 
                            -0.47937 88.8204zm19.6542 -419.997l9.17651 311.659 8.8341 -311.659 -18.0106 0zm24.8245 0l8.8341 311.659 9.17651 -311.659 -18.0106 0zm24.3451 0l9.31347 311.659 8.8341 
                            -311.659 -18.1476 0zm24.9957 0l8.8341 311.659 9.17651 -311.659 -18.0106 0zm24.3451 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.9957 0l8.8341 311.659 9.14227 
                            -311.659 -17.9764 0zm24.3109 0l9.34771 311.659 8.8341 -311.659 -18.1818 0zm24.5163 0l9.17651 311.659 9.31347 -311.659 -18.49 0zm24.8245 0l8.8341 311.659 9.34771 
                            -311.659 -18.1818 0zm24.5163 0l9.14227 311.659 9.34771 -311.659 -18.49 0zm135.148 228.488l1.50659 -62.4893 4.34857 0 -5.85516 62.4893zm37.6648 -62.4893l4.86218 0 
                            1.98596 72.3164 -6.84814 -72.3164zm110.837 -9.65588c0,-0.342407 0.171204,-0.513611 0.513611,-0.513611l-0.513611 0.513611zm12.1897 -156.343l9.31347 311.659 8.6629 
                            -311.659 -17.9764 0zm24.8245 0l8.8341 311.659 9.31347 -311.659 -18.1476 0zm24.4821 0l9.34771 311.659 9.17651 -311.659 -18.5242 0zm24.8588 0l9.31347 311.659 8.8341 
                            -311.659 -18.1476 0zm24.4821 0l9.17651 311.659 9.31347 -311.659 -18.49 0zm24.8245 0l9.34771 311.659 8.8341 -311.659 -18.1818 0zm24.0027 0l9.17651 311.659 8.8341 
                            -311.659 -18.0106 0zm24.8588 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.4821 0l9.17651 311.659 9.31347 -311.659 -18.49 0zm24.8245 0l8.8341 311.659 9.34771 
                            -311.659 -18.1818 0z" />
                        </SvgIcon>
                      </Button>
                    </label>
                  </div>
                </div>
                <div className="div-list_itens" style={{ display: this.state.tabMenu === '0' || this.state.tabMenu === '1' ? 'block' : 'none' }}>
                  <div className="notTooBig">
                    <div>
                      <h2 title={
                        this.state.title_sk && this.state.title === '...' ?
                          this.state.title_sk : this.state.title
                      } >{
                          (this.state.title_sk && this.state.title === '...' ? this.state.title_sk : this.state.title).length > 30 ?
                            (this.state.title_sk && this.state.title === '...' ? this.state.title_sk : this.state.title).substring(0, 27) + '...' :
                            (this.state.title_sk && this.state.title === '...' ? this.state.title_sk : this.state.title)}</h2>
                    </div>
                    {this.state.title !== '...' && this.state.title !== this.state.title_sk &&
                      <div style={{ textAlign: 'right', marginTop: '-1rem' }}>
                        <h4 style={{ color: '#bcbcbc' }}>{this.state.title_sk}</h4>
                      </div>
                    }
                    <Accordion title={res.INFORMACOES_GERAIS}>
                      <div>
                        <div style={{ display: 'flex', flexFlow: 'row wrap', width: '24rem', gap: '.5rem' }}>
                          <TextField
                            label={res.NAME_OS}
                            value={this.state.gNome}
                            size="small"
                            margin="dense"
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                          />
                          <TextField
                            label={res.AERONAVE}
                            value={this.state.gAeronave}
                            size="small"
                            margin="dense"
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                          />
                          <TextField
                            label={res.CLIENTE}
                            value={this.state.gCliente}
                            size="small"
                            margin="dense"
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                          />
                          <TextField
                            label={res.PILOTO}
                            value={this.state.gPiloto}
                            size="small"
                            margin="dense"
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                          />
                          <TextField
                            label={res.CULTURA}
                            value={this.state.gCultura}
                            size="small"
                            margin="dense"
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                          />
                          <TextField
                            label={res.STARTDATE}
                            value={this.state.dateIni}
                            size="small"
                            margin="dense"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label={res.ENDDATE}
                            value={this.state.dateFim}
                            size="small"
                            margin="dense"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label={res.AREA_TOTAL_TALHOES}
                            value={`${Units.formatValue(Units.convertArea(this.state.area_talhoes, 'ha', res), res, 1)} ${Units.getAreaUnit(res)}`}
                            size="small"
                            margin="dense"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label={res.DISTANCIA_PERCORRIDA}
                            value={res.LINGUA === 'en-US' ?
                              `${tools.km_to_m(this.state.distancia_percorrida).toFixed(2)} ${res.MILHAS}` :
                              `${this.state.distancia_percorrida.toFixed(2)}  ${res.KM}`}
                            size="small"
                            margin="dense"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                          <TextField
                            label={`${res.POLIGONO_APLICADO} / ${res.POLY}`}
                            value={`${this.state.polygons_aplicados} / ${this.state.polygons_total}`}
                            size="small"
                            margin="dense"
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                          />
                        </div>
                      </div>
                    </Accordion>
                    <Accordion title={res.INDICE_APLICACAO}>
                      <div style={{ marginTop: '10px' }}>
                        <div style={{ marginBottom: '1rem' }}><h4 style={styleTitle}>{res.APLICACAO.toUpperCase()}</h4></div>
                        <Slider res={res} text={res.INDICE_ACERTO} value={this.state.gAcerto} />
                        <Slider res={res} text={res.INDICE_UNIFORMIDADE} value={this.state.gUniformidade} />
                        <Slider res={res} text={res.INDICE_FALHA} value={this.state.gFalha} inverted={true} />
                        <Slider res={res} text={res.INDICE_PERDA} value={this.state.gPerda} inverted={true} />
                        <div style={{ marginBottom: '1rem' }}><h4 style={styleTitle}>{res.COMPLEMENTO_}</h4></div>
                        {!isNaN(this.state.gfluxo) ? <Slider res={res} text={res.INDICE_FLUXO} value={this.state.gfluxo} /> : null}
                        {!isNaN(this.state.gAltura) ? <Slider res={res} text={res.INDICE_ALTURA} value={this.state.gAltura} /> : null}
                        {!isNaN(this.state.gVelocidade) ? <Slider res={res} text={res.INDICE_VELOCIDADE} value={this.state.gVelocidade} /> : null}
                        <div style={{ marginBottom: '1rem' }}><h4 style={styleTitle}>{res.CLIMA_}</h4></div>
                        {!isNaN(this.state.gVelocidadeV) ? <Slider res={res} text={res.INDICE_VELOCIDADE_VENTO} value={this.state.gVelocidadeV} /> : null}
                        {!isNaN(this.state.gDirecaoV) ? <Slider res={res} text={res.INDICE_DIRECAO_VENTO} value={this.state.gDirecaoV} /> : null}
                        {!isNaN(this.state.gDeltaT) ? <Slider res={res} text={res.INDICE_DELTA_T} value={this.state.gDeltaT} /> : null}
                        {!isNaN(this.state.gTemperatura) ? <Slider res={res} text={res.INDICE_TEMPERATURA} value={this.state.gTemperatura} /> : null}
                        {!isNaN(this.state.gHumidade) ? <Slider res={res} text={res.INDICE_HUMIDADE} value={this.state.gHumidade} /> : null}
                      </div>
                    </Accordion>
                    <Accordion id="divApp" title={res.INFORMACAO_APLICACAO} onUpdate={(is) => this.updateAccrodion("divApp", is)}>
                      <div>
                        <TextField
                          label={res.TEMPO}
                          value={tools.fancyTimeFormat(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.timeS : this.state.time)}
                          margin="normal"
                          InputProps={{
                            readOnly: true,
                          }}
                          fullWidth
                        />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', width: '24rem' }}>
                          <div style={{ width: this.state.data !== null ? '10rem' : 'auto' }}>
                            <TextField
                              label={tools.replaceString(res._AREA_APLICADA, Units.getAreaUnit(res))}
                              value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.areaS : this.state.area, 'ha', res), 1)}
                              margin="normal"
                              InputProps={{
                                readOnly: true,
                              }}
                              fullWidth
                              style={{ paddingTop: '0.5rem' }}
                            />
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={tools.replaceString(res._ACERTO, Units.getAreaUnit(res))}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.corretoS : this.state.correto, 'ha', res), 1)}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                                style={{ paddingTop: '0.5rem' }}
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.correto_static.light_color, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={tools.replaceString(res._APP_EXT, Units.getAreaUnit(res))}
                                value={Units.roundValue(Units.convertArea(this.state.app_extS, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                                style={{ paddingTop: '0.5rem' }}
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.app_add_static.color, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={tools.replaceString(res._SOBREPOSTO, Units.getAreaUnit(res))}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.sobreS : this.state.sobre, 'ha', res), 1)}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                                style={{ paddingTop: '0.5rem' }}
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.sobre_static.light_color, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={tools.replaceString(res._RESTANTE, Units.getAreaUnit(res))}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.restanteS : this.state.restante, 'ha', res), 1)}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                                style={{ paddingTop: '0.5rem' }}
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.area_static.color, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={tools.replaceString(res._FALHA, Units.getAreaUnit(res))}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.foraS : this.state.fora, 'ha', res), 1)}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                                style={{ paddingTop: '0.5rem' }}
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.fora_static.color, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                          </div>
                          <div style={{ width: '14rem', padding: '2rem', paddingTop: '0.5rem', textAlign: 'center', display: (this.state.timeS > 0) ? 'block' : 'none' }}>
                            <span>{res.AREA}</span>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.correto_static.light_color, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.area.data1}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.app_add_static.color, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.area.data2}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.sobre_static.light_color, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.area.data3}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.area_static.color, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.area.data4}%</span>
                              </div>
                            </div>
                            <canvas id="pieChart2"></canvas>
                            <span>{res.APLICACAO}</span>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.correto_static.light_color, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.aplicacao.data1}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.sobre_static.light_color, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.aplicacao.data2}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.fora_static.color, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.aplicacao.data3}%</span>
                              </div>
                            </div>
                            <canvas id="pieChart1"></canvas>
                          </div>
                        </div>
                      </div>
                    </Accordion>
                    <Accordion id="divAlt" disabled={!this.state.tabItens[1].active} title={res.INFORMACAO_ALTURA} onUpdate={(is) => this.updateAccrodion("divAlt", is)}>
                      <div>
                        <TextField
                          label={res.TEMPO}
                          value={tools.fancyTimeFormat(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.timeS : this.state.time)}
                          size="small"
                          margin="dense"
                          InputProps={{
                            readOnly: true,
                          }}
                          fullWidth
                        />
                        <BarHeat values={[
                          Number(this.state.alturaSet) - this.state.alturaMargemDown.value - this.state.alturaLimiteDown.value,
                          Number(this.state.alturaSet) - this.state.alturaMargemDown.value,
                          Number(this.state.alturaSet),
                          Number(this.state.alturaSet) + this.state.alturaMargemUp.value,
                          Number(this.state.alturaSet) + this.state.alturaMargemUp.value + this.state.alturaLimiteUp.value
                        ]} atual={!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? Units.convertLength(this.state.media_alturaS, 'm', res) : this.state.atual_altura} />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', width: '24rem' }}>
                          <div style={{ width: this.state.data !== null ? '10rem' : 'auto' }}>
                            <TextField
                              label={res.AREA_APLICADA}
                              value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.areaS : this.state.area, 'ha', res))}
                              size="small"
                              margin="dense"
                              InputProps={{
                                readOnly: true,
                              }}
                              fullWidth
                            />
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.ALTURA_MEDIA}
                                value={Units.roundValue(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? Units.convertLength(this.state.media_alturaS, 'm', res) : this.state.media_altura)}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_ALTURA_CORRETA}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.corretoAltS : this.state.corretoAlt, 'ha', res))}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '1.8rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_ALTURA_ACEITAVEL_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelAltInfS : this.state.aceitavelAltInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_ALTURA_ACEITAVEL_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelAltSupS : this.state.aceitavelAltSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_ALTURA_INCORRETA_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaAltInfS : this.state.incorretaAltInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_ALTURA_INCORRETA_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaAltSupS : this.state.incorretaAltSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                          </div>
                          <div style={{ width: '13.5rem', padding: '2rem', paddingTop: '6.5rem', textAlign: 'center', display: (this.state.timeS > 0) ? 'block' : 'none' }}>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.altura.data2}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.altura.data1}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.altura.data3}%</span>
                              </div>
                            </div>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.altura.data4}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}></div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.altura.data5}%</span>
                              </div>
                            </div>
                            <canvas id="pieChart3"></canvas>
                          </div>
                        </div>
                      </div>
                    </Accordion>
                    <Accordion id="divFlo" disabled={!this.state.tabItens[2].active} title={res.INFORMACAO_FLUXO} onUpdate={(is) => this.updateAccrodion("divFlo", is)}>
                      <div>
                        <TextField
                          label={res.TEMPO}
                          value={tools.fancyTimeFormat(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.timeS : this.state.time)}
                          size="small"
                          margin="dense"
                          InputProps={{
                            readOnly: true,
                          }}
                          fullWidth
                        />

                        {(() => {
                          const isStatic = (!this.state.updateValuesAnimation || this.state.tabMenu === '0');

                          const sets =
                            isStatic && this.state.fluxoSetsAplicacaoStatic && this.state.fluxoSetsAplicacaoStatic.length
                              ? this.state.fluxoSetsAplicacaoStatic
                              : [];

                          if (!sets.length) {
                            const atualGeral = (!this.state.updateValuesAnimation || this.state.tabMenu === '0')
                              ? this.state.media_fluxoS
                              : this.state.atual_fluxo;

                            return (
                              <div style={{ marginBottom: '1rem' }}>
                                <BarHeat
                                  values={[
                                    Number(this.state.fluxoSet) - this.state.fluxoMargemDown.value - this.state.fluxoLimiteDown.value,
                                    Number(this.state.fluxoSet) - this.state.fluxoMargemDown.value,
                                    Number(this.state.fluxoSet),
                                    Number(this.state.fluxoSet) + this.state.fluxoMargemUp.value,
                                    Number(this.state.fluxoSet) + this.state.fluxoMargemUp.value + this.state.fluxoLimiteUp.value
                                  ]}
                                  atual={!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? Units.convertFlow(atualGeral, 'L', 'ha', res) : atualGeral}
                                />

                                <div style={{ display: 'flex', flexFlow: 'row wrap', width: '24rem' }}>
                                  <div style={{ width: this.state.data !== null ? '10rem' : 'auto' }}>
                                    <TextField
                                      label={res.AREA_APLICADA}
                                      value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.areaS : this.state.area, 'ha', res))}
                                      size="small"
                                      margin="dense"
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                      fullWidth
                                    />

                                    <div style={{ position: 'relative' }}>
                                      <TextField
                                        label={res.FLUXO_MEDIO}
                                        value={Units.roundValue(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? Units.convertFlow(this.state.media_fluxoS, 'L', 'ha', res) : this.state.media_fluxo)}
                                        size="small"
                                        margin="dense"
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                        fullWidth
                                      />
                                    </div>

                                    <div style={{ position: 'relative' }}>
                                      <TextField
                                        label={res.AREA_FLUXO_CORRETO}
                                        value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.corretoFlxS : this.state.corretoFlx, 'ha', res))}
                                        size="small"
                                        margin="dense"
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                        fullWidth
                                      />
                                      <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '1.8rem' }}></div>
                                    </div>

                                    <div style={{ position: 'relative' }}>
                                      <TextField
                                        label={res.AREA_FLUXO_ACEITAVEL_INF}
                                        value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelFlxInfS : this.state.aceitavelFlxInf, 'ha', res))}
                                        margin="normal"
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                        fullWidth
                                      />
                                      <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                                    </div>

                                    <div style={{ position: 'relative' }}>
                                      <TextField
                                        label={res.AREA_FLUXO_ACEITAVEL_SUP}
                                        value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelFlxSupS : this.state.aceitavelFlxSup, 'ha', res))}
                                        margin="normal"
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                        fullWidth
                                      />
                                      <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                                    </div>
                                    <div style={{ position: 'relative' }}>
                                      <TextField
                                        label={res.AREA_FLUXO_INCORRETA_INF}
                                        value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaFlxInfS : this.state.incorretaFlxInf, 'ha', res))}
                                        margin="normal"
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                        fullWidth
                                      />
                                      <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                                    </div>

                                    <div style={{ position: 'relative' }}>
                                      <TextField
                                        label={res.AREA_FLUXO_INCORRETA_SUP}
                                        value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaFlxSupS : this.state.incorretaFlxSup, 'ha', res))}
                                        margin="normal"
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                        fullWidth
                                      />
                                      <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                                    </div>
                                  </div>

                                  <div style={{ width: '13.5rem', padding: '2rem', paddingTop: '6.5rem', textAlign: 'center', display: (this.state.timeS > 0) ? 'block' : 'none' }}>
                                    <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                                      <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                        <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px' }}></div>
                                        <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.fluxo.data2}%</span>
                                      </div>
                                      <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                        <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px' }}></div>
                                        <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.fluxo.data1}%</span>
                                      </div>
                                      <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                        <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px' }}></div>
                                        <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.fluxo.data3}%</span>
                                      </div>
                                    </div>
                                    <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                                      <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                        <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px' }}></div>
                                        <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.fluxo.data4}%</span>
                                      </div>
                                      <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}></div>
                                      <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                        <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px' }}></div>
                                        <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.fluxo.data5}%</span>
                                      </div>
                                    </div>
                                    <canvas id="pieChart4"></canvas>
                                  </div>
                                </div>
                              </div>
                            );
                          }

                          return (
                            <div>
                              {sets.map((setValor) => {
                                const chave = String(setValor);
                                const stats = (this.state.fluxoPorSetStatic && this.state.fluxoPorSetStatic[chave]) ? this.state.fluxoPorSetStatic[chave] : null;

                                const areaSet = stats && typeof stats.area === 'number' ? stats.area : 0;
                                const mediaSet = stats && typeof stats.media === 'number' ? stats.media : 0;

                                const corretoSet = stats && typeof stats.correto === 'number' ? stats.correto : 0;
                                const aceitavelInfSet = stats && typeof stats.aceitavelInf === 'number' ? stats.aceitavelInf : 0;
                                const aceitavelSupSet = stats && typeof stats.aceitavelSup === 'number' ? stats.aceitavelSup : 0;
                                const incorretaInfSet = stats && typeof stats.incorretaInf === 'number' ? stats.incorretaInf : 0;
                                const incorretaSupSet = stats && typeof stats.incorretaSup === 'number' ? stats.incorretaSup : 0;

                                // mediaSet já está na unidade de exibição, pois foi calculado a partir de temp_fluxo.
                                // Não converter novamente: isso causava dupla conversão (ex.: gal(US)/ha -> gal(US)/ha como se fosse L/ha).
                                const atualRender = mediaSet;



                                const totalPie = corretoSet + aceitavelInfSet + aceitavelSupSet + incorretaInfSet + incorretaSupSet;

                                const p1 = totalPie === 0 ? 0 : Math.round(100 * corretoSet / totalPie);
                                const p2 = totalPie === 0 ? 0 : Math.round(100 * aceitavelInfSet / totalPie);
                                const p3 = totalPie === 0 ? 0 : Math.round(100 * aceitavelSupSet / totalPie);
                                const p4 = totalPie === 0 ? 0 : Math.round(100 * incorretaInfSet / totalPie);
                                const p5 = totalPie === 0 ? 0 : Math.round(100 * incorretaSupSet / totalPie);

                                return (
                                  <div id={`divFloSet_${chave}`} key={`fluxo-set-block-${chave}`} style={{ marginBottom: '1.5rem' }}>
                                    <div style={{ fontSize: '0.9rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '.25rem' }}>
                                      {res.FLUXO} {this.formatQualityValue(setValor)}
                                    </div>

                                    <BarHeat
                                      values={[
                                        Number(setValor) - this.state.fluxoMargemDown.value - this.state.fluxoLimiteDown.value,
                                        Number(setValor) - this.state.fluxoMargemDown.value,
                                        Number(setValor),
                                        Number(setValor) + this.state.fluxoMargemUp.value,
                                        Number(setValor) + this.state.fluxoMargemUp.value + this.state.fluxoLimiteUp.value
                                      ]}
                                      atual={atualRender}
                                    />

                                    <div style={{ display: 'flex', flexFlow: 'row wrap', width: '24rem' }}>
                                      <div style={{ width: this.state.data !== null ? '10rem' : 'auto' }}>
                                        <TextField
                                          label={res.AREA_APLICADA}
                                          value={Units.roundValue(Units.convertArea(areaSet, 'ha', res))}
                                          size="small"
                                          margin="dense"
                                          InputProps={{
                                            readOnly: true,
                                          }}
                                          fullWidth
                                        />

                                        <div style={{ position: 'relative' }}>
                                          <TextField
                                            label={res.FLUXO_MEDIO}
                                            value={Units.roundValue(mediaSet)}
                                            size="small"
                                            margin="dense"
                                            InputProps={{
                                              readOnly: true,
                                            }}
                                            fullWidth
                                          />
                                        </div>

                                        <div style={{ position: 'relative' }}>
                                          <TextField
                                            label={res.AREA_FLUXO_CORRETO}
                                            value={Units.roundValue(Units.convertArea(corretoSet, 'ha', res))}
                                            size="small"
                                            margin="dense"
                                            InputProps={{
                                              readOnly: true,
                                            }}
                                            fullWidth
                                          />
                                          <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '1.8rem' }}></div>
                                        </div>

                                        <div style={{ position: 'relative' }}>
                                          <TextField
                                            label={res.AREA_FLUXO_ACEITAVEL_INF}
                                            value={Units.roundValue(Units.convertArea(aceitavelInfSet, 'ha', res))}
                                            margin="normal"
                                            InputProps={{
                                              readOnly: true,
                                            }}
                                            fullWidth
                                          />
                                          <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                                        </div>

                                        <div style={{ position: 'relative' }}>
                                          <TextField
                                            label={res.AREA_FLUXO_ACEITAVEL_SUP}
                                            value={Units.roundValue(Units.convertArea(aceitavelSupSet, 'ha', res))}
                                            margin="normal"
                                            InputProps={{
                                              readOnly: true,
                                            }}
                                            fullWidth
                                          />
                                          <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                                        </div>

                                        <div style={{ position: 'relative' }}>
                                          <TextField
                                            label={res.AREA_FLUXO_INCORRETA_INF}
                                            value={Units.roundValue(Units.convertArea(incorretaInfSet, 'ha', res))}
                                            margin="normal"
                                            InputProps={{
                                              readOnly: true,
                                            }}
                                            fullWidth
                                          />
                                          <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                                        </div>

                                        <div style={{ position: 'relative' }}>
                                          <TextField
                                            label={res.AREA_FLUXO_INCORRETA_SUP}
                                            value={Units.roundValue(Units.convertArea(incorretaSupSet, 'ha', res))}
                                            margin="normal"
                                            InputProps={{
                                              readOnly: true,
                                            }}
                                            fullWidth
                                          />
                                          <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                                        </div>
                                      </div>

                                      <div style={{ width: '13.5rem', padding: '2rem', paddingTop: '6.5rem', textAlign: 'center', display: (this.state.timeS > 0) ? 'block' : 'none' }}>
                                        <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                                          <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                            <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px' }}></div>
                                            <span style={{ marginLeft: '2px', marginRight: '2px' }}>{p2}%</span>
                                          </div>
                                          <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                            <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px' }}></div>
                                            <span style={{ marginLeft: '2px', marginRight: '2px' }}>{p1}%</span>
                                          </div>
                                          <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                            <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px' }}></div>
                                            <span style={{ marginLeft: '2px', marginRight: '2px' }}>{p3}%</span>
                                          </div>
                                        </div>
                                        <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                                          <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                            <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px' }}></div>
                                            <span style={{ marginLeft: '2px', marginRight: '2px' }}>{p4}%</span>
                                          </div>
                                          <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}></div>
                                          <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                            <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px' }}></div>
                                            <span style={{ marginLeft: '2px', marginRight: '2px' }}>{p5}%</span>
                                          </div>
                                        </div>
                                        <canvas id={`pieChart4_${chave}`}></canvas>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })()}
                      </div>
                    </Accordion>
                    <Accordion id="divVel" disabled={!this.state.tabItens[3].active} title={res.INFORMACAO_VELOCIDADE} onUpdate={(is) => this.updateAccrodion("divVel", is)}>
                      <div>
                        <TextField
                          label={res.TEMPO}
                          value={tools.fancyTimeFormat(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.timeS : this.state.time)}
                          size="small"
                          margin="dense"
                          InputProps={{
                            readOnly: true,
                          }}
                          fullWidth
                        />
                        <BarHeat values={[
                          Number(this.state.velocidadeSet) - this.state.velocidadeMargemDown.value - this.state.velocidadeLimiteDown.value,
                          Number(this.state.velocidadeSet) - this.state.velocidadeMargemDown.value,
                          Number(this.state.velocidadeSet),
                          Number(this.state.velocidadeSet) + this.state.velocidadeMargemUp.value,
                          Number(this.state.velocidadeSet) + this.state.velocidadeMargemUp.value + this.state.velocidadeLimiteUp.value
                        ]} atual={!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? Units.convertSpeed(this.state.media_velocidadeS, 'km/h', res) : this.state.atual_velocidade} />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', width: '24rem' }}>
                          <div style={{ width: this.state.data !== null ? '10rem' : 'auto' }}>
                            <TextField
                              label={tools.replaceString(res._AREA_APLICADA, Units.getAreaUnit(res))}
                              value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.areaS : this.state.area, 'ha', res))}
                              size="small"
                              margin="dense"
                              InputProps={{
                                readOnly: true,
                              }}
                              fullWidth
                            />
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={tools.replaceString(res._VELOCIDADE_MEDIA, Units.getSpeedUnit(res))}
                                value={Units.roundValue(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? Units.convertSpeed(this.state.media_velocidadeS, 'km/h', res) : this.state.media_velocidade)}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_VELOCIDADE_CORRETA}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.corretoVlcS : this.state.corretoVlc, 'ha', res))}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '1.8rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_VELOCIDADE_ACEITAVEL_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelVlcInfS : this.state.aceitavelVlcInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_VELOCIDADE_ACEITAVEL_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelVlcSupS : this.state.aceitavelVlcSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_VELOCIDADE_INCORRETA_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaVlcInfS : this.state.incorretaVlcInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_VELOCIDADE_INCORRETA_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaVlcSupS : this.state.incorretaVlcSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                          </div>
                          <div style={{ width: '13.5rem', padding: '2rem', paddingTop: '6.5rem', textAlign: 'center', display: (this.state.timeS > 0) ? 'block' : 'none' }}>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.velocidade.data2}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.velocidade.data1}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.velocidade.data3}%</span>
                              </div>
                            </div>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.velocidade.data4}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}></div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.velocidade.data5}%</span>
                              </div>
                            </div>
                            <canvas id="pieChart5"></canvas>
                          </div>
                        </div>
                      </div>
                    </Accordion>
                    <Accordion id="divVen" disabled={!this.state.tabItensVento[0].active} title={res.INFORMACAO_VELOCIDADE_VENTO} onUpdate={(is) => this.updateAccrodion("divVen", is)}>
                      <div>
                        <TextField
                          id="time"
                          label={res.TEMPO}
                          value={tools.fancyTimeFormat(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.timeS : this.state.time)}
                          size="small"
                          margin="dense"
                          InputProps={{
                            readOnly: true,
                          }}
                          fullWidth
                        />
                        <BarHeat values={[
                          Number(this.state.velocidadeVSet) - this.state.velocidadeVMargemDown.value - this.state.velocidadeVLimiteDown.value,
                          Number(this.state.velocidadeVSet) - this.state.velocidadeVMargemDown.value,
                          null,//Number(this.state.velocidadeVSet),
                          Number(this.state.velocidadeVSet) + this.state.velocidadeVMargemUp.value,
                          Number(this.state.velocidadeVSet) + this.state.velocidadeVMargemUp.value + this.state.velocidadeVLimiteUp.value
                        ]} grayZero={true} atual={!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? Units.convertSpeed(this.state.media_velocidade_ventoS, 'km/h', res) : this.state.media_velocidade_vento} />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', width: '24rem' }}>
                          <div style={{ width: this.state.data !== null ? '10rem' : 'auto' }}>
                            <TextField
                              label={res.AREA_APLICADA}
                              value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.areaS : this.state.area, 'ha', res))}
                              size="small"
                              margin="dense"
                              InputProps={{
                                readOnly: true,
                              }}
                              fullWidth
                            />
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.VELOCIDADE_V_MEDIA}
                                value={Units.roundValue(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? Units.convertSpeed(this.state.media_velocidade_ventoS, 'km/h', res) : this.state.media_velocidade_vento)}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_VELOCIDADE_V_CORRETO}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.corretoVlcVS : this.state.corretoVlcV, 'ha', res))}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '1.8rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_VELOCIDADE_V_ACEITAVEL_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelVlcVInfS : this.state.aceitavelVlcVInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_VELOCIDADE_V_INCORRETA_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelVlcVSupS : this.state.aceitavelVlcVSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_VELOCIDADE_V_INCORRETA_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaVlcVInfS : this.state.incorretaVlcVInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_VELOCIDADE_V_ACEITAVEL_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaVlcVSupS : this.state.incorretaVlcVSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                          </div>
                          <div style={{ width: '13.5rem', padding: '2rem', paddingTop: '6.5rem', textAlign: 'center', display: (this.state.timeS > 0) ? 'block' : 'none' }}>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.velocidadeVento.data2}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.velocidadeVento.data1}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.velocidadeVento.data3}%</span>
                              </div>
                            </div>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.velocidadeVento.data4}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}></div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.velocidadeVento.data5}%</span>
                              </div>
                            </div>
                            <canvas id="pieChart6"></canvas>
                          </div>
                        </div>
                      </div>
                    </Accordion>
                    <Accordion id="divVenD" disabled={!this.state.tabItensVento[1].active} title={res.INFORMACAO_DIRECAO_VENTO} onUpdate={(is) => this.updateAccrodion("divVenD", is)}>
                      <div>
                        <TextField
                          label={res.TEMPO}
                          value={tools.fancyTimeFormat(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.timeS : this.state.time)}
                          size="small"
                          margin="dense"
                          InputProps={{
                            readOnly: true,
                          }}
                          fullWidth
                        />
                        <PlaneHeat type="G" ckey="2" values={[
                          Number(this.state.anguloVLimiteDown.value),
                          Number(this.state.anguloVMargemDown.value),
                          Number(this.state.anguloVSet),
                          this.state.espelharAnguloV ? Number(this.state.anguloVMargemDown.value) : Number(this.state.anguloVMargemUp.value),
                          this.state.espelharAnguloV ? Number(this.state.anguloVLimiteDown.value) : Number(this.state.anguloVLimiteUp.value)
                        ]} limit="90" res={res} />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', width: '24rem' }}>
                          <div style={{ width: this.state.data !== null ? '10rem' : 'auto' }}>
                            <TextField
                              label={res.AREA_APLICADA}
                              value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.areaS : this.state.area, 'ha', res))}
                              size="small"
                              margin="dense"
                              InputProps={{
                                readOnly: true,
                              }}
                              fullWidth
                            />
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_DIRECAO_V_CORRETO}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.corretoAngVS : this.state.corretoAngV, 'ha', res))}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '1.8rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_DIRECAO_V_ACEITAVEL_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelAngVInfS : this.state.aceitavelAngVInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_DIRECAO_V_INCORRETA_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelAngVSupS : this.state.aceitavelAngVSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_DIRECAO_V_INCORRETA_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaAngVInfS : this.state.incorretaAngVInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_DIRECAO_V_ACEITAVEL_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaAngVSupS : this.state.incorretaAngVSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                          </div>
                          <div style={{ width: '13.5rem', padding: '2rem', paddingTop: '6.5rem', textAlign: 'center', display: (this.state.timeS > 0) ? 'block' : 'none' }}>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.direcaoVento.data2}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.direcaoVento.data1}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.direcaoVento.data3}%</span>
                              </div>
                            </div>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.direcaoVento.data4}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}></div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.direcaoVento.data5}%</span>
                              </div>
                            </div>
                            <canvas id="pieChart7"></canvas>
                          </div>
                        </div>
                      </div>
                    </Accordion>
                    <Accordion id="divDeltaT" disabled={!this.state.tabItensDeltaT[0].active} title={res.INFORMACAO_DELTAT} onUpdate={(is) => this.updateAccrodion("divDeltaT", is)}>
                      <div>
                        <TextField
                          label={res.TEMPO}
                          value={tools.fancyTimeFormat(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.timeS : this.state.time)}
                          size="small"
                          margin="dense"
                          InputProps={{
                            readOnly: true,
                          }}
                          fullWidth
                        />
                        <DeltaTHeat values={this.state} temperatura_values={[
                          Number(this.state.temperaturaSet) - this.state.temperaturaMargemDown.value - this.state.temperaturaLimiteDown.value,
                          Number(this.state.temperaturaSet) - this.state.temperaturaMargemDown.value,
                          null,//Number(this.state.temperaturaSet),
                          Number(this.state.temperaturaSet) + this.state.temperaturaMargemUp.value,
                          Number(this.state.temperaturaSet) + this.state.temperaturaMargemUp.value + this.state.temperaturaLimiteUp.value
                        ]} humidade_values={[
                          Number(this.state.umidadeSet) - this.state.umidadeMargemDown.value - this.state.umidadeLimiteDown.value,
                          Number(this.state.umidadeSet) - this.state.umidadeMargemDown.value,
                          null,//Number(this.state.umidadeSet),     temperatura='30' humidade='75' atual='1.8'
                          Number(this.state.umidadeSet) + this.state.umidadeMargemUp.value,
                          Number(this.state.umidadeSet) + this.state.umidadeMargemUp.value + this.state.umidadeLimiteUp.value
                        ]}
                          atual={(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.media_DeltaTS : this.state.media_DeltaT)}
                          humidade={(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.media_UmidadeS : this.state.media_Umidade)}
                          temperatura={res.LINGUA === 'en-US' ?
                            tools.c_to_f(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.media_temperaturaS : this.state.media_temperatura) :
                            (!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.media_temperaturaS : this.state.media_temperatura)}
                          res={res}
                        />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', width: '24rem' }}>
                          <div style={{ width: this.state.data !== null ? '10rem' : 'auto' }}>
                            <TextField
                              label={res.AREA_APLICADA}
                              value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.areaS : this.state.area, 'ha', res))}
                              size="small"
                              margin="dense"
                              InputProps={{
                                readOnly: true,
                              }}
                              fullWidth
                            />
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.DELTAT_MEDIA}
                                value={(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.media_DeltaTS : this.state.media_DeltaT).toFixed(2)}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_DELTAT_CORRETO}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.corretoDeltaT : this.state.corretoDelta, 'ha', res))}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '1.8rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_DELTAT_ACEITAVEL}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ?
                                  this.state.aceitavelDeltaTInfS + this.state.aceitavelDeltaTSupS :
                                  this.state.aceitavelDeltaTInf + this.state.aceitavelDeltaTSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_DELTAT_INCORRETA}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ?
                                  this.state.incorretaDeltaTInfS + this.state.incorretaDeltaTSupS :
                                  this.state.incorretaDeltaTInf + this.state.incorretaDeltaTSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                          </div>
                          <div style={{ width: '13.5rem', padding: '2rem', paddingTop: '6.5rem', textAlign: 'center', display: (this.state.timeS > 0) ? 'block' : 'none' }}>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.deltaT.data2}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.deltaT.data1 + this.state.legend.deltaT.data3}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.deltaT.data4 + this.state.legend.deltaT.data5}%</span>
                              </div>
                            </div>
                            <canvas id="pieChart8"></canvas>
                          </div>
                        </div>
                      </div>
                    </Accordion>
                    <Accordion id="divTemp" disabled={!this.state.tabItensDeltaT[1].active} title={res.INFORMACAO_TEMPERATURA} onUpdate={(is) => this.updateAccrodion("divTemp", is)}>
                      <div>
                        <TextField
                          label={res.TEMPO}
                          value={tools.fancyTimeFormat(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.timeS : this.state.time)}
                          size="small"
                          margin="dense"
                          InputProps={{
                            readOnly: true,
                          }}
                          fullWidth
                        />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', width: '24rem' }}>
                          <div style={{ width: this.state.data !== null ? '10rem' : 'auto' }}>
                            <TextField
                              label={res.AREA_APLICADA}
                              value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.areaS : this.state.area, 'ha', res))}
                              size="small"
                              margin="dense"
                              InputProps={{
                                readOnly: true,
                              }}
                              fullWidth
                            />
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.TEMPERATURA_MEDIA}
                                value={(res.LINGUA === 'en-US' ?
                                  tools.c_to_f(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.media_temperaturaS : this.state.media_temperatura) :
                                  (!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.media_temperaturaS : this.state.media_temperatura)).toFixed(2)}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_TEMPERATURA_CORRETO}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.corretoTempVS : this.state.corretoTempV, 'ha', res))}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '1.8rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_TEMPERATURA_ACEITAVEL_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelTempInfS : this.state.aceitavelTempInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_TEMPERATURA_INCORRETA_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelTempSupS : this.state.aceitavelTempSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_TEMPERATURA_INCORRETA_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaTempInfS : this.state.incorretaTempInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_TEMPERATURA_ACEITAVEL_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaTempSupS : this.state.incorretaTempSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                          </div>
                          <div style={{ width: '13.5rem', padding: '2rem', paddingTop: '6.5rem', textAlign: 'center', display: (this.state.timeS > 0) ? 'block' : 'none' }}>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.temperatura.data2}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.temperatura.data1}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.temperatura.data3}%</span>
                              </div>
                            </div>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.temperatura.data4}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}></div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.temperatura.data5}%</span>
                              </div>
                            </div>
                            <canvas id="pieChart9"></canvas>
                          </div>
                        </div>
                      </div>
                    </Accordion>
                    <Accordion id="divHum" disabled={!this.state.tabItensDeltaT[2].active} title={res.INFORMACAO_UMIDADE} onUpdate={(is) => this.updateAccrodion("divHum", is)}>
                      <div>
                        <TextField
                          label={res.TEMPO}
                          value={tools.fancyTimeFormat(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.timeS : this.state.time)}
                          size="small"
                          margin="dense"
                          InputProps={{
                            readOnly: true,
                          }}
                          fullWidth
                        />
                        <div style={{ display: 'flex', flexFlow: 'row wrap', width: '24rem' }}>
                          <div style={{ width: this.state.data !== null ? '10rem' : 'auto' }}>
                            <TextField
                              label={res.AREA_APLICADA}
                              value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.areaS : this.state.area, 'ha', res))}
                              size="small"
                              margin="dense"
                              InputProps={{
                                readOnly: true,
                              }}
                              fullWidth
                            />
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.UMIDADE_MEDIA}
                                value={(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.media_UmidadeS : this.state.media_Umidade).toFixed(2)}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_UMIDADE_CORRETO}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.corretoTempVS : this.state.corretoTempV, 'ha', res))}
                                size="small"
                                margin="dense"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '1.8rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_UMIDADE_ACEITAVEL_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelUmiInfS : this.state.aceitavelUmiInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_UMIDADE_INCORRETA_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.aceitavelUmiSupS : this.state.aceitavelUmiSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_UMIDADE_INCORRETA_INF}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaUmiInfS : this.state.incorretaUmiInf, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                            <div style={{ position: 'relative' }}>
                              <TextField
                                label={res.AREA_UMIDADE_ACEITAVEL_SUP}
                                value={Units.roundValue(Units.convertArea(!this.state.updateValuesAnimation || this.state.tabMenu === '0' ? this.state.incorretaUmiSupS : this.state.incorretaUmiSup, 'ha', res))}
                                margin="normal"
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                              <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px', position: 'absolute', right: '.5rem', top: '2.5rem' }}></div>
                            </div>
                          </div>
                          <div style={{ width: '13.5rem', padding: '2rem', paddingTop: '6.5rem', textAlign: 'center', display: (this.state.timeS > 0) ? 'block' : 'none' }}>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.humidade.data2}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.correto, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.humidade.data1}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.aceitavelSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.humidade.data3}%</span>
                              </div>
                            </div>
                            <div style={{ width: '100%', height: '1.6rem', display: 'flex', justifyContent: 'space-between' }}>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaInf, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.humidade.data4}%</span>
                              </div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}></div>
                              <div style={{ width: '3.5rem', display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: '1rem', height: '1rem', backgroundColor: this.styles.stripColor.incorretaSup, borderRadius: '5px' }}></div>
                                <span style={{ marginLeft: '2px', marginRight: '2px' }}>{this.state.legend.humidade.data5}%</span>
                              </div>
                            </div>
                            <canvas id="pieChart10"></canvas>
                          </div>
                        </div>
                      </div>
                    </Accordion>
                  </div>
                </div>
                <div className="div-list_itens" style={{ display: this.state.tabMenu === '2' ? 'block' : 'none' }}>
                  <div className="notTooBig" style={{ display: 'flex', flexDirection: 'column' }}>
                    <h2 title={this.state.title} style={{ borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)' }}>{this.state.title.length > 30 ? this.state.title.substring(0, 27) + '...' : this.state.title}</h2>
                    <Accordion title={res.INFORMACOES_GERAIS}>
                      <div>
                        <TextField
                          label={res.NAME_OS}
                          value={this.state.nome}
                          onChange={this.handleChange('nome')}
                          size="small"
                          margin="dense"
                          disabled={this.state.state === 3}
                          fullWidth
                          onInput={(e) => {
                            e.target.value = e.target.value.toString().slice(0, 255)
                          }}
                        />
                        <div>
                          <TextField
                            autoComplete="off"
                            label={res.AERONAVE}
                            value={this.state.aeronave}
                            onChange={this.handlePlaneChange}
                            disabled={this.state.state === 3}
                            fullWidth
                            onInput={(e) => {
                              e.target.value = e.target.value.toString().slice(0, 45)
                            }}
                            size="small"
                            margin="dense"
                            onKeyDown={e => {
                              if (e.keyCode === 13) {
                                let item = this.state.planes.filter((item) => { return item.name && String(item.name).toLowerCase().includes(String(this.state.aeronave || '').toLowerCase()) });
                                if (item.length > 0) {
                                  this.selectPlane(item[0]);
                                }
                              }
                            }}
                            onFocus={this.showAutoComplete("plane_div")}
                            onBlur={this.showAutoComplete("plane_div")}
                          />
                          <div id="plane_div" className="sr-only" style={{ boxShadow: '2px 2px 5px grey', width: '23.5rem' }}>
                            {this.state.planes
                              .filter((item) => { return item.name && String(item.name).toLowerCase().includes(String(this.state.aeronave || '').toLowerCase()) })
                              .map((item, index) => {
                                return <ListItem key={index} button
                                  onMouseDown={event => this.selectPlane(item)}>
                                  <ListItemText id={index} primary={this.limitChar(item.name, 202)} />
                                </ListItem>
                              })}
                          </div>
                        </div>
                        <div>
                          <TextField
                            autoComplete="off"
                            label={res.CLIENTE}
                            value={this.state.cliente}
                            onChange={this.handleChange('cliente')}
                            disabled={this.state.state === 3}
                            fullWidth
                            onInput={(e) => {
                              e.target.value = e.target.value.toString().slice(0, 45)
                            }}
                            size="small"
                            margin="dense"
                            onKeyDown={e => {
                              if (e.keyCode === 13) {
                                let item = this.state.clients.filter((item) => { return item.name && String(item.name).toLowerCase().includes(String(this.state.cliente || '').toLowerCase()) });
                                if (item.length > 0) {
                                  this.setState({ cliente: item[0].name });
                                }
                              }
                            }}
                            onFocus={this.showAutoComplete("client_div")}
                            onBlur={this.showAutoComplete("client_div")}
                          />
                          <div id="client_div" className="sr-only" style={{ boxShadow: '2px 2px 5px grey', width: '23.5rem' }}>
                            {this.state.clients
                              .filter((item) => { return item.name && String(item.name).toLowerCase().includes(String(this.state.cliente || '').toLowerCase()) })
                              .map((item, index) => {
                                return <ListItem key={index} button
                                  onMouseDown={event => this.setState({ cliente: item.name })}>
                                  <ListItemText id={index} primary={this.limitChar(item.name, 202)} />
                                </ListItem>
                              })}
                          </div>
                        </div>
                        <div>
                          <TextField
                            autoComplete="off"
                            label={res.PILOTO}
                            value={this.state.piloto}
                            onChange={this.handleChange('piloto')}
                            disabled={this.state.state === 3}
                            fullWidth
                            onInput={(e) => {
                              e.target.value = e.target.value.toString().slice(0, 45)
                            }}
                            size="small"
                            margin="dense"
                            onKeyDown={e => {
                              if (e.keyCode === 13) {
                                let item = this.state.pilots.filter((item) => { return item.name && String(item.name).toLowerCase().includes(String(this.state.piloto || '').toLowerCase()) });
                                if (item.length > 0) {
                                  this.setState({ piloto: item[0].name });
                                }
                              }
                            }}
                            onFocus={this.showAutoComplete("pilot_div")}
                            onBlur={this.showAutoComplete("pilot_div")}
                          />
                          <div id="pilot_div" className="sr-only" style={{ boxShadow: '2px 2px 5px grey', width: '23.5rem' }}>
                            {this.state.pilots
                              .filter((item) => { return item.name && String(item.name).toLowerCase().includes(String(this.state.piloto || '').toLowerCase()) })
                              .map((item, index) => {
                                return <ListItem key={index} button
                                  onMouseDown={event => this.setState({ piloto: item.name })}>
                                  <ListItemText id={index} primary={this.limitChar(item.name, 202)} />
                                </ListItem>
                              })}
                          </div>
                        </div>
                        <TextField
                          label={res.CULTURA}
                          value={this.state.cultura}
                          onChange={this.handleChange('cultura')}
                          size="small"
                          margin="dense"
                          disabled={this.state.state === 3}
                          fullWidth
                          onInput={(e) => {
                            e.target.value = e.target.value.toString().slice(0, 255)
                          }}
                        />
                      </div>
                    </Accordion>
                    <Accordion title={res.VARIAVEIS_TRABALHO}>
                      <div>
                        {/* faixa */}
                        <div style={{ display: 'flex' }}>
                          <TextField
                            label={res.LARGURA_FAIXA}
                            value={tools.round(this.state.larguraSet, 2)}
                            onChange={this.handleChange('larguraSet')}
                            disabled={!this.state.checkConfig[0] || this.state.state === 3}
                            type="number"
                            className="mb-4 notTooClose"
                            size="small"
                            margin="dense"
                            style={{ width: '11rem' }}
                          />
                          <div style={{ paddingTop: '1rem' }}>
                            <Checkbox
                              checked={this.state.checkConfig[0]}
                              onChange={this.handleCheck(0)}
                              disabled={this.state.state === 3}
                            />
                            <span onClick={this.handleCheck(0)} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                              {res.MODIFICAR_LARGURA}
                            </span>
                          </div>
                        </div>
                        {/* altura */}
                        <div style={{ display: 'flex' }}>
                          <TextField
                            label={res.ALTURA_VOO}
                            value={tools.round(this.state.alturaSet, 2)}
                            onChange={(event) => {
                              if (!isNaN(event.target.value) && Number(event.target.value) >= 0) {
                                this.handleChange('alturaSet')(event);
                                let alturaLimiteDown = this.state.alturaLimiteDown;
                                let alturaMargemDown = this.state.alturaMargemDown;
                                let alturaMargemUp = this.state.alturaMargemUp;
                                let alturaLimiteUp = this.state.alturaLimiteUp;
                                let value = Number(event.target.value);
                                if (value < Number(this.state.alturaSet)) {
                                  if ((value - this.state.alturaMargemDown.value) < 0) {
                                    alturaMargemDown.value -= 1;
                                    if (alturaMargemDown.valid) alturaMargemDown.text = value - alturaMargemDown.value;
                                  } else if ((value - this.state.alturaMargemDown.value - this.state.alturaLimiteDown.value) < 0) {
                                    alturaLimiteDown.value -= 1;
                                    if (alturaLimiteDown.valid) alturaLimiteDown.text = value - alturaLimiteDown.value;
                                  }
                                }
                                alturaMargemUp.text = (value + alturaMargemUp.value);
                                alturaLimiteUp.text = (value + alturaMargemUp.value + alturaLimiteUp.value);
                                alturaMargemDown.text = (value - alturaMargemDown.value);
                                alturaLimiteDown.text = (value - alturaMargemDown.value - alturaLimiteDown.value);
                                this.setState({ alturaMargemDown: alturaMargemDown, alturaLimiteDown: alturaLimiteDown });
                              }
                            }}
                            disabled={!this.state.checkConfig[1] || this.state.state === 3}
                            type="number"
                            className="mb-4 notTooClose"
                            size="small"
                            margin="dense"
                            style={{ width: '11rem' }}
                          />
                          <div style={{ paddingTop: '1rem' }}>
                            <Checkbox
                              checked={this.state.checkConfig[1]}
                              onChange={this.handleCheck(1)}
                              disabled={this.state.state === 3}
                            />
                            <span onClick={this.handleCheck(1)} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                              {res.MODIFICAR_ALTURA}
                            </span>
                          </div>
                        </div>
                        {/* fluxo */}
                        <div style={{ display: 'flex' }}>
                          <TextField
                            label={res.FLUXO_APLICACAO}
                            value={tools.round(this.state.fluxoSet, 2)}
                            onChange={(event) => {
                              if (!isNaN(event.target.value) && Number(event.target.value) >= 0) {
                                this.handleChange('fluxoSet')(event);
                                let fluxoLimiteDown = this.state.fluxoLimiteDown;
                                let fluxoMargemDown = this.state.fluxoMargemDown;
                                let fluxoMargemUp = this.state.fluxoMargemUp;
                                let fluxoLimiteUp = this.state.fluxoLimiteUp;
                                let value = Number(event.target.value);
                                if (value < Number(this.state.fluxoSet)) {
                                  if ((value - this.state.fluxoMargemDown.value) < 0) {
                                    fluxoMargemDown.value -= 1;
                                    if (fluxoMargemDown.valid) fluxoMargemDown.text = value - fluxoMargemDown.value;
                                  } else if ((value - this.state.fluxoMargemDown.value - this.state.fluxoLimiteDown.value) < 0) {
                                    fluxoLimiteDown.value -= 1;
                                    if (fluxoLimiteDown.valid) fluxoLimiteDown.text = value - fluxoLimiteDown.value;
                                  }
                                }
                                fluxoMargemUp.text = (value + fluxoMargemUp.value);
                                fluxoLimiteUp.text = (value + fluxoMargemUp.value + fluxoLimiteUp.value);
                                fluxoMargemDown.text = (value - fluxoMargemDown.value);
                                fluxoLimiteDown.text = (value - fluxoMargemDown.value - fluxoLimiteDown.value);
                                this.setState({ fluxoMargemDown: fluxoMargemDown, fluxoLimiteDown: fluxoLimiteDown });
                              }
                            }}
                            disabled={!this.state.checkConfig[2] || this.state.state === 3}
                            type="number"
                            className="mb-4 notTooClose"
                            size="small"
                            margin="dense"
                            style={{ width: '11rem' }}
                          />
                          <div style={{ paddingTop: '1rem' }}>
                            <Checkbox
                              checked={this.state.checkConfig[2]}
                              onChange={this.handleCheck(2)}
                              disabled={this.state.state === 3}
                            />
                            <span onClick={this.handleCheck(2)} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                              {res.MODIFICAR_FLUXO}
                            </span>
                          </div>
                        </div>
                        {/* velocidade */}
                        <div style={{ display: 'flex' }}>
                          <TextField
                            label={tools.replaceString(res._VELOCIDADE_APLICACAO, Units.getSpeedUnit(res))}
                            value={tools.round(this.state.velocidadeSet, 2)}
                            onChange={(event) => {
                              if (!isNaN(event.target.value) && Number(event.target.value) >= 0) {
                                this.handleChange('velocidadeSet')(event);
                                let velocidadeLimiteDown = this.state.velocidadeLimiteDown;
                                let velocidadeMargemDown = this.state.velocidadeMargemDown;
                                let velocidadeMargemUp = this.state.velocidadeMargemUp;
                                let velocidadeLimiteUp = this.state.velocidadeLimiteUp;
                                let value = Number(event.target.value);
                                if (value < Number(this.state.velocidadeSet)) {
                                  if ((value - this.state.velocidadeMargemDown.value) < 0) {
                                    velocidadeMargemDown.value -= 1;
                                    if (velocidadeMargemDown.valid) velocidadeMargemDown.text = value - velocidadeMargemDown.value;
                                  } else if ((value - this.state.velocidadeMargemDown.value - this.state.velocidadeLimiteDown.value) < 0) {
                                    velocidadeLimiteDown.value -= 1;
                                    if (velocidadeLimiteDown.valid) velocidadeLimiteDown.text = value - velocidadeLimiteDown.value;
                                  }
                                }
                                velocidadeMargemUp.text = (value + velocidadeMargemUp.value);
                                velocidadeLimiteUp.text = (value + velocidadeMargemUp.value + velocidadeLimiteUp.value);
                                velocidadeMargemDown.text = (value - velocidadeMargemDown.value);
                                velocidadeLimiteDown.text = (value - velocidadeMargemDown.value - velocidadeLimiteDown.value);
                                this.setState({ velocidadeMargemDown: velocidadeMargemDown, velocidadeLimiteDown: velocidadeLimiteDown });
                              }
                            }}
                            disabled={!this.state.checkConfig[3] || this.state.state === 3}
                            type="number"
                            className="mb-4 notTooClose"
                            size="small"
                            margin="dense"
                            style={{ width: '11rem' }}
                          />
                          <div style={{ paddingTop: '1rem' }}>
                            <Checkbox
                              checked={this.state.checkConfig[3]}
                              onChange={this.handleCheck(3)}
                              disabled={this.state.state === 3}
                            />
                            <span onClick={this.handleCheck(3)} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                              {res.MODIFICAR_VELOCIDADE}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Accordion>
                    <Accordion title={res.INFORMACOES_ANALISE}>
                      <div>
                        <div><h4 style={styleTitle}>{res.PERFIL.toUpperCase()}</h4></div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                          <Select
                            style={{ textAlign: 'left', marginTop: '.5rem' }}
                            id='perfis'
                            value={this.state.selectedPerfil + ''}
                            onChange={this.handleChangePerfil}
                            inputProps={{
                              id: 'id',
                            }}
                            disabled={this.state.nomePerfil}
                            fullWidth
                          >
                            {
                              this.state.nomePerfil ?
                                <MenuItem key={0} value={0}>{this.state.nomePerfil}</MenuItem>
                                :
                                <MenuItem key={0} value={0}>{res.CUSTOMIZADO}</MenuItem>
                            }
                            {this.state.listPerfis.map((item, index) => {
                              return <MenuItem key={index + 1} value={item.id}>{item.name}</MenuItem>
                            })}
                          </Select>
                        </div>
                        <div><h4 style={styleTitle}>{res.LARGURA_FAIXA_ESTENDIDA.toUpperCase()}</h4></div>
                        <div style={{ width: '100%', height: '4rem', textAlign: 'center', padding: '1rem' }}>
                          < Button className={"buttonS buttonMenu"} disabled={this.state.larguraExd <= 100 || this.state.state === 3} onClick={event => this.changeSize('larguraExd', -5)}>
                            {'-'}
                          </Button>
                          <label style={{ margin: '.2rem' }}>  {this.state.larguraExd}%  </label>
                          < Button className={"buttonS buttonMenu"} disabled={this.state.larguraExd >= 130 || this.state.state === 3} onClick={event => this.changeSize('larguraExd', 5)}>
                            {'+'}
                          </Button>
                        </div>
                        <div><h4 style={styleTitle}>{res.ALTURA.toUpperCase()}</h4></div>
                        <BarHeat values={[
                          Number(this.state.alturaSet) - this.state.alturaMargemDown.value - this.state.alturaLimiteDown.value,
                          Number(this.state.alturaSet) - this.state.alturaMargemDown.value,
                          Number(this.state.alturaSet),
                          Number(this.state.alturaSet) + this.state.alturaMargemUp.value,
                          Number(this.state.alturaSet) + this.state.alturaMargemUp.value + this.state.alturaLimiteUp.value
                        ]} />
                        <div>
                          <TextField
                            label={res.TOLERANCIA_ALTURA_MIN}
                            value={Math.round(this.state.alturaMargemDown.text * 1000) / 1000}
                            error={!this.state.alturaMargemDown.valid}
                            onChange={(event) => {
                              this.changeSettingsMargemDown(
                                event.target.value,
                                'alturaSet',
                                'alturaMargemDown',
                                'alturaLimiteDown',
                                'alturaMargemUp',
                                true
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                            style={{ marginRight: '.5rem' }}
                          />
                          <TextField
                            label={res.TOLERANCIA_ALTURA_MAX}
                            value={Math.round(this.state.alturaMargemUp.text * 1000) / 1000}
                            error={!this.state.alturaMargemUp.valid}
                            onChange={(event) => {
                              this.changeSettingsMargemUp(
                                event.target.value,
                                'alturaSet',
                                'alturaMargemUp',
                                'alturaLimiteUp',
                                null,
                                'alturaMargemDown',
                                true
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                          />
                        </div>
                        <div>
                          <TextField
                            label={res.LIMITE_ALTURA_MIN}
                            value={Math.round(this.state.alturaLimiteDown.text * 1000) / 1000}
                            error={!this.state.alturaLimiteDown.valid}
                            onChange={(event) => {
                              this.changeSettingsLimitDown(
                                event.target.value,
                                'alturaSet',
                                'alturaMargemDown',
                                'alturaLimiteDown'
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                            style={{ marginRight: '.5rem' }}
                          />
                          <TextField
                            label={res.LIMITE_ALTURA_MAX}
                            value={Math.round(this.state.alturaLimiteUp.text * 1000) / 1000}
                            error={!this.state.alturaLimiteUp.valid}
                            onChange={(event) => {
                              this.changeSettingsLimitUp(
                                event.target.value,
                                'alturaSet',
                                'alturaMargemUp',
                                'alturaLimiteUp'
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                          />
                        </div>

                        <div><h4 style={styleTitle}>{res.FLUXO.toUpperCase()}</h4></div>
                        <BarHeat values={[
                          Number(this.state.fluxoSet) - this.state.fluxoMargemDown.value - this.state.fluxoLimiteDown.value,
                          Number(this.state.fluxoSet) - this.state.fluxoMargemDown.value,
                          Number(this.state.fluxoSet),
                          Number(this.state.fluxoSet) + this.state.fluxoMargemUp.value,
                          Number(this.state.fluxoSet) + this.state.fluxoMargemUp.value + this.state.fluxoLimiteUp.value
                        ]} />
                        <div>
                          <TextField
                            label={res.TOLERANCIA_FLUXO_MIN}
                            value={Math.round(this.state.fluxoMargemDown.text * 1000) / 1000}
                            error={!this.state.fluxoMargemDown.valid}
                            onChange={(event) => {
                              this.changeSettingsMargemDown(
                                event.target.value,
                                'fluxoSet',
                                'fluxoMargemDown',
                                'fluxoLimiteDown',
                                'fluxoMargemUp',
                                true
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                            style={{ marginRight: '.5rem' }}
                          />
                          <TextField
                            label={res.TOLERANCIA_FLUXO_MAX}
                            value={Math.round(this.state.fluxoMargemUp.text * 1000) / 1000}
                            error={!this.state.fluxoMargemUp.valid}
                            onChange={(event) => {
                              this.changeSettingsMargemUp(
                                event.target.value,
                                'fluxoSet',
                                'fluxoMargemUp',
                                'fluxoLimiteUp',
                                null,
                                'fluxoMargemDown',
                                true
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                          />
                        </div>
                        <div>
                          <TextField
                            label={res.LIMITE_FLUXO_MIN}
                            value={Math.round(this.state.fluxoLimiteDown.text * 1000) / 1000}
                            error={!this.state.fluxoLimiteDown.valid}
                            onChange={(event) => {
                              this.changeSettingsLimitDown(
                                event.target.value,
                                'fluxoSet',
                                'fluxoMargemDown',
                                'fluxoLimiteDown'
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                            style={{ marginRight: '.5rem' }}
                          />
                          <TextField
                            label={res.LIMITE_FLUXO_MAX}
                            value={Math.round(this.state.fluxoLimiteUp.text * 1000) / 1000}
                            error={!this.state.fluxoLimiteUp.valid}
                            onChange={(event) => {
                              this.changeSettingsLimitUp(
                                event.target.value,
                                'fluxoSet',
                                'fluxoMargemUp',
                                'fluxoLimiteUp'
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                          />
                        </div>

                        <div><h4 style={styleTitle}>{res.VELOCIDADE.toUpperCase()}</h4></div>
                        <BarHeat values={[
                          Number(this.state.velocidadeSet) - this.state.velocidadeMargemDown.value - this.state.velocidadeLimiteDown.value,
                          Number(this.state.velocidadeSet) - this.state.velocidadeMargemDown.value,
                          Number(this.state.velocidadeSet),
                          Number(this.state.velocidadeSet) + this.state.velocidadeMargemUp.value,
                          Number(this.state.velocidadeSet) + this.state.velocidadeMargemUp.value + this.state.velocidadeLimiteUp.value
                        ]} grayZero={true} />
                        <div>
                          <TextField
                            label={res.TOLERANCIA_VELOCIDADE_MIN}
                            value={Math.round(this.state.velocidadeMargemDown.text * 1000) / 1000}
                            error={!this.state.velocidadeMargemDown.valid}
                            onChange={(event) => {
                              this.changeSettingsMargemDown(
                                event.target.value,
                                'velocidadeSet',
                                'velocidadeMargemDown',
                                'velocidadeLimiteDown',
                                'velocidadeMargemUp',
                                true
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                            style={{ marginRight: '.5rem' }}
                          />
                          <TextField
                            label={res.TOLERANCIA_VELOCIDADE_MAX}
                            value={Math.round(this.state.velocidadeMargemUp.text * 1000) / 1000}
                            error={!this.state.velocidadeMargemUp.valid}
                            onChange={(event) => {
                              this.changeSettingsMargemUp(
                                event.target.value,
                                'velocidadeSet',
                                'velocidadeMargemUp',
                                'velocidadeLimiteUp',
                                null,
                                'velocidadeMargemDown',
                                true
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                          />
                        </div>
                        <div>
                          <TextField
                            label={res.LIMITE_VELOCIDADE_MIN}
                            value={Math.round(this.state.velocidadeLimiteDown.text * 1000) / 1000}
                            error={!this.state.velocidadeLimiteDown.valid}
                            onChange={(event) => {
                              this.changeSettingsLimitDown(
                                event.target.value,
                                'velocidadeSet',
                                'velocidadeMargemDown',
                                'velocidadeLimiteDown'
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                            style={{ marginRight: '.5rem' }}
                          />
                          <TextField
                            label={res.LIMITE_VELOCIDADE_MAX}
                            value={Math.round(this.state.velocidadeLimiteUp.text * 1000) / 1000}
                            error={!this.state.velocidadeLimiteUp.valid}
                            onChange={(event) => {
                              this.changeSettingsLimitUp(
                                event.target.value,
                                'velocidadeSet',
                                'velocidadeMargemUp',
                                'velocidadeLimiteUp'
                              );
                            }}
                            size="small"
                            margin="dense"
                            disabled={this.state.state === 3}
                            type="number"
                          />
                        </div>

                        <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                          <Checkbox
                            disabled={this.state.tabMenuItens[0].active || (this.state.fonstes.length === 0 && (this.state.limitWeather - this.state.limitConsumption) <= 0)}
                            checked={this.state.checkConfig[4]}
                            onChange={this.handleCheck(4)}
                          />
                          <div style={{ display: 'inline-flex' }}>
                            <span onClick={(event) => { if (!this.state.tabMenuItens[0].active) this.handleCheck(4)(event); }} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                              <h3 style={styleTitle}>{res.USAR_DADOS_METEOROLOGICOS}</h3>
                            </span>
                          </div>
                        </div>
                        <div style={{ position: 'relative' }}>
                          <div style={{ display: (this.state.checkConfig[4] ? 'none' : 'block'), position: 'absolute', width: '100%', height: '100%', backgroundColor: '#ffffff87', zIndex: '1' }}></div>
                          <div><h4 style={styleTitle}>{res.FONTE_DADOS_}</h4></div>
                          <FormControl
                            style={{ padding: ".4rem 0 .4rem 0", alignItems: 'center' }}
                            fullWidth
                            component="fieldset">
                            <RadioGroup style={{ scale: '.9' }} row id="tipoFonte" aria-label="tipoFonte" name="tipoFonte" value={this.state.tipoFonte} onChange={this.handleChange('tipoFonte')}>
                              <FormControlLabel value="ESTACAO" disabled={(this.state.tabMenuItens[0].active && this.state.fonstes.length === 0 && this.state.tipoFonte !== 'ESTACAO')} control={<Radio color="primary" />} label={res.ESTACOES} />
                              <FormControlLabel value="EXTERNO" disabled={(this.state.tabMenuItens[0].active && this.state.tipoFonte !== 'EXTERNO')} control={<Radio color="primary" />} label={this.state.showLimit ? `${res.EXTERNO} (${this.state.limitConsumption}/${this.state.limitWeather})` : res.EXTERNO} />
                            </RadioGroup>
                          </FormControl>
                          <Select
                            value={this.state.fonteClima}
                            disabled={this.state.tabMenuItens[0].active || this.state.fonstes.length === 0}
                            style={{ width: '100%', marginBottom: '.5rem' }}
                            onChange={this.handleChange('fonteClima')}
                            inputProps={{
                              id: 'fonteClimaPup',
                            }}
                          >
                            <MenuItem key={0} value={0}>{res.MAIS_PROXIMO}</MenuItem> :
                            {this.state.fonstes.map((item, key) => {
                              return <MenuItem key={key} value={item.id}>
                                {/* <Checkbox checked={this.state.fonteClima.indexOf(item.id) > -1} /> */}
                                {item.name}
                              </MenuItem>;
                            })}
                          </Select>

                          <div><h4 style={styleTitle}>{tools.replaceString(res._VELOCIDADE_VENTO, Units.getSpeedUnit(res)).toUpperCase()}</h4></div>
                          <BarHeat values={[
                            Number(this.state.velocidadeVSet) - this.state.velocidadeVMargemDown.value - this.state.velocidadeVLimiteDown.value,
                            Number(this.state.velocidadeVSet) - this.state.velocidadeVMargemDown.value,
                            null,//Number(this.state.velocidadeVSet),
                            Number(this.state.velocidadeVSet) + this.state.velocidadeVMargemUp.value,
                            Number(this.state.velocidadeVSet) + this.state.velocidadeVMargemUp.value + this.state.velocidadeVLimiteUp.value
                          ]} grayZero={true} />
                          <div>
                            <TextField
                              label={res.TOLERANCIA_VELOCIDADE_VENTO_MIN}
                              value={Math.round(this.state.velocidadeVMargemDown.text * 1000) / 1000}
                              error={!this.state.velocidadeVMargemDown.valid}
                              onChange={(event) => {
                                this.changeSettingsMargemDown(
                                  event.target.value,
                                  'velocidadeVSet',
                                  'velocidadeVMargemDown',
                                  'velocidadeVLimiteDown',
                                  'velocidadeVMargemUp',
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                              style={{ marginRight: '.5rem' }}
                            />
                            <TextField
                              label={res.TOLERANCIA_VELOCIDADE_MAX}
                              value={Math.round(this.state.velocidadeVMargemUp.text * 1000) / 1000}
                              error={!this.state.velocidadeVMargemUp.valid}
                              onChange={(event) => {
                                this.changeSettingsMargemUp(
                                  event.target.value,
                                  'velocidadeVSet',
                                  'velocidadeVMargemUp',
                                  'velocidadeVLimiteUp',
                                  null,
                                  'velocidadeVMargemDown'
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                            />
                          </div>
                          <div>
                            <TextField
                              label={res.LIMITE_VELOCIDADE_MIN}
                              value={Math.round(this.state.velocidadeVLimiteDown.text * 1000) / 1000}
                              error={!this.state.velocidadeVLimiteDown.valid}
                              onChange={(event) => {
                                this.changeSettingsLimitDown(
                                  event.target.value,
                                  'velocidadeVSet',
                                  'velocidadeVMargemDown',
                                  'velocidadeVLimiteDown'
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                              style={{ marginRight: '.5rem' }}
                            />
                            <TextField
                              label={res.LIMITE_VELOCIDADE_MAX}
                              value={Math.round(this.state.velocidadeVLimiteUp.text * 1000) / 1000}
                              error={!this.state.velocidadeVLimiteUp.valid}
                              onChange={(event) => {
                                this.changeSettingsLimitUp(
                                  event.target.value,
                                  'velocidadeVSet',
                                  'velocidadeVMargemUp',
                                  'velocidadeVLimiteUp'
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                            />
                          </div>
                          <div><h4 style={styleTitle}>{res.ANGULO_DESVIO_VENTO_UNI.toUpperCase()}</h4></div>
                          <PlaneHeat type="P" ckey="0" values={[
                            Number(this.state.anguloVLimiteDown.value),
                            Number(this.state.anguloVMargemDown.value),
                            Number(this.state.anguloVSet),
                            this.state.espelharAnguloV ? Number(this.state.anguloVMargemDown.value) : Number(this.state.anguloVMargemUp.value),
                            this.state.espelharAnguloV ? Number(this.state.anguloVLimiteDown.value) : Number(this.state.anguloVLimiteUp.value)
                          ]} limit="90" res={res} />
                          <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', right: 0, top: '-2rem' }}>
                              <span onClick={(ev) => { if (!this.state.tabMenuItens[0].active) this.setState({ espelharAnguloV: !this.state.espelharAnguloV }) }} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                                {res.ESPELHAR}
                              </span>
                              <Checkbox
                                disabled={this.state.tabMenuItens[0].active}
                                checked={this.state.espelharAnguloV}
                                onChange={(ev) => { this.setState({ espelharAnguloV: !this.state.espelharAnguloV }) }}
                              />
                            </div>
                            <TextField
                              label={res.TOLERANCIA_ANGULO_VENTO_MIN}
                              value={Math.round(this.state.anguloVMargemDown.text * 1000) / 1000}
                              error={!this.state.anguloVMargemDown.valid}
                              onChange={(event) => {
                                this.changeSettingsMargemUp(
                                  event.target.value,
                                  'anguloVSet',
                                  'anguloVMargemDown',
                                  'anguloVLimiteDown',
                                  90
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                              style={{ marginRight: '.5rem' }}
                            />
                            <TextField
                              label={res.TOLERANCIA_ANGULO_VENTO_MAX}
                              value={this.state.espelharAnguloV ?
                                Math.round(this.state.anguloVMargemDown.text * 1000) / 1000 :
                                Math.round(this.state.anguloVMargemUp.text * 1000) / 1000}
                              error={!this.state.anguloVMargemUp.valid}
                              onChange={(event) => {
                                this.changeSettingsMargemUp(
                                  event.target.value,
                                  'anguloVSet',
                                  'anguloVMargemUp',
                                  'anguloVLimiteUp',
                                  90
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3 || this.state.espelharAnguloV}
                              type="number"
                            />
                          </div>
                          <div>
                            <TextField
                              label={res.LIMITE_ANGULO_VENTO_MIN}
                              value={Math.round(this.state.anguloVLimiteDown.text * 1000) / 1000}
                              error={!this.state.anguloVLimiteDown.valid}
                              onChange={(event) => {
                                this.changeSettingsLimitUp(
                                  event.target.value,
                                  'anguloVSet',
                                  'anguloVMargemDown',
                                  'anguloVLimiteDown',
                                  90
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                              style={{ marginRight: '.5rem' }}
                            />
                            <TextField
                              label={res.LIMITE_ANGULO_VENTO_MAX}
                              value={this.state.espelharAnguloV ?
                                Math.round(this.state.anguloVLimiteDown.text * 1000) / 1000 :
                                Math.round(this.state.anguloVLimiteUp.text * 1000) / 1000}
                              error={!this.state.anguloVLimiteUp.valid}
                              onChange={(event) => {
                                this.changeSettingsLimitUp(
                                  event.target.value,
                                  'anguloVSet',
                                  'anguloVMargemUp',
                                  'anguloVLimiteUp',
                                  90
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3 || this.state.espelharAnguloV}
                              type="number"
                            />
                          </div>

                          <div><h4 style={styleTitle}>{res.DELTA_T.toUpperCase()}</h4></div>
                          <div style={{ position: 'relative' }}>
                            <div style={{ position: 'absolute', right: 0, top: '-1.6rem' }}>
                              <span onClick={(ev) => { if (!this.state.tabMenuItens[0].active) this.setState({ showDeltat: !this.state.showDeltat }) }} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                                {res.EXIBIR}
                              </span>
                              <Checkbox
                                disabled={this.state.tabMenuItens[0].active}
                                checked={this.state.showDeltat}
                                onChange={(ev) => { this.setState({ showDeltat: !this.state.showDeltat }) }}
                              />
                            </div>
                          </div>
                          {this.state.showDeltat && <div>
                            <DeltaTHeat values={this.state} temperatura_values={[
                              Number(this.state.temperaturaSet) - this.state.temperaturaMargemDown.value - this.state.temperaturaLimiteDown.value,
                              Number(this.state.temperaturaSet) - this.state.temperaturaMargemDown.value,
                              null,//Number(this.state.temperaturaSet),
                              Number(this.state.temperaturaSet) + this.state.temperaturaMargemUp.value,
                              Number(this.state.temperaturaSet) + this.state.temperaturaMargemUp.value + this.state.temperaturaLimiteUp.value
                            ]} humidade_values={[
                              Number(this.state.umidadeSet) - this.state.umidadeMargemDown.value - this.state.umidadeLimiteDown.value,
                              Number(this.state.umidadeSet) - this.state.umidadeMargemDown.value,
                              null,//Number(this.state.umidadeSet),     temperatura='30' humidade='75' atual='1.8'
                              Number(this.state.umidadeSet) + this.state.umidadeMargemUp.value,
                              Number(this.state.umidadeSet) + this.state.umidadeMargemUp.value + this.state.umidadeLimiteUp.value
                            ]} res={res} />
                          </div>}
                          <div><h4 style={styleTitle}>{tools.replaceString(res._TEMPERATURA_UNI, res.C).toUpperCase()}</h4></div>
                          {!this.state.showDeltat && <BarHeat values={[
                            Number(this.state.temperaturaSet) - this.state.temperaturaMargemDown.value - this.state.temperaturaLimiteDown.value,
                            Number(this.state.temperaturaSet) - this.state.temperaturaMargemDown.value,
                            null,//Number(this.state.temperaturaSet),
                            Number(this.state.temperaturaSet) + this.state.temperaturaMargemUp.value,
                            Number(this.state.temperaturaSet) + this.state.temperaturaMargemUp.value + this.state.temperaturaLimiteUp.value
                          ]} />}
                          <div>
                            <TextField
                              label={res.TOLERANCIA_TEMPERATURA_MIN}
                              value={Math.round(this.state.temperaturaMargemDown.text * 1000) / 1000}
                              error={!this.state.temperaturaMargemDown.valid}
                              onChange={(event) => {
                                this.changeSettingsMargemDown(
                                  event.target.value,
                                  'temperaturaSet',
                                  'temperaturaMargemDown',
                                  'temperaturaLimiteDown',
                                  'temperaturaMargemUp',
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                              style={{ marginRight: '.5rem' }}
                            />
                            <TextField
                              label={res.TOLERANCIA_TEMPERATURA_MAX}
                              value={Math.round(this.state.temperaturaMargemUp.text * 1000) / 1000}
                              error={!this.state.temperaturaMargemUp.valid}
                              onChange={(event) => {
                                this.changeSettingsMargemUp(
                                  event.target.value,
                                  'temperaturaSet',
                                  'temperaturaMargemUp',
                                  'temperaturaLimiteUp',
                                  null,
                                  'temperaturaMargemDown',
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                            />
                          </div>
                          <div>
                            <TextField
                              label={res.LIMITE_TEMPERATURA_MIN}
                              value={Math.round(this.state.temperaturaLimiteDown.text * 1000) / 1000}
                              error={!this.state.temperaturaLimiteDown.valid}
                              onChange={(event) => {
                                this.changeSettingsLimitDown(
                                  event.target.value,
                                  'temperaturaSet',
                                  'temperaturaMargemDown',
                                  'temperaturaLimiteDown',
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                              style={{ marginRight: '.5rem' }}
                            />
                            <TextField
                              label={res.LIMITE_TEMPERATURA_MAX}
                              value={Math.round(this.state.temperaturaLimiteUp.text * 1000) / 1000}
                              error={!this.state.temperaturaLimiteUp.valid}
                              onChange={(event) => {
                                this.changeSettingsLimitUp(
                                  event.target.value,
                                  'temperaturaSet',
                                  'temperaturaMargemUp',
                                  'temperaturaLimiteUp'
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                            />
                          </div>

                          <div><h4 style={styleTitle}>{res.HUMIDADE_UNI.toUpperCase()}</h4></div>
                          {!this.state.showDeltat && <BarHeat values={[
                            Number(this.state.umidadeSet) - this.state.umidadeMargemDown.value - this.state.umidadeLimiteDown.value,
                            Number(this.state.umidadeSet) - this.state.umidadeMargemDown.value,
                            null,//Number(this.state.umidadeSet),
                            Number(this.state.umidadeSet) + this.state.umidadeMargemUp.value,
                            Number(this.state.umidadeSet) + this.state.umidadeMargemUp.value + this.state.umidadeLimiteUp.value
                          ]} />}
                          <div>
                            <TextField
                              label={res.TOLERANCIA_HUMIDADE_MIN}
                              value={Math.round(this.state.umidadeMargemDown.text * 1000) / 1000}
                              error={!this.state.umidadeMargemDown.valid}
                              onChange={(event) => {
                                this.changeSettingsMargemDown(
                                  event.target.value,
                                  'umidadeSet',
                                  'umidadeMargemDown',
                                  'umidadeLimiteDown',
                                  'umidadeMargemUp',
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                              style={{ marginRight: '.5rem' }}
                            />
                            <TextField
                              label={res.TOLERANCIA_HUMIDADE_MAX}
                              value={Math.round(this.state.umidadeMargemUp.text * 1000) / 1000}
                              error={!this.state.umidadeMargemUp.valid}
                              onChange={(event) => {
                                this.changeSettingsMargemUp(
                                  event.target.value,
                                  'umidadeSet',
                                  'umidadeMargemUp',
                                  'umidadeLimiteUp',
                                  null,
                                  'umidadeMargemDown',
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                            />
                          </div>
                          <div>
                            <TextField
                              label={res.LIMITE_HUMIDADE_MIN}
                              value={Math.round(this.state.umidadeLimiteDown.text * 1000) / 1000}
                              error={!this.state.umidadeLimiteDown.valid}
                              onChange={(event) => {
                                this.changeSettingsLimitDown(
                                  event.target.value,
                                  'umidadeSet',
                                  'umidadeMargemDown',
                                  'umidadeLimiteDown'
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                              style={{ marginRight: '.5rem' }}
                            />
                            <TextField
                              label={res.LIMITE_HUMIDADE_MAX}
                              value={Math.round(this.state.umidadeLimiteUp.text * 1000) / 1000}
                              error={!this.state.umidadeLimiteUp.valid}
                              onChange={(event) => {
                                this.changeSettingsLimitUp(
                                  event.target.value,
                                  'umidadeSet',
                                  'umidadeMargemUp',
                                  'umidadeLimiteUp'
                                );
                              }}
                              size="small"
                              margin="dense"
                              disabled={this.state.state === 3}
                              type="number"
                            />
                          </div>
                        </div>
                      </div>
                    </Accordion>
                    <div style={{ marginTop: '.5rem', display: 'grid', gridTemplateColumns: '5rem auto 3rem 3rem', gap: '.2rem' }}>
                      <div></div>
                      <h3 style={{ marginTop: '.6rem', width: 'auto', height: '2.3rem', textAlign: 'center' }}>{res.AREAS.toUpperCase()}</h3>
                      <Button component="span" className="buttonS buttonMenu" title={res.LIMPAR} disabled={this.state.state === 3} onClick={event => this.showMapItem('analise')}>
                        <MaterialIcon icon="select_all" className="iconMap" />
                      </Button>
                      <Button component="span" className="buttonS buttonMenu" title={'Reset'} disabled={this.state.state === 3 || this.state.polygons.length === 0 || this.state.polygons === this.polygonsDefault} onClick={() => { this.onCloseEditMap(this.polygonsDefault) }}>
                        <MaterialIcon icon="close" className="iconMap" />
                      </Button>
                    </div>
                    <div id="divAreas">
                      {this.state.polygons.map((item, key) => {
                        return <div key={key} style={{ width: '100%', height: '2rem', textAlign: 'center' }}>{item.name}</div>
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
        <div className="divContent divRelative map-p">
          <div className="containerTop">
            <div className="leftTop">
              <div style={{ marginTop: '-1rem', height: '2.9rem', display: 'flex' }}>
                <Tab value={this.state.tab} handleChange={this.handleChangeTab} name="tab" itens={this.state.tabItens} />
                {this.state.tab === '5' || this.state.tab === '4' ?
                  <div style={{ width: '0.1rem', height: 'calc(100% - 1rem)', backgroundColor: '#0000001f', margin: '1rem 1rem 0.5rem 1rem' }}></div>
                  : null}
                {this.state.tab === '4' ?
                  <Tab value={this.state.tabSubMenuV} handleChange={this.handleChangeTab} name="tabSubMenuV" itens={this.state.tabItensVento} />
                  : this.state.tab === '5' ?
                    <Tab value={this.state.tabSubMenuD} handleChange={this.handleChangeTab} name="tabSubMenuD" itens={this.state.tabItensDeltaT} />
                    : null}
              </div>
            </div>
            <div className="centerTop"></div>
            <div className="rightTop">
              <Button
                size="small"
                className="buttonS buttonMenu"
                onClick={this.toggleCoordMode}
                title={(this.state.coordMode === 'dms') ? res.COORDENADA_DMS : res.COORDENADA_DD}
              >
                <MaterialIcon icon="swap_horiz" className="iconMap" />
              </Button>
              <Button className={this.state.ruler_a ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} onClick={event => this.regua()} title={res.REGUA}>
                <MaterialIcon icon="settings_ethernet" className="iconMap highlightSVG" />
              </Button>
              <Button className="buttonS buttonMenu" disabled={this.state.state !== 3 || !this.state.id_job} onClick={event => this.showMapItem('retoque')} title={res.RETOQUE}>
                <SvgIcon viewBox="79 18 21 26" className="iconMapP" style={this.state.state !== 3 || !this.state.id_job ? { color: '#bdbdbd' } : {}}>
                  <path id="polygon" d="M 95 19 L 88 19 L 88 26 L 95 26 Z M 85 28 L 78 28 L 78 35 L 85 35 Z M 85 19 L 78 19 L 78 26 L 85 26 Z" />
                </SvgIcon>
              </Button>
              <Button className={this.state.showStack ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={this.state.state !== 3} onClick={event => this.setState({ showStack: !this.state.showStack })} title={res.EXIBIR_ESCONDER}>
                <MaterialIcon icon="layers" className="iconMap" />
              </Button>
            </div>
          </div>
          <div className="wrapperMap">
            <div id="mapid"></div>
            {this.state.tabMenu === '1' ?
              <Button
                className="buttonS buttonMenu replay3d-open-button"
                disabled={!this.state.data}
                onClick={this.openReplay3D}
                title="Replay 3D"
                style={{
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  zIndex: 401
                }}
              >
                <MaterialIcon icon="public" className="iconMap" />
              </Button>
              : null}
            {this.state.showReplay3D ?
              <Replay3D
                data={this.state.data}
                polygons={this.state.polygons}
                p={this.p}
                res={res}
                key={this.getReplay3DModelType()}
                modelUrl={this.getReplay3DModelCatalog()}
                defaultModelType={this.getReplay3DModelType()}
                selectedAircraftBrand={this.getPlaneAircraftBrandName(this.getSelectedPlaneFromState())}
                selectedAircraft={this.getSelectedPlaneFromState()}
                climateTimeline={this.state.climateTimeline && this.state.climateTimeline.length ? this.state.climateTimeline : (this.replay3DClimateTimeline || [])}
                climatePeriod={this.state.climatePeriod || this.replay3DClimatePeriod || null}
                allowExternalClimateLookup={replay3DAllowExternalClimateLookup}
                externalClimateLoading={this.state.externalClimateLoading}
                onRequestExternalClimate={this.loadReplay3DExternalClimate}
                onClose={this.closeReplay3D}
              />
              : null}
            <div
              style={{
                position: 'absolute',
                left: '1rem',
                right: '1rem',
                bottom: '1rem',
                zIndex: 401,
                display: this.state.tabMenu === '1' ? 'flex' : 'none',
                alignItems: 'center',
                gap: '.5rem',
                background: 'rgba(255,255,255,.92)',
                borderRadius: '.4rem',
                padding: '.4rem .6rem'
              }}
            >
              <Button className={!this.state.play ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                disabled={this.state.data === null}
                onClick={event => this.play(false)}>
                <MaterialIcon icon="pause" className="iconMap" />
              </Button>

              <Button className={(this.state.play && this.state.sTime === 1) ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                disabled={this.state.data === null}
                onClick={event => { this.setState({ sTime: 1 }); this.play(true); }}>
                <MaterialIcon icon={this.state.end ? "replay" : "play_arrow"} className="iconMap" />
              </Button>

              <Button className={(this.state.play && this.state.sTime === 10) ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                disabled={this.state.data === null || !this.state.play}
                onClick={event => this.setState({ sTime: 10 })}>
                <MaterialIcon icon="fast_forward" className="iconMap" />
              </Button>

              <Button className={(this.state.play && this.state.sTime === 50) ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                disabled={this.state.data === null || !this.state.play}
                onClick={event => this.setState({ sTime: 50 })}>
                <SvgIcon viewBox="2 0 28 24" className="iconArrow">
                  <path d="M 4 18 l 8.5 -6 l -8.5 -6 v 12 z m 9 -12 v 12 l 8.5 -6 l -8.5 -6 Z m 9 0 v 12 l 8.5 -6 l -8.5 -6 Z" />
                </SvgIcon>
              </Button>

              <Button className={(this.state.play && this.state.fastProgress) ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                disabled={this.state.data === null || !this.state.play}
                onClick={event => this.setState({ fastProgress: !this.state.fastProgress })}>
                <SvgIcon viewBox="2 0 28 24" className="iconArrow">
                  <path d="M 13 13 L 13 11 L 4 11 V 13 Z M 13 7 V 17 L 21.5 12 Z M 22 6 V 18 L 24 18 L 24 6 Z" />
                </SvgIcon>
              </Button>

              <div style={{ flex: 1, padding: '0 .5rem' }}>
                <SliderComponent
                  value={this.state.valueBar}
                  min={0}
                  max={1000}
                  step={1}
                  disabled={this.state.data === null || this.state.progress}
                  onChange={this.handleChangeBar}
                  onChangeCommitted={this.handleChangeBarCommit}
                />
              </div>
            </div>
            <div className="zoomB" style={{ display: this.state.tabMenu === '3' ? 'none' : 'block' }}>
              <Button className="buttonS buttonMenu" onClick={event => this.zoomInL()}>
                <MaterialIcon icon="add" className="iconMap" />
              </Button>
              <Button className="buttonS buttonMenu" onClick={event => this.zoomOutL()}>
                <MaterialIcon icon="remove" className="iconMap" />
              </Button>
            </div>
            <div className={this.state.edit || this.state.delete ? "divContent floatDiv floatDivItens" : "sr-only"}>
              <label className="textDiv">
                {res.CLICK_DESFAZER}
              </label>
              <Button size="small" className="popUpButton" onClick={event => this.state.edit ? this.saveEdit() : this.saveDelete()}>
                {res.SALVAR}
              </Button>
              <Button size="small" className="popUpButton" onClick={event => this.state.edit ? this.cancelEdit() : this.cancelDelete()}>
                {res.CANCELAR}
              </Button>
            </div>
            {this.state.goto &&
              <div className="divContent floatW divS" style={{ width: '15rem' }}>
                <div>
                  <span style={{ marginRight: '2rem' }}>{res.IRPARA}</span>
                  <Button size="small" className="popUpButton blButton" onClick={event => this.goto("poly")}>
                    <SvgIcon viewBox="79 18 21 26" className="iconMapP" >
                      <path id="polygon" d="M 100 23.4 L 97 36.9 L 83 39.6 L 76 27 L 86 18 Z" />
                    </SvgIcon>
                  </Button>
                  <Button size="small" className="popUpButton blButton" onClick={event => this.goto("home")}>
                    <MaterialIcon icon="home" className="iconMap" />
                  </Button>
                </div>
                <TextField
                  id="lat"
                  label="LAT"
                  margin="normal"
                  size='small'
                  onChange={this.handleChange('lat')}
                  value={this.state.lat}
                  onKeyDown={e => {
                    if (e.keyCode === 13) { this.goto() }
                  }}
                  onInput={(e) => {
                    e.target.value = isNaN(e.target.value) ? this.state.lat : e.target.value.toString().slice(0, 20).trim()
                  }}
                />
                <TextField
                  id="lng"
                  label="LNG"
                  margin="normal"
                  onChange={this.handleChange('lng')}
                  value={this.state.lng}
                  onKeyDown={e => {
                    if (e.keyCode === 13) { this.goto() }
                  }}
                  onInput={(e) => {
                    e.target.value = isNaN(e.target.value) ? this.state.lng : e.target.value.toString().slice(0, 20).trim()
                  }}
                />
                <div className="divForm">
                  <Button size="small" className="popUpButton" onClick={event => this.goto()}>
                    {res.IR}
                  </Button>
                  <Button size="small" className="popUpButton" onClick={event => this.setState({ goto: false })}>
                    {res.CANCELAR}
                  </Button>
                </div>
              </div>}
            {this.state.showStack &&
              <div className="divContent floatW divS">
                <List
                  component="nav"
                  aria-labelledby="stack"
                >
                  {this.state.listTypes
                    .map((item, key) => (
                      <MenuItem className="popup-item" key={key}>
                        <FormControlLabel
                          style={{ width: '100%' }}
                          control={<Checkbox checked={item.active} onChange={() => { this.setStack(item) }} />}
                          label={item.label}
                        />
                      </MenuItem>
                    ))}
                </List>
              </div>}

            <div className="divContent floatW divI" style={{
              bottom: '0.5rem',
              top: 'auto',
              width: 'calc(100% - 2rem)',
              height: '10rem',
              left: '9rem',
              padding: 'revert',
              paddingLeft: '0.5rem',
              paddingRight: '0.5rem',
              paddingTop: '2rem',
              display: this.state.showChart ? 'block' : 'none'
            }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
                  <Button style={{ height: '.5rem' }} color="primary" onClick={() => { this.selectTiroChart(null, -1) }}>{'<'}</Button>
                  <span style={{ margin: '0 10px' }}>{this.state.barTitle} </span>
                  <Button style={{ height: '.5rem' }} color="primary" onClick={() => { this.selectTiroChart(null, 1) }}>{'>'}</Button>
                </div>

                <div style={{ marginTop: '4px', borderTop: '1px solid rgba(0,0,0,0.25)' }} />

                {(this.state.barInfoFluxo) ? (
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '14px',
                    marginTop: '4px',
                    fontSize: '12px',
                    lineHeight: '16px',
                    fontWeight: 'normal',
                    flexWrap: 'wrap'
                  }}>
                    <div><b>{this.props.res.FLUXO}:</b> {tools.round(this.state.barInfoFluxo.fluxoSet, 2)}</div>
                    <div><b>{this.props.res.FLUXO_MEDIO}:</b> {tools.round(this.state.barInfoFluxo.fluxoMedio, 2)}</div>
                  </div>
                ) : null}
              </div>

              <div style={{ position: 'absolute', top: 0, right: '1rem', zIndex: 11 }}>
                <Button style={{ height: '.5rem' }} color="primary" onClick={() => { this.barChart.resetZoom() }}>{res.RESET}</Button>
              </div>

              <div style={{ width: '100%', height: '100%', display: (this.state.tab === '4' && this.state.tabSubMenuV === '1') ? 'flex' : 'solid' }}>
                {(this.state.tab === '4' && this.state.tabSubMenuV === '1') ?
                  <div style={{
                    width: '7rem', height: '7rem', position: 'absolute',
                    margin: '-1rem 0px 0px 1rem',
                    transform: `rotate(${this.state.angulo_wind}deg)`,
                    transformOrigin: '50% 50%',
                    transition: 'all 0.5s ease 0s'
                  }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '7rem',
                      height: '7rem',
                      backgroundImage: 'linear-gradient(#6daaee, #6daaee73, #0000ff00)',
                      borderRadius: '3.5rem',
                    }}>
                      <div style={{
                        position: 'absolute',
                        top: '-.3rem',
                        left: '3rem',
                        width: '1rem',
                        height: '1rem',
                        backgroundColor: '#6daaee',
                        transform: 'rotate(45deg)'
                      }}></div>
                      <div style={{
                        width: '6rem',
                        height: '6rem',
                        backgroundColor: 'white',
                        borderRadius: '3rem',
                      }}></div>
                    </div>
                  </div> : null}

                {(this.state.tab === '4' && this.state.tabSubMenuV === '1') ?
                  <div style={{
                    height: '10.7rem',
                    width: '10.5rem',
                    scale: '.7',
                    marginTop: '-3.2em',
                    marginLeft: '-0.75rem',
                    transform: `rotate(${this.state.angulo_plane}deg)`,
                    transformOrigin: '50% 50%',
                    transition: 'all 0.5s ease 0s'
                  }}>
                    <PlaneHeat type="G" ckey="1" values={[
                      Number(this.state.anguloVLimiteDown.value),
                      Number(this.state.anguloVMargemDown.value),
                      Number(this.state.anguloVSet),
                      this.state.espelharAnguloV ? Number(this.state.anguloVMargemDown.value) : Number(this.state.anguloVMargemUp.value),
                      this.state.espelharAnguloV ? Number(this.state.anguloVLimiteDown.value) : Number(this.state.anguloVLimiteUp.value)
                    ]} limit="90" res={res} />
                  </div> : null}

                <div style={{ width: (this.state.tab === '4' && this.state.tabSubMenuV === '1') ? 'calc(100% - 11rem)' : 'auto', height: 'calc(100% + 1rem)', marginTop: '0.5rem' }}>
                  <canvas id="barChart"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          open={this.state.modalOpen}
          onClose={() => this.setState({ modalOpen: false })}
          maxWidth="md"
          fullWidth
          PaperProps={{
            style: {
              backgroundColor: 'white',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
              borderRadius: '8px',
            }
          }}
          BackdropProps={{
            style: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            }
          }}
        >
          <DialogTitle style={{ backgroundColor: 'white' }}>{res.CONFIGURACOES_RELATORIO}</DialogTitle>

          <DialogContent style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column' }}>
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  checked={this.state.checkMapa}
                  onChange={() => this.setState({ checkMapa: !this.state.checkMapa })}
                />
              }
              label={res.MAPA_FUNDO}
            />
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  checked={this.state.checkResumo}
                  name="checkResumo"
                  onChange={() => this.setState({ checkResumo: !this.state.checkResumo })}
                />
              }
              label={res.RELATORIO_RESUMIDO}
            />

            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  checked={this.state.checkDetailFluxo}
                  name="checkDetailFluxo"
                  onChange={() => this.setState({ checkDetailFluxo: !this.state.checkDetailFluxo })}
                />
              }
              label={res.RELATORIO_DETAIL_FLUXO}
            />

            <div>
              <DialogTitle id="customized-dialog-title">{res.ANALISE_QUALIDADE}</DialogTitle>

              <DialogContent>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoCobertura}
                        onChange={() => this.setState({ checkResumoCobertura: !this.state.checkResumoCobertura })}
                      />
                    }
                    label={res.COBERTURA}
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoAltura}
                        onChange={() => this.setState({ checkResumoAltura: !this.state.checkResumoAltura })}
                      // disabled={!this.state.tabItens[1].active}
                      />
                    }
                    label={res.ALTURA}
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoFluxo}
                        onChange={() => this.setState({ checkResumoFluxo: !this.state.checkResumoFluxo })}
                      // disabled={!this.state.tabItens[2].active}
                      />
                    }
                    label={res.FLUXO}
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoVelocidade}
                        onChange={() => this.setState({ checkResumoVelocidade: !this.state.checkResumoVelocidade })}
                      // disabled={!this.state.tabItens[3].active}
                      />
                    }
                    label={res.VELOCIDADE}
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoVelocidadeVento}
                        onChange={() => this.setState({ checkResumoVelocidadeVento: !this.state.checkResumoVelocidadeVento })}
                      // disabled={!this.state.tabItensVento[0].active}
                      />
                    }
                    label={res.VELOCIDADE_VENTO}
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoAnguloVento}
                        onChange={() => this.setState({ checkResumoAnguloVento: !this.state.checkResumoAnguloVento })}
                      // disabled={!this.state.tabItensVento[1].active}
                      />
                    }
                    label={res.ANGULO_DESVIO_VENTO}
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoTemperatura}
                        onChange={() => this.setState({ checkResumoTemperatura: !this.state.checkResumoTemperatura })}
                      // disabled={!this.state.tabItensDeltaT[1].active}
                      />
                    }
                    label={res.TEMPERATURA}
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoUmidade}
                        onChange={() => this.setState({ checkResumoUmidade: !this.state.checkResumoUmidade })}
                      // disabled={!this.state.tabItensDeltaT[2].active}
                      />
                    }
                    label={res.UMIDADE}
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoDeltat}
                        onChange={() => this.setState({ checkResumoDeltat: !this.state.checkResumoDeltat })}
                      // disabled={!this.state.tabItensDeltaT[0].active}
                      />
                    }
                    label={res.DELTA_T}
                  />
                </div>
              </DialogContent>
            </div>
          </DialogContent>

          <DialogActions style={{ display: 'flex', justifyContent: 'space-evenly', backgroundColor: 'white' }}>
            <Button disabled={this.state.disabledPorcessJob} id='prcessJob' component="span" variant="contained" color="primary" style={{ marginRight: '.4rem' }} className="popUpButton" title={res.BAIXAR_RELATORIO} onClick={() => { this.setState({ modalOpen: false }, () => this.downloadRel()) }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" class="bi bi-file-earmark-arrow-down-fill" viewBox="-4 -4 24 24">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
              </svg>
            </Button>
            <Button
              variant="contained"
              onClick={event => this.setState({ modalOpen: false })}
            >
              {res.CANCELAR}
            </Button>
          </DialogActions>
        </Dialog>
      </div >
    );
  };
}


const TextFields1 = Edit;

const Box = (props) => {
  const { link, res, profile } = props;
  let { guid } = useParams();
  return (
    <div className="rowPMap maxHMap">
      <TextFields1 link={link} guid={guid} res={res} profile={profile} />
    </div>)
}
export default Box;
